{
  "material.outdated.title": "Dieses Material wurde aktualisiert",
  "material.outdated.description": "Bitte kopiere deine noch nicht abgegebenen Antworten und lade anschließend die Seite im Browser neu, um weiterzuarbeiten.",
  "material.autosave.saved": "Gespeichert",
  "material.autosave.description": "Änderungen werden automatisch gespeichert.",
  "material.autosave.saving": "Wird gespeichert …",
  "material.autosave.failed": "Nicht gespeichert",
  "ai.assistant.sharing.title": "Material freigeben",
  "ai.assistant.sharing.recipients": "Freigeben für",
  "ai.assistant.sharing.hide.title": "Material ausblenden",
  "ai.assistant.sharing.hide.recipients": "Ausblenden für",
  "ai.assistant.sharing.hide.confirm": "Ausblenden",
  "ai.assistant.sharing.hide.confirmed": "Ausgeblendet",
  "ai.assistant.sharing.all_students": "Alle Schüler:innen dieses Kurses",
  "ai.assistant.sharing.pending": "Die Sichtbarkeit dieser Materialien wird erst mit deiner Bestätigung geändert.",
  "ai.assistant.sharing.confirmed": "Freigegeben",
  "ai.assistant.sharing.discarded": "Änderung verworfen",
  "ai.assistant.sharing.error": "Die Sichtbarkeit konnte nicht aktualisiert werden. Bitte versuche es erneut.",
  "ai.assistant.composer.attachment_size_limit": "Dateien dürfen höchstens {{size}} MiB groß sein. Bitte wähle eine kleinere Datei.",
  "course_students.access_cards.login_instruction": "Öffne {{url}} und gib deinen Code ein.",
  "course_students.access_cards.course_scope_hint": "Mit diesen Codes erhalten die Schüler:innen Zugang zu allen freigegebenen Materialien im Kurs „{{courseName}}“.",
  "ai.assistant.student_note.loading": "Dokumentation wird geladen …",
  "ai.assistant.student_note.discarded": "Dieser Dokumentationsentwurf wurde verworfen oder ist nicht mehr verfügbar.",
  "ai.assistant.student_note.student": "Schüler:in",
  "ai.assistant.student_note.edit": "Dokumentation oder Schüler:in ändern",
  "ai.assistant.student_note.discard": "Entwurf verwerfen",
  "ai.assistant.student_note.open_student": "Schüler:in öffnen",
  "ai.assistant.student_note.error": "Die Dokumentation konnte nicht geladen oder aktualisiert werden. Bitte versuche es erneut.",
  "ai.assistant.student_note.retry": "Erneut versuchen",
  "ai.assistant.student_privacy.protected": "Geschützt",
  "ai.assistant.student_privacy.hint": "Der Name wird automatisch durch ein zufälliges Pseudonym ersetzt",
  "auth.signup_v2.continue_with_provider": "Weiter mit {{provider}}",
  "auth.signup_v2.marketing_title": "Die Unterrichtsplattform,\ndie mitdenkt.",
  "auth.signup_v2.marketing_description": "Planung, Material, Aufgaben und Dokumentation an einem Ort – verbunden durch eine KI-Assistenz, die mitarbeitet und Ideen umsetzt.",
  "auth.signup_v2.start_free": "Kostenlos starten",
  "integration.google.description": "Melde Dich mit Deinem Google-Konto bei Teachino an.",
  "integration.authenticate_google.description": "Melde Dich mit Deinem Google-Konto bei Teachino an.",
  "onboarding.iam_banner.title": "Aktiviere deine kostenlose Teachino-Lizenz",
  "onboarding.iam_banner.description": "Melde dich jetzt mit deinem IAM-Konto (CGIE) an, um deine kostenlose Lizenz zu aktivieren.",
  "onboarding.iam_banner.connect": "Mit IAM anmelden",
  "onboarding.webuntis_banner.title": "Verbinde WebUntis, um Kurse, Schüler:innen und Stundenplan zu importieren",
  "onboarding.webuntis_banner.step_open": "Öffne WebUntis in einem neuen Tab, melde dich an und wähle „Teachino“ in der Hauptnavigation. Falls der Menüpunkt fehlt, bitte deine Administration, ihn freizuschalten.",
  "onboarding.webuntis_banner.step_connect": "Bestätige die Verbindung mit deinem Teachino-Konto.",
  "onboarding.webuntis_banner.step_ready": "Anschließend findest du hier deine Kurse, deinen Stundenplan und deine Schüler:innen aus WebUntis.",
  "onboarding.webuntis_banner.tutorial": "Vollständige Anleitung ansehen",
  "onboarding.webuntis_banner.dismiss": "Ausblenden",
  "integration.authenticate_eduplaces.description": "Melde Dich mit Eduplaces bei Teachino an und übernimm freigegebene Gruppen und Schüler:innen in Deine Kurse.",
  "integration.eduplaces.description": "Verbinde Teachino mit Eduplaces, um Dich per Single Sign-on anzumelden und Kurse sowie Schüler:innen zu importieren.",
  "info": "Info",
  "error": "Fehler",
  "success": "Änderungen gespeichert",
  "generic_created_at": "Erstellt am {{date}}",
  "generic_error": "Ein Fehler ist aufgetreten. Bitte probiere es erneut",
  "generic_name": "Name",
  "generic_error_network": "Etwas ist schiefgelaufen. Bitte überprüfe Deine Internetverbindung und probiere es erneut.",
  "generic_slogan": "Jahresplanung. Wochenplanung. Materialien.\nEine App. Einfach und übersichtlich.",
  "generic_back": "Zurück",
  "generic_confirm": "Bestätigen",
  "generic_and": "und",
  "generic_save": "Speichern",
  "generic_cancel": "Abbrechen",
  "generic_retry": "Erneut versuchen",
  "generic_delete": "Löschen",
  "generic_edit": "Bearbeiten",
  "generic_done": "Fertig",
  "generic_topic": "Ordner",
  "generic_topics": "Ordner",
  "generic_folder": "Ordner",
  "generic_folders": "Ordner",
  "generic_sub_folder": "Unterordner",
  "generic_sub_folders": "Unterordner",
  "generic_item": "Material",
  "generic_material": "Material",
  "generic_materials": "Materialien",
  "generic_file_name": "Dateiname",
  "generic_file_description": "Beschreibung der Datei",
  "generic_items": "Materialien",
  "generic_title": "Titel",
  "generic_continue": "Weiter",
  "generic_loading": "Wird geladen …",
  "generic.copy_link": "Link kopieren",
  "generic_copy": "Kopieren",
  "generic_add": "Hinzufügen",
  "generic_next": "Weiter",
  "generic_close": "Schließen",
  "generic_course": "Kurs",
  "generic_courses": "Kurse",
  "generic_template": "Sammlung",
  "generic_duplicate": "Kopieren",
  "generic_move": "Verschieben",
  "generic_preview": "Vorschau",
  "generic_form_error_required": "Feld ist erforderlich",
  "homepage_title": "Startseite",
  "generic_first_name": "Vorname",
  "generic_first_name_placeholder": "Maria",
  "generic_last_name": "Nachname",
  "generic_last_name_placeholder": "Huber",
  "generic_email": "E-Mail-Adresse",
  "generic_email_placeholder": "meine@email.de",
  "generic_schoolyear": "Schuljahr",
  "generic_subject": "Fach",
  "generic_class": "Klasse",
  "generic_clear_date": "Kein Datum",
  "generic_duration": "Dauer",
  "generic_duration_in_minutes": "Dauer (in Minuten)",
  "generic_vacation": "Ferien",
  "generic_choose": "Wählen",
  "generic_search": "Suchen",
  "generic_options": "Optionen",
  "generic_new_badge": "Neu!",
  "generic_empty_state": "Keine Daten gefunden",
  "generic_substitution": "Vertretung",
  "generic_archived": "Gelöscht",
  "generic_text_copied_to_clipboard": "Text in Zwischenablage kopiert",
  "generic_link_copied_to_clipboard": "Link in Zwischenablage kopiert",
  "generic_select_placeholder": "Wähle eine Option …",
  "generic_upgrade": "Upgrade",
  "generic_class_level": "Schulstufe",
  "generic_form_error.not_a_number": "Bitte gib eine Zahl ein",
  "generic_add_image": "Bild hinzufügen",
  "generic_error_url_invalid": "Ungültige URL",
  "generic_sus_long": "Schüler:innen",
  "generic_n_years": "{{years}} Jahre",
  "generic_create": "Erstellen",
  "generic_beta": "Beta",
  "pro_feature_badge.tooltip": "Funktion in Testphase oder mit bezahlter Lizenz verfügbar",
  "generic_optional": "(optional)",
  "generic_sus_short": "SuS",
  "generic_form_error.max_line_length": "Zeile zu lang (max. {{maxLength}} Zeichen): \"{{line}}\"",
  "generic_drop_files_here": "Datei hier ablegen",
  "teachino_ai": "Teachino KI",
  "navigation.timetable": "Stundenplan",
  "navigation.agenda": "Agenda",
  "navigation.timetable_week": "Stundenplan",
  "navigation.timetable_list": "Liste",
  "navigation.library": "Materialien",
  "navigation.help": "Hilfe & Feedback",
  "navigation.profile": "Profil",
  "navigation.profile_settings": "Profil-Einstellungen",
  "navigation.profile.trial_days_left": "Noch {{days}} Tage testen",
  "navigation.profile.grace_days_left": "Noch {{days}} Tage testen",
  "navigation.log_out": "Abmelden",
  "navigation.imprint": "Impressum",
  "navigation.terms": "Nutzungsbedingungen",
  "navigation.privacy": "Datenschutzerklärung",
  "navigation.courses": "Kurse",
  "navigation.status": "Server-Status",
  "navigation.licenses": "Lizenz & Upgrade",
  "navigation.ai": "KI",
  "navigation.new_course": "Neuer Kurs",
  "navigation.help_and_support": "Hilfe & Support",
  "navigation.feedback": "Feedback",
  "auth_password": "Passwort",
  "auth_button_login": "Anmelden",
  "auth_forgot_password": "Passwort vergessen?",
  "auth_signup_tos": "Nutzungsbedingungen",
  "auth_verify_title": "E-Mail-Adresse bestätigen",
  "auth_verify_description_1": "Bitte gib den Code ein, den wir soeben an ",
  "auth_verify_description_2": " gesendet haben.",
  "auth_verify_typo": "Tippfehler?",
  "auth_verify_spam": "Code nicht erhalten? Bitte kontrolliere Deinen Spam-Ordner.",
  "auth_verify_resend": "E-Mail erneut senden",
  "auth_verify_resend_change": "E-Mail-Adresse ändern",
  "auth_verify_resend_save": "E-Mail-Adresse speichern",
  "auth_verify_change_error_duplicate": "Diese E-Mail-Adresse ist bereits bei Teachino registriert.",
  "auth_verify_change_login": "Mit Passwort anmelden",
  "auth_verify_code_error": "Dieser Code ist ungültig oder abgelaufen.",
  "auth_verify_code_empty": "Bitte gib den Code ein, den Du per E-Mail erhalten hast.",
  "auth_verify_code_error_expired": "Dieser Code ist nicht mehr gültig.",
  "auth_verify_code_request_new_code": "Neuen Code anfordern",
  "auth_verify_limit_exceeded": "In den letzten Minuten wurden sehr viele E-Mails angefordert. Bitte warte einen Moment, bevor Du weitere E-Mails anforderst.",
  "auth_verify_resend_success": "Eine neue E-Mail wurde an Dich gesendet.",
  "auth_new_password": "Wähle ein Passwort",
  "auth_password_requirement_letter": "ein Buchstabe",
  "auth_password_requirement_number": "eine Zahl",
  "auth_password_requirement_length": "{{number}} Zeichen",
  "auth_reset_code_title": "Falls {{email}} bei Teachino registriert ist, haben wir Dir einen Code zum Zurücksetzen des Passwortes gesandt.",
  "auth_reset_password_title": "Gib Deine E-Mail-Adresse ein, um Dein Passwort zurückzusetzen.",
  "auth_reset_password_button": "Passwort zurücksetzen",
  "auth_reset_password_new_password": "Bitte wähle ein neues Passwort.",
  "auth_reset_password_code": "Bestätigungscode",
  "auth_login.title": "Willkommen zurück!",
  "auth.signup_v2.page_title": "Mit Teachino fortfahren",
  "auth.signup_v2.trust_privacy": "Datenschutzkonform",
  "auth.signup_v2.trust_ph_salzburg": "Entwickelt mit der PH Salzburg",
  "auth.signup_v2.role_label": "Rolle",
  "auth.signup_v2.teacher_section": "Ich bin Lehrkraft",
  "auth.signup_v2.student_section": "Ich bin Schüler:in",
  "auth.signup_v2.signup_title": "Kostenloses Konto erstellen",
  "auth.signup_v2.signup_description": "Für {{email}} gibt es noch kein Teachino-Konto. Gib Deinen Namen ein und wähle ein Passwort.",
  "auth_login.send_login_link_instead": "Stattdessen Login-Link senden",
  "auth_login.password_required": "Bitte gib Dein Passwort ein.",
  "auth_login.wrong_password": "Das Passwort ist nicht richtig. Versuche es noch einmal oder lass Dir stattdessen einen Login-Link senden.",
  "auth.signup_v2.invalid_email": "Bitte gib eine gültige E-Mail-Adresse ein.",
  "auth.signup_v2.name_required": "Bitte gib Deinen Vor- und Nachnamen ein.",
  "auth.signup_v2.password_invalid": "Bitte wähle ein Passwort, das alle Anforderungen erfüllt.",
  "auth.signup_v2.show_password": "Passwort anzeigen",
  "auth.signup_v2.hide_password": "Passwort verbergen",
  "auth.signup_v2.code_password_hint": "Bitte gib zur Sicherheit Dein Passwort noch einmal ein.",
  "auth.signup_v2.newsletter_opt_in": "Ich möchte Infos zu neuen Funktionen und Tipps per E-Mail erhalten",
  "auth.signup_v2.luxembourg_title": "Du kommst aus Luxemburg?",
  "auth.signup_v2.luxembourg_body": "Teachino ist kostenlos für Dich. Melde Dich mit IAM an, um die Lizenz zu aktivieren.",
  "auth.signup_v2.luxembourg_iam_login": "Mit IAM anmelden",
  "auth.signup_v2.luxembourg_without_iam": "Ohne IAM fortfahren",
  "auth.signup_v2.request_error": "Der Code konnte nicht gesendet werden. Bitte versuche es später erneut.",
  "auth.signup_v2.or_continue_with": "oder melde Dich über ein Portal an",
  "auth.signup_v2.choose_page_title": "Teachino ausprobieren",
  "auth.signup_v2.intent_title": "Was möchtest Du mit Teachino machen?",
  "auth.signup_v2.intent_description": "Wähle alles aus, was Dich interessiert.",
  "auth.signup_v2.intent_option_record_grades": "Noten dokumentieren",
  "auth.signup_v2.intent_option_record_participation": "Mitarbeit dokumentieren",
  "auth.signup_v2.intent_option_plan_lessons": "Einzelne Stunden planen",
  "auth.signup_v2.intent_option_plan_school_year": "Jahresplanung",
  "auth.signup_v2.intent_option_organize_materials": "Material organisieren",
  "auth.signup_v2.intent_option_create_materials": "Material erstellen",
  "auth.signup_v2.intent_option_use_ai_with_students": "KI mit Schüler:innen nutzen",
  "auth.signup_v2.intent_option_share_with_colleagues": "Material mit Kolleg:innen teilen",
  "auth.signup_v2.intent_skip": "Überspringen",
  "auth.signup_v2.legal_prefix": "Mit der ersten Anmeldung akzeptierst Du unsere",
  "auth.signup_v2.code_page_title": "Anmeldecode eingeben",
  "auth.signup_v2.code_title": "Prüfe Deine E-Mails",
  "auth.signup_v2.code_description": "Wir haben einen sechsstelligen Code an {{email}} gesendet.",
  "auth.signup_v2.code_description_generic": "Wir haben Dir einen sechsstelligen Code per E-Mail gesendet.",
  "auth.signup_v2.code_label": "Bestätigungscode",
  "auth.signup_v2.code_error_invalid": "Dieser Code ist ungültig. Bitte überprüfe Deine Eingabe.",
  "auth.signup_v2.code_error_expired": "Dieser Code ist abgelaufen. Bitte fordere einen neuen Code an.",
  "auth.signup_v2.code_error_network": "Der Code konnte nicht geprüft werden. Bitte versuche es erneut.",
  "profile.general.title": "Persönliche Daten aktualisieren",
  "profile.email-subscription.title": "E-Mail-Benachrichtigungen",
  "profile.email-subscription.success_message": "Einstellungen gespeichert",
  "profile.email.title": "E-Mail-Adresse aktualisieren",
  "profile.password.title": "Passwort aktualisieren",
  "profile.password.old_password": "Aktuelles Passwort",
  "profile.password.new_password": "Neues Passwort",
  "profile.password.new_password_2": "Neues Passwort bestätigen",
  "profile.password.wrong_title": "Falsches Passwort",
  "profile.password.wrong_description": "Bitte überprüfe das aktuelle Passwort. Das neue Passwort wurde nicht gespeichert.",
  "profile.password.success_title": "Passwort geändert",
  "profile.password.success_description": "Du kannst Dich nun mit Deinem neuen Passwort anmelden.",
  "auth_login.pending_integration_hint": "Melde Dich einmal mit E-Mail-Adresse und Passwort an. Danach kannst Du {{displayName}} mit Deinem Teachino-Konto verknüpfen, und beim nächsten Mal reicht die Anmeldung über {{displayName}}.",
  "auth_login.code.sent_to": "Wir haben einen Anmeldecode an {{email}} gesendet. Gib ihn hier ein oder klicke auf den Link in der E-Mail.",
  "auth_login.code.sent_generic": "Gib den Anmeldecode aus Deiner E-Mail ein.",
  "profile.password.by_code_hint": "Du hast Dich ohne Passwort registriert oder Dein aktuelles Passwort vergessen? Lege ein neues Passwort mit einem Code fest, den wir Dir per E-Mail senden.",
  "profile.password.by_code_request": "Code per E-Mail senden",
  "profile.password.by_code_sent": "Wir haben einen Code an {{email}} gesendet.",
  "profile.password.by_code_save": "Passwort speichern",
  "profile.data.success_title": "Daten gespeichert",
  "profile.data.success_description": "Deine persönlichen Daten wurden gespeichert.",
  "profile.language": "Sprache",
  "profile.curriculum.title": "Land und Schulprofil",
  "profile.curriculum.description": "Diese Einstellungen werden genutzt, um Fächer, Klassenstufen und KI-Ergebnisse anzupassen.",
  "profile.curriculum.success_title": "Profil aktualisiert",
  "profile.curriculum.success_description": "Land, Region und Schulart wurden gespeichert.",
  "profile.export_library_action": "Export starten",
  "profile.export_library": "Materialien exportieren und herunterladen",
  "profile.export_library_description": "Mit dieser Funktion kannst Du alle Materialien exportieren und auf Deinen Computer herunterladen.",
  "profile.export_library_tech_details": "Bei großen Datenmengen kann dieser Export einige Minuten oder Stunden dauern. Sobald der Export zum Download bereitsteht, erhältst Du eine E-Mail. Der Export kann nur einmal alle 12 Stunden gestartet werden.",
  "profile.export_library_success": "Export gestartet! Sobald Deine Daten zum Download bereitstehen, bekommst Du eine E-Mail.",
  "profile.delete_account.title": "Konto löschen",
  "profile.delete_account.description": "Lösche Dein Teachino-Konto dauerhaft. Alle Integrationen werden getrennt und Deine Kontodaten können nicht wiederhergestellt werden.",
  "profile.delete_account.action": "Konto löschen",
  "profile.delete_account.confirm_title": "Dein Konto löschen?",
  "profile.delete_account.confirm_description": "Diese Aktion kann nicht rückgängig gemacht werden. Deine Integrationen werden getrennt, Du wirst abgemeldet und erhältst eine Bestätigung per E-Mail.",
  "profile.delete_account.confirm_pro_license": "Deine individuelle Pro-Lizenz wird beim Löschen Deines Kontos ebenfalls gekündigt.",
  "profile.delete_account.confirm_instruction": "Gib zur Bestätigung die unten angezeigte E-Mail-Adresse ein.",
  "profile.delete_account.email_mismatch": "Die E-Mail-Adresse stimmt nicht überein.",
  "profile.delete_account.reason_question": "Warum löschst Du Dein Konto?",
  "profile.delete_account.reason_hint": "Deine Antwort ist freiwillig und hilft uns, Teachino zu verbessern.",
  "profile.delete_account.reason.too_expensive": "Teachino ist mir zu teuer",
  "profile.delete_account.reason.missing_feature": "Mir fehlt eine Funktion",
  "profile.delete_account.reason.too_complicated": "Teachino ist mir zu kompliziert",
  "profile.delete_account.reason.no_time_or_not_needed": "Ich habe keine Zeit dafür oder brauche es nicht",
  "profile.delete_account.reason.switched_to_other_tool": "Ich nutze jetzt ein anderes Tool",
  "profile.delete_account.reason.privacy_concerns": "Ich habe Datenschutzbedenken",
  "profile.delete_account.reason.duplicate_account": "Ich habe bereits ein anderes Teachino-Konto",
  "profile.delete_account.reason.other": "Sonstiges",
  "profile.delete_account.reason_text_label": "Möchtest Du uns noch etwas mitteilen?",
  "profile.delete_account.reason_text_placeholder": "Dein Feedback (optional)",
  "profile.checklist.show": "Tipps auf der Startseite wieder anzeigen",
  "profile.checklist.success": "Die Checkliste wird wieder auf der Startseite angezeigt",
  "course_name": "Name",
  "course_short_name": "Kurzname",
  "course_create_title": "Neuen Kurs erstellen",
  "course_create_success_title": "{{name}} erstellt!",
  "course_create_color": "Farbe wählen",
  "course_create_char_limit_error": "Der Kursname darf {{limit}} Zeichen nicht überschreiten",
  "course_create_short_name_char_limit_error": "Kurzname darf nicht mehr als {{limit}} Zeichen haben",
  "course_create_name_required": "Bitte gib einen Kursnamen ein.",
  "course.plan": "Planung",
  "course.page.title": "Deine Kurse",
  "course.page.description": "Erstelle einen Kurs für jede Klasse und jedes Fach, die Du unterrichtest. Zum Beispiel: \"8A Geographie\".",
  "library.generic_materials": "Allgemeine Materialien",
  "library.generic_materials.description": "Alle Materialien, die keinem Ordner zugeordnet wurden",
  "library.topics.description.title": "Organisiere Materialien in Ordnern, um einen besseren Überblick zu erhalten.",
  "library.topics.description.description_1": "Öffne dazu ein Material und wähle unter Details den passenden Ordner aus.",
  "library.topics.description.description_2": "Ordner entsprechen den Abschnitten des Schuljahres, z. B. einem größeren Thema oder Kapitel.",
  "library.create_course.title_course": "Neuen Kurs erstellen",
  "library.create_course.title_template": "Neue Sammlung erstellen",
  "library.create_course.title_from_template": "Kurs aus Sammlung erstellen",
  "library.create_course.placeholder_name_course": "z. B. 1A Mathematik",
  "library.create_course.placeholder_short_name_course": "z. B. 1AM",
  "library.create_course.placeholder_name_template": "Geographie Fachschaft Jahrgang 1",
  "library.create_course.button_course": "Kurs erstellen",
  "library.create_course.button_template": "Sammlung erstellen",
  "library.new_items.empty_state.description": "Lade bestehende Materialien hoch oder erstelle neue direkt in Teachino.",
  "library.items_selected_1": "1 Material",
  "library.items_selected_many": "{{number}} Materialien",
  "library.topics_selected_1": "1 Ordner",
  "library.topics_selected_many": "{{number}} Ordner",
  "library.new_items.empty_state.cta": "Material erstellen",
  "library.all_topics.empty_state.title": "Noch keine Ordner erstellt.",
  "library.all_topics.empty_state.description": "Deine Materialien werden in Teachino in Ordnern organisiert. Sobald Du einen Ordner erstellst, scheint dieser hier auf und kann in jedem Schuljahr und in jeder Parallelklasse wiederverwendet werden.",
  "library.all_topics.empty_state.cta": "Ordner erstellen",
  "library.search.all_topics.no_results": "Die Suche nach \"{{search}}\" hat leider keine passenden Ergebnisse geliefert",
  "library.my_topics": "Alle Ordner",
  "library.unsorted_topics": "Unsortierte Ordner",
  "library.unsorted_topics.empty_state.title": "Saubere Leistung! 🧹🧽",
  "library.unsorted_topics.empty_state.description_0": "Du hast keine unsortierten Ordner.",
  "library.unsorted_topics.empty_state.description_1": "Wir lieben Ordnung und Du offensichtlich auch!",
  "library.topic_details.no_courses": "Dieser Ordner ist noch keinem Kurs zugewiesen.",
  "library.topic.cannot_bulk_delete.title": "Kapitel konnten nicht gelöscht werden",
  "library.topic.cannot_bulk_delete.description": "Der Ordner \"{{topic}}\" kann nicht gelöscht werden.",
  "library.topic.cannot_bulk_duplicate.title": "Kapitel konnten nicht dupliziert werden",
  "library.topic.cannot_bulk_duplicate.description": "Der Ordner \"{{topic}}\" kann nicht dupliziert werden.",
  "library.sort.default": "Eigene Sortierung",
  "library.sort.created": "Nach Erstelldatum",
  "library.sort.date": "Nach Datum",
  "library.sort.alphabetically": "Alphabetisch",
  "course_settings.all_settings": "Alle Einstellungen",
  "course_settings.tabs.general.title": "Allgemeine Einstellungen",
  "course_settings.tabs.general.description": "Name, Darstellung und Zusammenarbeit",
  "course_settings.tabs.ai.title": "KI-Einstellungen",
  "course_settings.tabs.ai.description": "Schultyp, Klassenstufe, Fach und zusätzliche KI-Anweisungen",
  "course_settings.tabs.students.description": "Schüler:innen, Zugangscodes und Lerngruppen",
  "course_settings.tabs.students.section_description": "Schüler:innen und ihre Zugangscodes verwalten",
  "course_settings.details.title": "Details",
  "course_settings.details.sub_title": "Name, Kurzname, Farbe, Schuljahr",
  "course_settings.close_title": "Kurs löschen",
  "course_settings.close_description": "Der Kurs wird nicht mehr zum Planen angezeigt. Auf Materialien kann weiterhin über den Menüpunkt \"Gelöschte Kurse\" zugegriffen werden.",
  "course_settings.close_warning": "\"{{courseName}}\" löschen?",
  "course_settings.close_button": "Kurs löschen",
  "course_settings.close.success_title": "Kurs gelöscht",
  "course_settings.close.success_description": "Der Kurs \"{{courseName}}\" wurde gelöscht.",
  "course_settings.collaboration.title": "Zusammenarbeiten",
  "course_settings.collaboration.sub_title": "Mit anderen Lehrer:innen zusammenarbeiten",
  "course_settings.collaboration.description_1": "Zusammen macht Unterrichten mehr Spaß! Lade Deine Kolleg:innen ein, um Materialien auszutauschen und Unterricht gemeinsam zu planen!",
  "course_settings.collaboration.invite.title": "Kolleg:innen zu {{courseName}} einladen",
  "course_settings.collaboration.invite.cta": "Kolleg:innen einladen",
  "course_settings.collaboration.invite.description": "Wähle die Berechtigungen, die Deine Kolleg:in erhalten soll.",
  "course_settings.collaboration.invite.access.read_only": "Nur lesen",
  "course_settings.collaboration.invite.access.read_only_description": "Kann den Kurs ansehen und Materialien kopieren, aber nicht bearbeiten.",
  "course_settings.collaboration.invite.access.write": "Bearbeiten",
  "course_settings.collaboration.invite.access.write_description": "Kann gemeinsame Kursmaterialien bearbeiten und direkt im Kurs mitarbeiten.",
  "course_settings.collaboration.invite.role_title": "{{roleName}} zu {{courseName}} einladen",
  "course_settings.collaboration.invite.link.title": "Einladungs-Link senden",
  "course_settings.collaboration.invite.link.description": "Kopiere den Link und sende ihn den Kolleg:innen, mit denen Du zusammenarbeiten möchtest. Der Link bleibt 7 Tage gültig.",
  "course_settings.collaboration.invite.search.title": "Kolleg:in suchen",
  "course_settings.collaboration.invite.search.description": "Lehrer:innen innerhalb der gleichen Schullizenz können direkt eingeladen werden.",
  "course_settings.collaboration.invite.search.cta": "Einladen",
  "course_settings.collaboration.invite.search.placeholder": "Namen eingeben, um zu suchen",
  "course_settings.collaboration.invite.search.success": "Kolleg:in zum Kurs hinzugefügt.",
  "course_settings.collaboration.leave.cta": "Zusammenarbeit verlassen",
  "course_settings.collaboration.role.owner": "Ersteller:in",
  "course_settings.collaboration.role.teacher": "Bearbeiter:in",
  "course_settings.collaboration.role.teacher_description": "Kann Materialien aller Mitglieder bearbeiten und kopieren.",
  "course_settings.collaboration.role.co_teacher": "Co-Bearbeiter:in",
  "course_settings.collaboration.role.co_teacher_description": "Kann eigene Materialien hinzufügen und bearbeiten. Kann alle Ordner und Materialien kopieren.",
  "course_settings.collaboration.role.guest": "Gast",
  "course_settings.collaboration.role.guest_description": "Kann Ordner und Materialien sehen und kopieren.",
  "course_settings.collaboration.role.sub_teacher": "Vertretung",
  "course_settings.collaboration.remove_teacher": "Entfernen",
  "course_settings.collaboration.remove_teacher_description": "{{collaboratorName}} kann nicht mehr auf {{courseName}} zugreifen.",
  "course_settings.collaboration.remove_myself": "Zusammenarbeit verlassen",
  "course_settings.collaboration.remove_myself_description": "Du verlierst Zugriff auf {{courseName}} und die dort gespeicherten Materialien.",
  "course_settings.collaboration.member_since": "Mitglied seit {{date}}",
  "course_invite.title": "{{courseOwner}} lädt Dich zur Zusammenarbeit ein.",
  "course_invite.description": "Mit Teachino könnt ihr eure Materialien an einer Stelle sammeln und den Unterricht gemeinsam planen.",
  "course_invite.accept": "Einladung annehmen",
  "course_invite.signup_accept": "Konto erstellen & Einladung annehmen",
  "course_invite.login_accept": "Einloggen & Einladung annehmen",
  "course_invite.already_member": "Teile den Link zu dieser Seite mit Deinen Kolleg:innen, um gemeinsam den Unterricht zu planen.",
  "course_invite.open_course": "Kurs öffnen",
  "course_invite.open_collection": "Sammlung öffnen",
  "course_invite.expired": "Dieser Link ist abgelaufen.",
  "course_invite.expired_call_to_action": "Bitte {{courseOwner}} um einen neuen Link.",
  "tenant_invite.title": "Die Unterrichtsplattform, die mitdenkt.",
  "tenant_invite.description": "Material, Planung, interaktives Lernen und Dokumentation an einem Ort – verbunden durch eine KI-Assistenz, die mitdenkt und unterstützt.",
  "tenant_invite.accept": "Einladung annehmen",
  "tenant_invite.signup_accept": "Konto erstellen & Einladung annehmen",
  "tenant_invite.login_accept": "Einloggen & Einladung annehmen",
  "tenant_invite.already_member": "Du bist bereits Mitglied dieser Schule.",
  "tenant_invite.continue": "Zu Teachino",
  "tenant_invite.expired": "Dieser Einladungslink ist abgelaufen.",
  "tenant_invite.expired_call_to_action": "Bitte {{tenantName}} um einen neuen Link.",
  "course_plan.create_topic": "Neuen Ordner erstellen",
  "course_plan.create_material_in_topic": "Neues Material in {{topicName}} erstellen",
  "course_plan.add_topic": "Ordner hinzufügen",
  "course_plan.add_from_library": "Ordner aus anderem Kurs hinzufügen",
  "course_plan.unorganised_topic": "Materialien ohne Ordner",
  "create_item.confirm_delete_snippet": "Material wird nicht gespeichert!",
  "course_plan.manage_content_button": "Jahresplanung öffnen",
  "course_plan.empty_state_1": "Beginne mit der Planung",
  "course_plan.empty_state_2": "Wähle Materialien aus dem Kurs oder erstelle neue",
  "course_plan.primary_note.title": "Notiz für diese Stunde",
  "course_plan.primary_note.mobile.button_empty": "Tippe hier, um administrative Dinge, die nur diese Stunde betreffen, zu notieren.",
  "course_plan.items.title": "Materialien der Stunde",
  "course_plan.drag_drop_tutorial": "Materialien hier in die Stunde ziehen",
  "course_create_topic_placeholder": "Neuen Ordner eintippen",
  "topic.name": "Name des Ordners",
  "topic.action.edit": "Ordner bearbeiten",
  "topic.action.sort": "Ordner sortieren",
  "topic.lesson_goals": "Lernziele & Kompetenzen",
  "topic.lesson_goals.placeholder": "Schreibe etwas …",
  "topic.delete": "Ordner und Materialien löschen",
  "topic.read_only": "🔒 Dieser Ordner kann von Dir nicht bearbeitet werden. Du kannst Materialien in einen anderen Kurs kopieren.",
  "course.settings": "Einstellungen",
  "course.settings_ai": "KI-Einstellungen",
  "topic_instance.create.create_topic": "Ordner",
  "topic_instance.create.create_topic_save": "Erstellen",
  "topic_instance.create.add_to_multiple_courses_closed": "Zu mehreren Kursen hinzufügen",
  "topic_instance.create.add_to_course_0": "Zu einem Kurs hinzufügen",
  "topic_instance.create.add_to_course_1": "Zu einem Kurs hinzufügen",
  "topic_instance.create.add_to_course_many": "Zu {{number}} Kursen hinzufügen",
  "topic_instance.create.add_to_course_with_name": "Zu {{course}} hinzufügen",
  "topic_instance.create.add_to_course_disabled": "Zu Kurs hinzufügen",
  "topic_instance.add_course_modal.title": "Ordner zu Kurs hinzufügen",
  "topic_instance.add_course_modal.description": "Wähle die Kurse, zu denen {{topic}} hinzugefügt werden soll:",
  "topic_summary_item_0": "Keine Materialien",
  "topic_summary_item_1": "1 Material",
  "topic_summary_item_many": "{{number}} Materialien",
  "item.tooltip.past_dates": "Unterrichtet am: {{dates}}",
  "item.tooltip.future_dates": "Geplant für: {{dates}}",
  "item.menu.make_visible": "Für SuS anzeigen",
  "item.menu.make_not_visible": "Für SuS ausblenden",
  "item.menu.hidden_for_class": "Für SuS ausgeblendet",
  "item.menu.visible_for_class": "Für SuS sichtbar",
  "item.menu.item_made_visible": "Material ist jetzt für SuS sichtbar",
  "item.menu.item_made_not_visible": "Material ist für SuS nicht mehr sichtbar",
  "item.menu.edit_item": "Material umbenennen",
  "item.name": "Name",
  "page_title_reset_password": "Passwort zurücksetzen",
  "page_title_verify_password": "Passwort bestätigen",
  "page_title_login": "Anmelden",
  "page_title_logout": "Abmelden",
  "page_title_signup": "Registrieren",
  "page_title_verify_email": "E-Mail bestätigen",
  "page_title_course_create": "Kurs erstellen",
  "calendar_week": "KW",
  "edit_note_error": "Notiz konnte nicht gespeichert werden",
  "remove_note_error": "Notiz konnte nicht entfernt werden",
  "note_placeholder": "Notiz eingeben",
  "weekday_date_picker_reader_text": "Datum wählen",
  "weekday_move_to": "Schiebe auf {{date}}",
  "note_empty_error": "Bitte füge Deiner Notiz etwas Material hinzu",
  "offline_mode": "Offline-Modus",
  "online_mode": "Online",
  "back_online": "Du bist wieder online!",
  "offline_text": "Du bist offline, die Funktionalität ist eingeschränkt.",
  "today": "Heute",
  "view_menu_options": "Menüoptionen anzeigen",
  "item_detail.duration_heading": "Dauer",
  "item_detail.duration.error_le_0": "Die minimale Dauer beträgt eine Minute",
  "item_detail.add_duration": "Dauer hinzufügen",
  "item_detail.edit_duration": "Dauer ändern",
  "item_detail.minute_0": "Minuten",
  "item_detail.minute_1": "Minute",
  "item_detail.minute_many": "Minuten",
  "item_detail.confirm_delete_item_pre": " ",
  "item_detail.confirm_delete_item_post": "und alle zugehörigen Bausteine löschen?",
  "item_detail.force_delete_text_pre": "Dieses Material wurde in folgenden Kursen verplant:",
  "item_detail.force_delete_text_post": "Möchtest Du es trotzdem löschen?",
  "item_detail.file_unacceptable_type": "Dateityp nicht akzeptiert",
  "item_detail.file_too_large": "Datei zu groß",
  "item_detail.file_empty": "Leere Dateien können nicht hochgeladen werden.",
  "item_detail.file_changed": "Zeichnungen werden nicht gespeichert. Bitte nur zur Präsentation verwenden!",
  "item_detail.file_start_edit_mode": "Zeichnen",
  "item_detail.file_download": "Datei herunterladen",
  "item_detail.file_replace": "Datei ersetzen",
  "item_detail.add_to_lesson": "Zu Stunde hinzufügen",
  "item_detail.remove_from_lesson": "Aus Stunde entfernen",
  "item_detail.presentation": "Präsentieren",
  "item_detail.edit_details": "Details bearbeiten",
  "delete_topic.delete_message_pre": "Willst Du",
  "delete_topic.delete_message_post": "aus diesem Kurs entfernen?",
  "delete_topic.delete_button": "Entfernen",
  "course_students.share_link": "Schüleransicht",
  "course_students.share_item.title": "Material mit Schüler:innen teilen",
  "course_students.access_cards.print_filename_all_students": "Alle Schüler",
  "course_students.accounts.title": "Schüler:innen",
  "course_students.accounts.loading": "Schüler:innen werden geladen …",
  "course_students.accounts.empty": "Noch keine Schüler:innen hinzugefügt. Gib die Schüler:innen ein, um ihnen Zugang zum Kurs zu geben.",
  "course_students.accounts.empty_connect_webuntis": "Bitte verbinde deinen Kurs mit WebUntis, um Schüler:innen zu importieren.",
  "course_students.accounts.table.name": "Name",
  "course_students.accounts.table.last_active": "Zuletzt aktiv",
  "course_students.privacy_banner.message": "Personenbezogene Daten von Schüler:innen dürfen erst nach Unterschrift eines Vertrags zur Auftragsverarbeitung (AVV) eingegeben werden. Der Schule entstehen keine Kosten aus diesem Vertrag. Bis dahin kannst du mit Test-Schüler:innen ausprobieren.",
  "course_students.privacy_banner.austria_message": "Um Schüler:innendaten in Österreich zu verwenden, melde dich über das Bildungsportal (BIP) an. Alternativ kann deine Schulleitung den Vertrag zur Auftragsverarbeitung (AVV) unterzeichnen.",
  "course_students.privacy_banner.connect_bip": "Mit BIP anmelden",
  "course_students.privacy_banner.sign": "AVV durch Schulleitung unterschreiben",
  "course_students.privacy_banner.learn_more": "Mehr erfahren",
  "course_students.privacy_banner.read_more": "Weiterlesen",
  "course_students.accounts.table.no_activity": "Noch keine Aktivität",
  "course_students.accounts.actions.print_code": "Code drucken",
  "course_students.accounts.actions.regenerate_code": "Code neu generieren",
  "course_students.accounts.actions.delete": "Löschen",
  "course_students.accounts.actions.print_all": "Zugänge für Schüler:innen drucken",
  "course_students.accounts.actions.add_students": "Schüler:innen erstellen",
  "course_students.accounts.actions.copy_access_link": "Zugangslink kopieren",
  "course_students.accounts.actions.print_access_code": "Zugangscode drucken",
  "course_students.accounts.actions.rename": "Schüler:in umbenennen",
  "course_students.accounts.actions.print_codes": "Zugangscodes drucken",
  "course_students.accounts.actions.manage_groups": "Lerngruppen verwalten",
  "course_students.accounts.actions.assign_groups": "Zuweisen",
  "course_students.accounts.import.title": "Mit {{integration}} synchronisieren",
  "course_students.accounts.import.description": "Schüler*innen aus {{course}} importieren. Bestehende Schüler*innen bleiben unverändert.",
  "course_students.accounts.import.action": "Schüler*innen synchronisieren",
  "course_students.accounts.import.created": "{{count}} neue Schüler*innen aus {{integration}} importiert.",
  "course_students.accounts.import.no_new": "In {{integration}} wurden keine neuen Schüler*innen gefunden.",
  "course_students.accounts.import.provider_error": "Schüler*innen konnten nicht aus {{integration}} geladen werden. Bitte versuche es erneut.",
  "course_students.accounts.import.provider_error_eduplaces": "Schüler*innen konnten nicht aus {{integration}} geladen werden. Bitte versuche es erneut. Zugriff auf Daten von Schüler:innen muss von der Schule freigeschaltet werden.",
  "course_students.accounts.import.error": "Die Schüler*innen konnten nicht mit {{integration}} synchronisiert werden.",
  "course_students.accounts.import.source_tag": "Aus {{integration}}",
  "course_students.accounts.import.new_available": "{{count}} neue Schüler*innen können importiert werden.",
  "course_students.accounts.import.auto_failed": "Der Kurs wurde verbunden, aber die Schüler*innen konnten nicht automatisch importiert werden. Starte die Synchronisierung unter \"Kurs bearbeiten\" > \"Schüler:innen verwalten\" erneut.",
  "course_students.accounts.import.license_missing_title": "Schüler*innen-Import nicht verfügbar",
  "course_students.accounts.import.license_missing_description": "Deine Schule benötigt eine Teachino-Schullizenz mit Freigabe für Schüler*innen-Konten, damit Schüler*innen automatisch aus der verbundenen Integration importiert werden können. Wende dich an deine Schulleitung oder an Teachino.",
  "course_students.accounts.import.license_missing_toast": "Der Kurs wurde verbunden. Schüler*innen wurden nicht importiert: Deine Schule benötigt dafür eine Teachino-Schullizenz mit Freigabe für Schüler*innen-Konten.",
  "course_students.accounts.student_code.title": "Zugang für {{studentName}}",
  "course_students.accounts.add_students.description": "Gib die Namen der Schüler:innen ein – schreibe einfach einen Namen pro Zeile.",
  "course_students.accounts.add_students.name_too_long": "Ein Schülername darf maximal {{maxLength}} Zeichen haben.",
  "course_students.accounts.add_students.placeholder": "Anna\nBoris\nChris\n…",
  "course_students.accounts.add_students.test_students_intro": "Diese Test-Zugänge werden neu angelegt:",
  "course_students.accounts.add_students.test_students_kept": "Bereits vorhandene Schüler:innen ({{count}}) bleiben unverändert – ihre Zugangscodes und Daten ändern sich nicht.",
  "course_students.accounts.add_students.create_count_one": "{{count}} Zugang erstellen",
  "course_students.accounts.add_students.create_count_many": "{{count}} Zugänge erstellen",
  "course_students.accounts.delete_student.title": "Schüler:in löschen",
  "course_students.accounts.delete_student.confirm": "Möchtest du „{{studentName}}“ wirklich löschen?",
  "course_students.accounts.data_footprint.answers_one": "{{count}} Antwort",
  "course_students.accounts.data_footprint.answers_many": "{{count}} Antworten",
  "course_students.accounts.data_footprint.grades_one": "{{count}} Note",
  "course_students.accounts.data_footprint.grades_many": "{{count}} Noten",
  "course_students.accounts.data_footprint.notes_one": "{{count}} Notiz",
  "course_students.accounts.data_footprint.notes_many": "{{count}} Notizen",
  "course_students.accounts.delete_student.data_intro": "Diese Daten werden gelöscht:",
  "course_students.accounts.delete_student.data_unknown": "Alle Abgaben, Antworten und Noten werden gelöscht.",
  "course_students.accounts.delete_student.permanent_hint": "Das lässt sich nicht rückgängig machen. Du kannst den Namen danach neu anlegen – der Zugang ist dann leer und hat einen neuen Code.",
  "course_students.accounts.delete_student.confirm_checkbox": "Ja, ich habe verstanden, dass diese Daten gelöscht werden.",
  "course_students.accounts.delete_student.deleted_toast": "„{{studentName}}“ wurde gelöscht.",
  "course_students.accounts.preview.description": "So sehen Schüler:innen dieses Material. Du kannst interaktive Aufgaben und KI-Chatbots hier ausprobieren.",
  "course_students.accounts.visibility.all_students": "Alle SuS",
  "course_students.groups.title": "Lerngruppen",
  "course_students.groups.create": "Lerngruppe erstellen",
  "course_students.groups.edit": "Lerngruppe bearbeiten",
  "course_students.groups.delete": "Lerngruppe löschen",
  "course_students.groups.assign": "Lerngruppen zuweisen",
  "course_students.groups.empty": "Noch keine Lerngruppen erstellt",
  "course_students.groups.empty_in_group": "Keine Schüler:innen in dieser Lerngruppe",
  "course_students.groups.new_group": "Neue Lerngruppe",
  "course_students.groups.student_label": "Schüler:in",
  "course_students.groups.description": "Erstelle Gruppen für Schüler:innen mit ähnlichen Lernvoraussetzungen, Unterstützungsbedarfen oder Stärken",
  "course_students.groups.create.description": "Lege eine Lerngruppe an und wähle optional direkt die ersten Schüler:innen aus.",
  "course_students.groups.edit.description": "Passe Namen und Farbe der Lerngruppe an und wähle aus, welche Schüler:innen Mitglied sein sollen.",
  "course_students.groups.assign.description": "Wähle die Lerngruppen aus, denen diese:r Schüler:in zugeordnet sein soll.",
  "course_students.groups.manage_members.title": "Schüler verwalten",
  "course_students.groups.manage_members.description": "Wähle aus, welche Schüler:innen in dieser Lerngruppe sein sollen.",
  "course_students.groups.manage_members.empty": "Keine Schüler in diesem Kurs",
  "course_students.groups.assign.empty": "Keine Lerngruppen in diesem Kurs",
  "course_students.groups.name_placeholder": "z. B. Lerngruppe A",
  "course_students.groups.name_placeholder_edit": "z. B. besonders motiviert, Deutsch als Zweitsprache",
  "course_students.groups.delete_confirm": "Möchtest du die Lerngruppe \"{{groupName}}\" wirklich löschen? Die Schüler:innen werden nicht gelöscht.",
  "student_accounts.page_title": "Schüler-Login",
  "student_accounts.login.code_label": "Code",
  "student_accounts.login.code_placeholder": "XXXXX-XXXXX",
  "student_accounts.login.submit": "Einloggen",
  "student_accounts.login.heading": "Materialien in Teachino öffnen",
  "student_accounts.login.choose_method": "Wie möchtest du fortfahren?",
  "student_accounts.login.received_code": "Ich habe einen Code von meiner Lehrkraft erhalten",
  "course_students.reusable_share.course_title": "Kurslink teilen",
  "course_students.reusable_share.course_description": "Teile diesen Link oder QR-Code. Schüler:innen melden sich mit ihrem persönlichen Zugangscode an.",
  "course_students.reusable_share.material_title": "Materiallink teilen",
  "course_students.reusable_share.material_description": "Teile diesen Link oder QR-Code, um Schüler:innen nach der Anmeldung direkt zu diesem Material zu führen.",
  "course_students.reusable_share.show_qr_code": "QR-Code anzeigen",
  "course_students.reusable_share.copy_public_tooltip": "Schüler:innen können sich über diesen Link selbst registrieren. Danach erhalten sie einen persönlichen Zugangscode.",
  "course_students.reusable_share.copy_code_tooltip": "Schüler:innen können diesen Link öffnen und sich mit ihrem persönlichen Zugangscode anmelden.",
  "course_students.reusable_share.qr_description": "Dieser QR-Code führt zum Kurs.",
  "course_students.reusable_share.qr_code_description": "Schüler:innen können sich mit diesem QR-Code mit ihrem persönlichen Zugangscode anmelden.",
  "course_students.reusable_share.qr_public_description": "Schüler:innen können sich mit diesem QR-Code selbst registrieren. Danach erhalten sie einen persönlichen Zugangscode.",
  "course_students.reusable_share.student_codes": "Zugangscodes deiner Schüler:innen",
  "course_students.reusable_share.material_disabled": "Mache das Material für mindestens eine:n Schüler:in sichtbar, bevor du es teilst.",
  "course_students.self_registration.title": "Selbstregistrierung für SuS aktivieren",
  "course_students.self_registration.description": "Schüler:innen öffnen den Link und geben Namen oder Kürzel ein. Sie erhalten einen Code um später wieder zuzugreifen.",
  "course_students.self_registration.toggle_label": "Selbstregistrierung erlauben",
  "course_students.self_registration.link_description": "Sende diesen Link an deine Schüler:innen.",
  "course_students.self_registration.saved": "Einstellung gespeichert",
  "course_students.self_registration.material_banner": "Schüler:innen können mit diesem Link selber einen Namen oder ein Kürzel eingeben. Sie erhalten einen Code, mit dem sie später wieder auf den Kurs zugreifen können.",
  "student_accounts.self_registration.no_code": "Ich habe noch keinen Code",
  "student_accounts.self_registration.description": "Gib deinen Namen oder ein Kürzel ein.",
  "student_accounts.self_registration.name_label": "Dein Name",
  "student_accounts.self_registration.name_placeholder": "Name eingeben",
  "student_accounts.self_registration.submit": "Konto erstellen",
  "student_accounts.self_registration.error": "Das Konto konnte nicht erstellt werden. Bitte versuche es erneut.",
  "student_accounts.self_registration.code_title": "Das ist dein Code",
  "student_accounts.self_registration.code_description": "Bewahre diesen Code gut auf. Du brauchst ihn, wenn du wiederkommst.",
  "student_accounts.self_registration.code_warning": "Notiere den Code, damit du später wieder auf Materialien und Abgaben zugreifen kannst.",
  "student_accounts.self_registration.code_teacher_note": "Deine Lehrkraft kann Codes verwalten.",
  "student_accounts.self_registration.continue": "Weiter",
  "course_students.merge.action": "Konto zusammenführen",
  "course_students.merge.title": "Doppeltes Konto zusammenführen",
  "course_students.merge.description": "{{sourceName}} ({{sourceCode}}) wird gelöscht. Wähle das Konto, in das alle Daten übernommen werden sollen.",
  "course_students.merge.target_label": "Konto, das bestehen bleibt",
  "course_students.merge.target_placeholder": "Konto auswählen, das bestehen bleibt",
  "course_students.merge.newest_wins_hint": "Alle Daten werden in das ausgewählte Konto übertragen. Name und Code bleiben gleich. Bei widersprüchlichen Ergebnissen bleibt der neueste Stand erhalten.",
  "course_students.merge.confirm": "Zusammenführen und Duplikat löschen",
  "course_students.merge.success": "{{sourceName}} wurde mit {{targetName}} zusammengeführt",
  "student_accounts.login.description": "Gib den Code ein, den du von deiner Lehrkraft erhalten hast.",
  "student_accounts.login.teacher_cta": "Du bist Lehrkraft? Hier anmelden",
  "student_accounts.login.code_invalid": "Der Code ist ungültig. Bitte überprüfe ihn und versuche es erneut.",
  "student_accounts.login.code_invalid_characters": "Der Code darf nur Buchstaben und Zahlen enthalten.",
  "student_accounts.login.code_length": "Der Code muss genau 10 Zeichen haben",
  "student_accounts.login.error_generic": "Beim Einloggen ist ein Fehler aufgetreten. Bitte versuche es erneut.",
  "student_accounts.logout.dialog_title": "Dein Zugang zu Teachino",
  "student_accounts.logout.logged_in_as": "Du bist angemeldet als",
  "student_accounts.logout.switch_course_title": "Kurs wechseln oder abmelden",
  "student_accounts.logout.switch_course_message": "Wenn du auf einen anderen Kurs zugreifen möchtest oder jemand anders mit diesem Gerät weiterarbeiten soll, klicke auf Abmelden. Du kannst später wieder mit deinem persönlichen Zugangscode einsteigen.",
  "student_accounts.access_card.website": "Webseite",
  "student_accounts.access_card.personal_code": "Persönlicher Zugangscode",
  "student_accounts.access_card.code_copied": "Code kopiert",
  "material.student_visibility.title": "Sichtbarkeit für Schüler:innen",
  "material.student_visibility.summary_all": "Material für alle Schüler:innen sichtbar",
  "material.student_visibility.summary_partial": "Material für {{visible}} von {{total}} Schüler:innen sichtbar",
  "material.student_visibility.toggle_all_hint": "Der Schalter blendet das Material für alle Schüler:innen ein",
  "material.student_visibility.show_for_groups": "Für Schüler:innen in Lerngruppen einblenden",
  "material.student_visibility.guest_readonly_hint": "Als Gast kannst du die Sichtbarkeit nur ansehen, nicht ändern.",
  "material.save_conflict.body_updated": "Dieses Material wurde aktualisiert, nachdem dieser Editor geöffnet wurde.",
  "material.save_conflict.body_reload_warning": "Beim Neuladen wird die neueste Version des Materials geladen. Nicht gespeicherte Änderungen in dieser veralteten Version gehen dabei verloren.",
  "course_settings.collaboration.empty": "Noch keine Lehrkräfte eingeladen",
  "link.copied.title": "Link kopiert",
  "link.copied.description": "Du kannst den Link nun versenden",
  "emoji.name": "Symbol",
  "emoji.title": "Symbol wählen",
  "emoji.search": "Suchen",
  "emoji.not_found": "Kein Icon gefunden",
  "emoji.category.search": "Suchergebnisse",
  "emoji.category.recent": "Nützliche Icons",
  "emoji.category.people": "Smileys & Personen",
  "emoji.category.nature": "Tiere & Natur",
  "emoji.category.foods": "Essen & Trinken",
  "emoji.category.activity": "Aktivität",
  "emoji.category.places": "Orte",
  "emoji.category.objects": "Objekte",
  "emoji.category.symbols": "Symbole",
  "emoji.category.flags": "Fahnen",
  "emoji.category.custom": "Weitere",
  "emoji.skin.choose": "Wähle eine Standard-Hautfarbe",
  "emoji.skin.1": "1",
  "emoji.skin.2": "2",
  "emoji.skin.3": "3",
  "emoji.skin.4": "4",
  "emoji.skin.5": "5",
  "emoji.skin.6": "6",
  "emoji.remove": "Symbol entfernen",
  "action": "Aktionen",
  "error_page.title": "Etwas ist schiefgelaufen",
  "error_page.title_404": "Seite nicht gefunden",
  "error_page.button": "Zurück zur Startseite",
  "public.empty_material.student": "Dieses Material ist noch leer. Sobald Deine Lehrkraft Inhalte hinzufügt, siehst Du diese hier.",
  "public.hidden_material.student.title": "Dieses Material wurde noch nicht für Dich freigegeben.",
  "public.hidden_material.student.description": "Sobald Deine Lehrkraft es freigibt, erscheint es in der Kursübersicht.",
  "public.logged_in_as": "Du bearbeitest das Material als {{studentNickname}}. Das bist nicht Du? Klicke hier, um Dich abzumelden.",
  "public.recently_shared": "Zuletzt freigegeben",
  "student_course.empty.title": "Noch keine Materialien",
  "student_course.empty.description": "Deine Lehrkraft hat noch nichts mit dir geteilt. Schau später wieder vorbei.",
  "library.empty": "Hier gibt es noch keine Materialien.",
  "library.topic_count_0": "Keine Ordner",
  "library.topic_details.empty_state": "Fülle den Ordner mit Materialien",
  "library.topic.move_to_folder": "In Ordner verschieben",
  "library.topic.move_to_folder.modal.move_one_description": "\"{{topic}}\" verschieben",
  "library.topic.move_to_folder.modal.move_many_description": "{{number}} Ordner verschieben",
  "library.topic.move_to_folder.modal.confirm": "Nach \"{{folder}}\" verschieben",
  "library.topic.move_to_folder.toast.success": "Ordner erfolgreich verschoben",
  "library.topic.copy_to_folder": "In Ordner kopieren",
  "library.topic.copy_to_folder.modal.move_one_description": "\"{{topic}}\" kopieren",
  "library.topic.copy_to_folder.modal.move_many_description": "{{number}} Ordner kopieren",
  "library.topic.copy_to_folder.modal.confirm": "Nach \"{{folder}}\" kopieren",
  "library.topic.copy_to_folder.toast.success": "Ordner erfolgreich kopiert",
  "library.topic.rename.toast.success": "Ordner umbenannt",
  "library.folder.rename.toast.success": "Ordner umbenannt",
  "library.folder.feature_description": "Ordner in Ordnern organisieren",
  "library.topic.goals_updated.toast.success": "Lernziele und Kompetenzen gespeichert",
  "library.topic.goals.empty_button": "Lernziele und Kompetenzen eingeben",
  "library.topic.add_to_course": "Zu Kurs hinzufügen",
  "library.topics.add_to_courses.bulk.description": "{{count}} Ordner werden zu den von dir ausgewählten Kursen hinzugefügt.",
  "library.topics.add_to_courses.toast.success": "Ordner zu Kursen hinzugefügt",
  "library.topic.courses_school_year_filter": "Schuljahr {{schoolYear}}",
  "library.topic.create_with_name": "Neuen Ordner {{name}} erstellen",
  "library.topic.create.title": "Neuen Ordner erstellen",
  "library.topic.create.label": "Name des Ordners",
  "library.topic.create.button": "Ordner erstellen",
  "library.topic.create.error": "Bitte gib einen Namen für den Ordner ein.",
  "library.topic.create.description": "Ordner sind thematische Einheiten, wie Kapitel im Schulbuch.<br />Im nächsten Schritt kannst Du Materialien zum Ordner hinzufügen.",
  "library.topic.create.examples": "<strong>Beispiele:</strong> \"Satz des Pythagoras\", \"Klimawandel\", \"Simple Past\"",
  "library.create_topic.empty_state.title": "Lege jetzt Deinen ersten Ordner an! 📚📝",
  "library.create_topic.empty_state.description": "In Teachino strukturierst Du Deine Materialien in Ordnern. Ordner dienen als übergeordnete Themen, z. B. Kapitel aus dem Schulbuch.",
  "library.create_topic.empty_state.input_placeholder": "z. B. \"Entstehung von Gletschern\" oder \"Einführung in den Satz des Pythagoras\"",
  "library.show_archived_courses": "Gelöschte Kurse anzeigen",
  "library.hide_archived_courses": "Gelöschte Kurse ausblenden",
  "library.add_from_library": "Ordner aus anderem Kurs hinzufügen",
  "library.add_from_library_closed_courses": "Gelöschte Kurse",
  "library.add_from_library_closed_courses_empty": "Kurse aus vergangenen Schuljahren werden hier aufscheinen.",
  "library.add_from_library.header": "{{number}} Ordner gefunden",
  "library.add_from_library.show_all": "Alle Ordner",
  "library.add_from_library.empty_title": "Keine Ordner gefunden",
  "library.add_from_library.empty_description": "Es wurde kein passender Ordner gefunden. Du kannst stattdessen einen neuen erstellen.",
  "library.duplicate_item.title": "Material kopieren",
  "library.move_item.title": "Material verschieben",
  "library.move_item.warning_title": "Achtung: Daten können verloren gehen!",
  "library.move_item.warning_description": "Falls dieses Material bereits in einem Kurs verplant wurde, geht die Zuordnung zum Kurs und zu den Unterrichtsstunden verloren!",
  "library.move_item.warning_description_many": "Falls Materialien bereits in einem Kurs verplant wurden, geht die Zuordnung zum Kurs und zu den Unterrichtsstunden verloren!",
  "library.duplicate_item.new_name": "Neuer Name",
  "library.duplicate_item.new_topic": "Neuer Ordner",
  "library.duplicate_item.new_name_prefix": "Kopie von",
  "library.duplicate_item.success": "Das Material wurde kopiert",
  "library.duplicate_topic.title": "Ordner kopieren",
  "library.duplicate_topic.course": "Neuer Kurs / Neue Sammlung",
  "library.duplicate_topic.success": "Der Ordner wurde kopiert.",
  "library.template.create_from_template.tooltip": "Ein neuer Kurs wird erstellt, der alle Ordner, Materialien und Einstellungen dieser Sammlung enthält.",
  "library.folder_tree.empty_state.description": "Ordner bieten eine zusätzliche Organisationsebene, mit der du deine Ordner organisieren kannst",
  "library.folder_tree.empty_state.cta": "Ordner erstellen",
  "library.folder.empty_state.title": "Leerer Ordner",
  "library.folder.empty_state.description": "\"{{folder}}\" enthält noch keine Ordner. Erstelle einen neuen oder schiebe einen bestehenden Ordner in diesen Ordner.",
  "library.folder.create": "Ordner erstellen",
  "library.folder.name.label": "Name des Ordners",
  "library.folder.delete": "Ordner löschen",
  "library.folder.delete.folder_not_empty": "Nur leere Ordner können gelöscht werden.",
  "library.folder.delete.please_delete_subfolders": "Bitte entferne alle Unterordner und Ordner aus \"{{folder}}\"",
  "library.folder.delete.are_you_sure": "Ordner \"{{folder}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "library.folder.rename": "Ordner umbenennen",
  "library.folder.convert_to_template": "In Sammlung umwandeln",
  "library.folder.add_to_course": "Zu Kurs hinzufügen",
  "library.folder.add_to_courses.description": "Alle Ordner und Materialien in „{{folder}}“ inklusive Unterordner ({{count}} Ordner) werden zu den von dir ausgewählten Kursen hinzugefügt.",
  "library.folder.convert_to_template.description": "Damit wird eine neue Sammlung mit einer Kopie aller Ordner und Materialien dieses Ordners erstellt.",
  "library.folder.convert_to_template.name.label": "Name der Sammlung",
  "library.folder.convert_to_template.cta": "Sammlung erstellen",
  "library.folder.convert_to_template.toast.success": "Sammlung erstellt",
  "library.collection.create_from_topics.button": "Sammlung erstellen",
  "library.collection.create_from_topics.title": "Sammlung erstellen",
  "library.collection.create_from_topics.description": "{{count}} Einheiten werden als separate Ordner in einer Sammlung kopiert. Verschachtelte Bibliotheksordner werden nicht übernommen.",
  "library.collection.create_from_topics.name.label": "Name der Sammlung",
  "library.collection.create_from_topics.cta": "Sammlung erstellen",
  "library.collection.create_from_topics.toast.success": "Sammlung erstellt",
  "library.collection.create_from_topics.no_eligible_topics": "Wähle mindestens eine Einheit aus. Allgemeine Materialien können nicht in eine Sammlung übernommen werden.",
  "collection.add_content_menu.import_material": "Aus Kurs hinzufügen",
  "collection.edit": "Sammlung bearbeiten",
  "collection.rename": "Sammlung umbenennen",
  "collection.name_description": "Wie soll die Sammlung heißen?",
  "collection.archive": "Sammlung löschen",
  "collection.archive_description": "Die Sammlung wird gelöscht und alle Mitglieder verlieren den Zugriff. In Kursen verwendete Ordner & Materialien bleiben erhalten.",
  "collection.archived_toast": "Sammlung gelöscht. Die Sammlung \"{{collectionName}}\" wurde gelöscht.",
  "navigation.collections": "Sammlungen",
  "collections.my_title": "Meine Sammlungen",
  "collections.shared_title": "Mit mir geteilt",
  "collections.create": "Sammlung erstellen",
  "collections.my.empty_title": "Noch keine Sammlungen",
  "collections.my.empty_description": "Erstelle deine erste Sammlung, um Ordner und Materialien mit Kolleg:innen zu teilen.",
  "collections.shared.empty_title": "Keine geteilten Sammlungen",
  "collections.shared.empty_description": "Sammlungen, zu denen dich Kolleg:innen einladen, erscheinen hier.",
  "collections.owner_you": "Du",
  "collection.name_and_gradient": "Name und Erscheinungsbild",
  "collection.gradient.regenerate": "Neu generieren",
  "template.sync.success": "Synchronisierung erfolgreich!",
  "template.sync.error": "Synchronisierung fehlgeschlagen!",
  "library.file_upload.choose_files": "Dateien wählen",
  "library.file_upload.drag_here": "Dateien hierher ziehen oder",
  "library.file_upload.error": "Die Datei konnte nicht hochgeladen werden.",
  "features.timetable.page_timetable": "Stundenplan",
  "features.timetable.failed_save": "Der Stundenplan ist fehlerhaft.",
  "timetable.week_not_loaded": "Der Stundenplan für diese Woche konnte nicht geladen werden. Bitte versuche es erneut oder wähle eine andere Woche.",
  "timetable.integration_not_available_title": "WebUntis nicht erreichbar – Stundenplanansicht eingeschränkt",
  "timetable.integration_not_available_desc1": "Bereits geplante Stunden scheinen in der Liste auf",
  "timetable.integration_not_available_desc2": "Noch nicht in Teachino geplante Stunden scheinen nicht auf",
  "timetable.integration_not_available_desc3": "Sobald WebUntis wieder verfügbar ist, wird der vollständige Stundenplan automatisch wieder angezeigt",
  "timetable.integration_not_available_desc4": "Über \"Kurse\" können jederzeit alle Materialien geöffnet werden",
  "timetable_edit.add_period": "Termin",
  "timetable_edit.create_period_title": "Termin erstellen",
  "timetable_edit.edit_period_title": "Termin bearbeiten",
  "timetable_edit.period_label": "Beschreibung",
  "timetable_edit.period_label_placeholder": "z. B. Besprechung, …",
  "timetable_edit.period_label_error": "Bitte Beschreibung eingeben",
  "timetable_edit.period_date": "Datum",
  "timetable_edit.period_date_time": "Datum und Uhrzeit",
  "timetable_edit.period_date_time_error": "Bitte überprüfe das Datum und die Uhrzeit",
  "timetable_edit.period_date_error": "Bitte wähle ein Datum aus.",
  "timetable_edit.period_time": "Zeit",
  "timetable_edit.period_note_loading": "Notiz wird geladen …",
  "timetable_edit.period_note_placeholder": "Notiz für diesen Kurstag",
  "timetable_edit.cancel": "Entfall",
  "timetable_edit.cancel_warning_title": "Entfall bestätigen",
  "timetable_edit.cancel_warning_description": "Bitte bestätige, dass diese Unterrichtsstunde nicht stattfindet.",
  "timetable_edit.cancel_warning_confirm": "Stunde fällt aus",
  "timetable_edit.uncancel": "Stunde wiederherstellen",
  "timetable_edit.uncancel_warning_title": "Abgesagte Stunde wiederherstellen",
  "timetable_edit.uncancel_warning_description": "Diese Stunde im Stundenplan wiederherstellen?",
  "timetable_edit.remove_warning_title": "Eintrag löschen",
  "timetable_edit.remove_warning_description": "Bitte bestätige, dass dieser Eintrag gelöscht werden soll.",
  "timetable_edit.remove_warning_confirm": "Eintrag löschen",
  "timetable.empty_state_header": "Stundenplan und Termine",
  "timetable.empty_state_description": "Hier hast Du Deine Woche im Blick und kannst deine Stunden vorbereiten.",
  "timetable.empty_state_button": "Stundenplan eingeben",
  "timetable.edit": "Stundenplan bearbeiten",
  "timetable.edit.choose": "Wähle einen Kurs für diese Stunde",
  "timetable.edit.choose_create": "Neuen Kurs erstellen",
  "agenda.empty.description": "Für diesen Kurs gibt es noch keine Termine im gewählten Zeitraum. Bitte hinterlege einen Stundenplan oder erstelle eine einzelne Stunde.",
  "agenda.empty.date_range": "Zeitraum:",
  "todo_title": "Persönliche To-dos",
  "todo_item_placeholder": "To-do eingeben",
  "todo_move_to_another_date": "Anderes Datum wählen",
  "todo_change_course": "Kurs ändern",
  "todo_no_course": "Kein Kurs",
  "todo_page_overdue": "Überfällige To-dos",
  "todo_add_date": "Datum hinzufügen",
  "todo_error_fetch": "Fehler: To-dos konnten nicht vom Server abgeholt werden",
  "todo_error_edit": "Fehler: To-do konnte nicht bearbeitet werden",
  "todo_error_delete": "Fehler: To-do konnte nicht gelöscht werden",
  "todo_success_change_date_header": "Datum wurde geändert",
  "todo_success_change_date_description": "Das Datum wurde auf {{date}} geändert.",
  "course_plan.todo_header": "To-dos für {{date}}",
  "course_plan.note_saved": "Planung gespeichert!",
  "integration.connect_title": "Profile verknüpfen",
  "integration.settings_title": "Integrationen",
  "integration.settings_remove": "Verbindung trennen",
  "integration.settings_remove_title": "Verbindung trennen",
  "integration.settings_remove_description": "Die Verbindung zu Kursen und Stundenplan wird getrennt. Single-Sign-On wird nicht mehr möglich sein. Falls Du noch kein Passwort gesetzt hast, kannst Du dieses über Deine E-Mail-Adresse zurücksetzen.",
  "integration.settings_connect": "Verbinden",
  "integration.settings_coming_soon_cta": "Mehr erfahren",
  "integration.disconnected_notice.title": "Verbindung zu {{displayName}} getrennt",
  "integration.disconnected_notice.description": "{{displayName}} erlaubt Teachino keinen Zugriff mehr auf Dein Konto – entweder hat Deine Schule die Integration deaktiviert oder Dein Zugang wurde entfernt. Wir haben die Verbindung deshalb getrennt. Deine Kurse und Materialien in Teachino bleiben erhalten. Sobald Du wieder Zugriff hast, kannst Du die Verbindung erneut herstellen.",
  "integration.disconnected_notice.open_settings": "Integrationen öffnen",
  "integration.disconnected_notice.dismiss": "Verstanden",
  "integration.authenticate.header": "{{displayName}} mit Teachino verknüpfen",
  "integration.authenticate.integration_profile": "{{displayName}}-Profil",
  "integration.authenticate.teachino_profile": "Teachino-Profil",
  "integration.authenticate.error_generic": "Bei der Anmeldung ist ein Fehler aufgetreten. Bitte öffne Teachino über app.teachino.io oder kontaktiere uns unter hallo@teachino.io",
  "integration.authenticate.student_creation_failed": "Dein Schüler*innenzugang konnte nicht erstellt werden. Bitte öffne Teachino erneut über WebUntis oder wende dich an deine Lehrperson.",
  "integration.authenticate.redirect_triggered": "Du wirst gleich weitergeleitet.",
  "integration.authenticate.not_possible_title": "Bereits mit einem anderen Teachino-Konto verknüpft",
  "integration.authenticate.not_possible_description": "Dieses {{displayName}}-Konto ist bereits mit einem anderen Teachino-Konto verknüpft und kann nicht mit Deinem aktuellen Konto verknüpft werden. Du kannst Dich abmelden und mit dem verknüpften Konto fortfahren oder in Deinem aktuellen Konto bleiben.",
  "integration.authenticate.login_conflict_title": "Du bist mit einem anderen Teachino-Konto angemeldet",
  "integration.authenticate.login_conflict_description": "Dieses {{displayName}}-Konto ist mit einem anderen Teachino-Konto verknüpft als dem, das Du gerade verwendest. Um Dich über diese Integration anzumelden, melde Dich zuerst von Deinem aktuellen Teachino-Konto ab.",
  "integration.authenticate.current_account": "Aktuell angemeldet: {{email}}",
  "integration.authenticate.sign_out_and_continue": "Abmelden und mit {{displayName}} fortfahren",
  "integration.authenticate.not_possible_back_link": "In meinem aktuellen Konto bleiben",
  "integration.authenticate.cannot_signup": "Du scheinst schon ein Teachino-Profil zu haben. Bitte wähle \"Ich verwende Teachino bereits\" und melde Dich an. Im Anschluss kannst du das Profil verknüpfen.",
  "integration.authenticate.signup_conflict_description": "Du hast bereits ein Teachino-Konto. Melde Dich an, um es mit dieser Integration zu verknüpfen.",
  "integration.authenticate.create_account": "Neues Konto erstellen",
  "integration.authenticate.help": "Für Hilfe wende Dich bitte an hallo@teachino.io",
  "integration.authenticate.sign_up": "Ich bin neu bei Teachino",
  "integration.authenticate.log_in": "Ich verwende Teachino bereits",
  "integration.authenticate.successful": "{{displayName}} und Teachino wurden verknüpft!",
  "integration.authenticate.open_teachino_hint": "Bitte öffne Teachino unter app.teachino.io und melde Dich mit E-Mail-Adresse und Passwort an.",
  "integration.authenticate.open_teachino": "Teachino öffnen",
  "integration.admininfo.title": "Die Integration mit Teachino ist aktiviert! 👏",
  "integration.admininfo.description": "Lehrkräfte sehen Teachino nun in WebUntis und können mit Teachino arbeiten.",
  "integration.admininfo.explore_title": "1. Teachino kennenlernen 👀",
  "integration.admininfo.open_website": "Webseite öffnen",
  "integration.admininfo.try_title": "Selbst ausprobieren?",
  "integration.admininfo.try_description": "Melde Dich dazu bitte in WebUntis mit einem Benutzer der Rolle Lehrkraft an und klicke dann auf Teachino. Anstelle dieser Seite siehst Du dann die Unterrichtsplanung.",
  "integration.admininfo.inform_title": "2. Kollegium informieren 📣",
  "integration.admininfo.inform_description": "Textvorlage zum Versenden per E-Mail oder Messenger",
  "integration.admininfo.mail_text": "Liebe Kolleg:innen\nIch habe soeben die WebUntis Integration mit Teachino aktiviert. Teachino unterstützt mit künstlicher Intelligenz bei der Erstellung von Materialien und gibt Schüler:innen Feedback mit KI. Ihr könnt Teachino jetzt ausprobieren. Weitere Informationen und eine kurze Anleitung findet ihr unter https://help.teachino.io/\nSchöne Grüße",
  "integration.admininfo.copy_text": "Text kopieren und versenden",
  "integration.admininfo.copied_title": "Text kopiert",
  "integration.admininfo.copied_description": "Der Text kann nun im E-Mail-Programm eingefügt und versendet werden.",
  "integration.admininfo.meeting_title": "3. Video-Konferenz mit Teachino vereinbaren 📆",
  "integration.admininfo.meeting_description": "Gerne stellen wir Teachino in einem Video-Call vor und beantworten alle Fragen.",
  "integration.admininfo.schedule": "Termin wählen",
  "integration.admininfo.contact": "Teachino-Team kontaktieren",
  "integration.not_ready.title": "Teachino-Integration aktivieren 🚀",
  "integration.not_ready.description": "Bitte fülle dieses Formular aus. Wir vereinbaren dann einen kurzen Video-Call, in dem wir die wichtigsten Funktionen von Teachino erklären und richten die Testphase mit Dir zusammen ein.",
  "integration.not_ready_student.title": "Teachino ist für Deine Schule noch nicht aktiviert.",
  "integration.not_ready_student.description": "Sobald Deine Lehrer:in Teachino aktiviert, wirst Du hier Unterrichtsmaterialien und vieles mehr sehen.",
  "integration.authenticate_untis.description": "Mit Teachino kannst Du Deinen Unterricht basierend auf Deinem WebUntis-Stundenplan vorbereiten und Deine Planung in das Klassenbuch übernehmen.",
  "integration.authenticate_digreg.description": "Mit Teachino kannst Du Deinen Unterricht basierend auf Deinem Stundenplan aus dem Digitalen Register vorbereiten und Deine Planung in das Klassenbuch übernehmen.",
  "integration.authenticate_microsoft.description": "Verknüpfe Dateien aus OneDrive und Seiten aus OneNote mit Teachino.",
  "integration.authenticate_bip.description": "Die Verbindung von Teachino und dem BIP ermöglicht die automatische Anmeldung in Teachino.",
  "integration.authenticate_europathek.description": "Die Verbindung von Teachino und der EUROPATHEK ermöglicht die automatische Anmeldung in Teachino.",
  "integration.authenticate_cgie.description": "Die Verbindung von Teachino und dem CGIE ermöglicht die automatische Anmeldung in Teachino und die Freischaltung einer kostenlosen Lizenz.",
  "integration.settings_connected_with": "Verbunden mit: {{displayName}}",
  "integration.ical.description": "Importiere Stundenplaneinträge aus einem iCal-Feed und ordne Kalendernamen auf dieser Seite Teachino-Kursen zu.",
  "integration.ical.connect_title": "iCal-Feed verbinden",
  "integration.ical.edit_title": "iCal-Feed bearbeiten",
  "integration.ical.edit_feed": "Link bearbeiten",
  "integration.ical.save_feed": "iCal-Feed speichern",
  "integration.ical.modal_description": "Füge die iCal-Abonnement-URL des Kalenders ein, den Du im Stundenplan anzeigen möchtest.",
  "integration.ical.url_label": "iCal-URL",
  "integration.ical.url_placeholder": "https://example.com/calendar.ics",
  "integration.ical.url_required": "Bitte gib eine iCal-URL ein.",
  "integration.ical.mapping_hint": "Verwende für alle Einträge desselben Kurses exakt denselben Kalendereintragsnamen, damit die Kurszuordnung korrekt funktioniert.",
  "integration.ical.invalid_feed_url": "Dieser Feed konnte nicht verbunden werden. Bitte stelle sicher, dass Du die iCal-Abonnement-URL und nicht den Link zur Kalenderseite eingefügt hast.",
  "integration.ical.connected_courses.description": "Verknüpfe die Kurse aus Teachino mit den Kalendereinträgen aus deinem Kalender.",
  "integration.untis.description": "Verbinde Teachino mit WebUntis, um Deinen Stundenplan und das Klassenbuch zu synchronisieren. Deine Schule muss die Integration in WebUntis aktivieren. Öffne dann WebUntis und klicke dort auf Teachino",
  "integration.edupage.description": "Verbinde Teachino mit EduPage, um Deinen Stundenplan zu importieren und EduPage-Fächer Deinen Teachino-Kursen zuzuordnen.",
  "integration.edupage.connect_title": "EduPage-Stundenplan verbinden",
  "integration.edupage.edit_title": "EduPage-Stundenplan bearbeiten",
  "integration.edupage.edit_feed": "EduPage-Verbindung bearbeiten",
  "integration.edupage.save_feed": "EduPage-Stundenplan speichern",
  "integration.edupage.tutorial_step_1": "Öffne in EduPage \"Unterricht\" → \"Termine\".",
  "integration.edupage.tutorial_step_2": "Wähle unter \"Termine\" den Eintrag \"Stundenplan\" aus.",
  "integration.edupage.tutorial_step_3": "Klicke auf \"Exportieren\" und anschließend auf \"Aktivieren Webcal\".",
  "integration.edupage.tutorial_step_4": "Die Webcal-URL wird nun angezeigt. Kopiere sie und füge sie unten ein.",
  "integration.edupage.tutorial_image_alt": "EduPage-Dialog zum Aktivieren von Webcal für den Stundenplan",
  "integration.edupage.url_label": "EduPage-Webcal-URL",
  "integration.edupage.url_placeholder": "https://deine-schule.edupage.org/webcal?pwd=...",
  "integration.edupage.url_required": "Bitte gib Deine EduPage-Webcal-URL ein.",
  "integration.edupage.invalid_feed_url": "Dieser EduPage-Stundenplan konnte nicht verbunden werden. Bitte prüfe, ob Du die Webcal-URL aus EduPage eingefügt hast.",
  "integration.edupage.connected_courses.description": "Verknüpfe Deine Teachino-Kurse mit den Fächern aus Deinem EduPage-Stundenplan.",
  "integration.edupage.external_course": "Fach in EduPage",
  "integration.bip.description": "Für Lehrkräfte in Österreich: Verbinde Teachino mit dem Bildungsportal.",
  "integration.europathek.description": "Für Lehrkräfte: Verbinde Teachino mit der EUROPATHEK.",
  "integration.cgie.description": "Für Lehrkräfte in Luxemburg: Nutze den IAM-Login des CGIE, um Teachino kostenlos zu verwenden.",
  "integration.digreg.description": "Für Lehrkräfte in Südtirol: Verbinde Teachino mit dem Digitalen Register, um Deinen Stundenplan und das Klassenbuch zu synchronisieren. Deine Schule muss die Integration im Digitalen Register aktivieren.",
  "integration.microsoft.description": "Verknüpfe Dein Microsoft-Profil mit Teachino, um auf Dein OneNote-Notizbuch und Deine OneDrive-Dateien zuzugreifen.",
  "integration.ical.external_course": "Kalendereintragsname",
  "integration.teachino.external_course": "Kurs in Teachino",
  "integration.untis.external_course": "Unterricht in WebUntis",
  "integration.digreg.external_course": "Bezeichnung im Digitalen Register",
  "integration.microsoft.external_course": "Team in Microsoft Teams",
  "integration.cgie.connect.title": "Bei Teachino registrieren",
  "integration.cgie.connect.description": "Im Rahmen des KI-Kompass steht Teachino allen Lehrkräften in Luxemburg kostenlos zur Verfügung.",
  "integration.cgie.connect.start": "Mit Teachino starten",
  "integration.cgie.connect.login": "Ich verwende Teachino bereits",
  "integration.cgie.connect.terms_prefix": "Es gelten die",
  "integration.cgie.connect.terms_suffix": "von Teachino im Rahmen der Zusammenarbeit zwischen Teachino und dem Script. Daten werden nach 24 Monaten Inaktivität gelöscht.",
  "integration.connect_course.title": "Unterricht mit Teachino verknüpfen",
  "integration.connect_course.description": "Welchen Teachino-Kurs möchtest Du mit \"{{externalCourseName}}\" verknüpfen?",
  "integration.connect_course.ignore": "{{courseName}} nicht mehr anzeigen",
  "integration.connect_course.ignore_confirm": "Die Stunden von {{courseName}} verschwinden damit auch aus deinem Stundenplan. Rückgängig machen kannst du das jederzeit unter „Stundenplan bearbeiten“.",
  "integration.connect_course.select": "Kurs wählen",
  "integration.connect_course.successful_connect": "Kurs verknüpft!",
  "integration.connect_course.successful_ignore": "Kurs ausgeblendet!",
  "integration.connect_course.ignore_title": "Der Kurs ist ausgeblendet.",
  "integration.connect_course.ignore_restore": "{{courseName}} wieder anzeigen",
  "integration.course_connected.description": "{{externalCourseName}} ist mit {{internalCourseName}} in Teachino verknüpft.",
  "integration.connect_course.create": "{{courseName}} erstellen",
  "integration.connect_course.header": "Wie soll {{courseName}} in Teachino aufscheinen?",
  "integration.connect_course.new": "Als neuer Kurs",
  "integration.connect_course.connect": "oder mit einem bestehenden Kurs verknüpfen",
  "integration.settings.connected_courses.description": "Verknüpfe Deine Kurse aus Teachino, damit Daten synchronisiert werden können.",
  "integration.settings.course_ignored": "Ausgeblendet",
  "integration.settings.remove_course_title": "Verknüpfung aufheben",
  "integration.settings.course_not_connected": "Nicht verknüpft",
  "integration.settings.course_connect": "Kurs verknüpfen",
  "integration.export_classregister.title": "Lehrstoff in das Klassenbuch schreiben",
  "integration.export_classregister.send_to_classregister": "Klassenbuch schreiben",
  "integration.export_classregister.send_to_classregister_successfull": "Klassenbuch ausgefüllt",
  "integration.export_classregister": "Klassenbuch",
  "integration.export_classregister.copy": "Text kopieren",
  "integration.export_classregister.copy_success_title": "Text in Zwischenablage kopiert",
  "onboarding_tutorial.enter_courses_description_1": "Bitte erstelle einen Kurs pro Fach und Klasse, den Du unterrichtest.\nWenn Du zwei Fächer in einer Klasse unterrichtest, erstelle bitte zwei Kurse.",
  "onboarding_tutorial.enter_courses_more_lines": "weiteren Kurs hinzufügen",
  "onboarding_tutorial.enter_courses_button": "Mit Teachino starten",
  "onboarding_tutorial.enter_courses_extra_note": "Du kannst später weitere Kurse erstellen und Farben ändern",
  "onboarding_tutorial.enter_courses_placeholder_1": "Geographie",
  "onboarding_tutorial.enter_courses_placeholder_2": "Geschichte",
  "onboarding_tutorial.enter_courses_placeholder_3": "Geschichte",
  "feature_course.onboarding.progress.aria_label": "Onboarding-Fortschritt",
  "feature_course.onboarding.step_label.country": "Land",
  "feature_course.onboarding.country.title": "Willkommen bei Teachino",
  "feature_course.onboarding.country.description": "Damit alles zu deinem Schulalltag passt, starten wir mit ein paar kurzen Fragen. In welchem Land unterrichtest du?",
  "feature_course.onboarding.country.other_option": "Anderes Land",
  "feature_course.onboarding.country.other_input_label": "Land",
  "feature_course.onboarding.country.other_placeholder": "Eigenes Land eingeben",
  "feature_course.onboarding.state.title": "Bundesland",
  "feature_course.onboarding.state.other_option": "Anderes Bundesland",
  "feature_course.onboarding.state.other_input_label": "Bundesland",
  "feature_course.onboarding.state.other_placeholder": "Eigenes Bundesland eingeben",
  "feature_course.onboarding.school_type.title": "Welche Schulart?",
  "feature_course.onboarding.school_type.description": "Die KI passt Ergebnisse an Deine Schule an",
  "feature_course.onboarding.school_type.other_option": "Andere Schulart",
  "feature_course.onboarding.school_type.other_input_label": "Schulart",
  "feature_course.onboarding.school_type.other_placeholder": "Eigene Schulart eingeben",
  "feature_course.onboarding.subject.title": "Mit welchem Fach möchtest Du starten?",
  "feature_course.onboarding.subject.description": "Du kannst später weitere Fächer hinzufügen.",
  "feature_course.onboarding.subject_group.languages": "Sprachen",
  "feature_course.onboarding.subject_group.natural_sciences": "Naturwissenschaften",
  "feature_course.onboarding.subject_group.social_studies": "Gesellschaft",
  "feature_course.onboarding.subject_group.vocational": "Beruflich",
  "feature_course.onboarding.subject_group.mandatory": "Pflichtgegenstände",
  "feature_course.onboarding.subject_group.other": "Weitere Fächer",
  "feature_course.onboarding.subject.other_option": "Anderes Fach",
  "feature_course.onboarding.subject.other_placeholder": "Eigenes Fach eingeben",
  "feature_course.onboarding.subject.other_label": "Fach eingeben",
  "feature_course.onboarding.subject.other_lesson_language_label": "Sprache des Unterrichts",
  "feature_course.onboarding.subject.other_lesson_language_placeholder": "Sprache des Unterrichts eingeben",
  "feature_course.onboarding.subject.default_course_language": "Deutsch",
  "feature_course.onboarding.class_level.title": "In welcher Klasse unterrichtest Du {{subject}}?",
  "feature_course.onboarding.class_level.description": "Du kannst später weitere Klassen hinzufügen.",
  "feature_course.onboarding.class_level.other_option": "Andere Klasse",
  "feature_course.onboarding.class_level.other_input_label": "Klasse",
  "feature_course.onboarding.class_level.other_placeholder": "Eigene Klasse eingeben",
  "feature_course.onboarding.summary.title": "Fast fertig!",
  "feature_course.onboarding.summary.description": "Überprüfe und passe Deinen Kurs an",
  "feature_course.onboarding.summary.more_courses_hint": "Du kannst später jederzeit weitere Kurse erstellen.",
  "feature_course.onboarding.summary.course_name_label": "Kursname",
  "feature_course.onboarding.summary.class_name_label": "Klasse",
  "feature_course.onboarding.summary.class_name_label_example": "Klasse (z. B. {{example}})",
  "feature_course.onboarding.summary.subject_name_label": "Fach",
  "feature_course.onboarding.summary.course_name_preview": "Dein Kursname",
  "feature_course.onboarding.summary.color_label": "Farbe",
  "feature_course.onboarding.action.create_course": "Kurs erstellen",
  "feature_course.onboarding.integration.action.import_courses": "Kurse importieren",
  "feature_course.onboarding.integration.connecting.title": "Deine Kurse werden importiert …",
  "feature_course.onboarding.integration.connecting.progress": "{{done}} von {{total}} Kursen verarbeitet",
  "feature_course.onboarding.integration.partial_error": "Einige Kurse konnten nicht automatisch verbunden werden. Du kannst sie jederzeit auf der Kursseite verbinden.",
  "feature_course.onboarding.common.other": "Sonstiges",
  "feature_course.onboarding.common.type_own_value": "Eigenen Wert eingeben",
  "item_detail.teachino_ai_questions": "Fragen",
  "item_detail.teachino_ai_questions.reproduction.title": "Reproduktion",
  "item_detail.teachino_ai_questions.reproduction.description": "Wiedergabe von Sachverhalten",
  "item_detail.teachino_ai_questions.reorganisation.title": "Reorganisation",
  "item_detail.teachino_ai_questions.reorganisation.description": "Selbständiges Erklären, Bearbeiten und Ordnen",
  "item_detail.teachino_ai_questions.reflection.title": "Reflexion",
  "item_detail.teachino_ai_questions.reflection.description": "Interpretieren und Bewerten, Zusammenhänge erkennen, Probleme lösen",
  "ai_setting.language": "In welcher Sprache soll die KI Ergebnisse generieren?",
  "ai_setting.description": "Mit diesen Einstellungen kannst Du die Vorschläge der Teachino-KI beeinflussen. Die KI in Teachino bezieht sich auf diese Einstellungen und auf die verwendeten Materialien.",
  "ai_setting.curriculum_other": "Eigenes Curriculum eingeben",
  "ai_setting.age": "Wie alt sind ungefähr die Schüler:innen, für die die KI-Ergebnisse verwendet werden?",
  "ai_settings.age_placeholder": "Alter der Schüler:innen in Jahren",
  "ai_setting.subject": "Gib das Fach möglichst genau an",
  "ai_setting.curriculum": "Lehrplan / Curriculum",
  "ai_setting.curriculum_country": "Land",
  "ai_setting.curriculum_state": "Region",
  "ai_setting.curriculum_name": "Schultyp",
  "ai_setting.curriculum_description": "Kopiere den Lehrplan, das Kerncurriculum oder das Schulcurriculum in das Textfeld. Die Teachino-KI kann sich dann darauf beziehen. Dieser Text kann bis zu 18.000 Zeichen lang sein und sollte nur die relevanten Bereiche für Jahrgang/Fach enthalten.",
  "ai_setting.curriculum_placeholder": "Du kannst den gesamten Text unformatiert hier einfügen",
  "ai_setting.curriculum_maxlength": "Lehrplan / Curriculum darf maximal {{max_length}} Zeichen haben. Längere Texte werden abgeschnitten.",
  "ai_setting.curriculum.school_type": "Schulform",
  "ai_setting.curriculum.subject": "Fach",
  "ai_setting.curriculum.class_level": "Schulstufe / Jahrgang",
  "ai_setting.curriculum.disclaimer": "<strong>Dein Lehrplan steht nicht zur Auswahl?</strong> Kein Problem! Wähle einfach <strong>\"eigenes Curriculum eingeben\"</strong> aus, kopiere Deinen Lehrplan und hinterlege diesen im entsprechenden Textfeld. <strong>Du brauchst Hilfe oder hast noch Fragen?</strong> Schau gerne auf unserer <a class=\"underline text-primary-500\" href=\"https://www.teachino.io/hilfe#faq\" target=\"_blank\">Hilfe-Seite</a> vorbei.",
  "ai_setting.checkmarks.age": "Alter der Schüler:innen",
  "ai_setting.checkmarks.subject": "Fach",
  "ai_setting.checkmarks.language": "Sprache des Unterrichts",
  "ai_setting.checkmarks.curriculum_available": "Lehrplan vorhanden",
  "ai_setting.cta_settings.description": "Zu diesem Kurs sind noch keine KI-Einstellungen hinterlegt. Gib Alter, Fach, Lehrplan, … ein, um die Ergebnisse zu verbessern.",
  "ai_setting.cta_settings.button": "Daten eingeben",
  "ai_setting.cta_curriculum.description": "Für noch bessere Ergebnisse lade Deinen Lehrplan hoch.",
  "ai_setting.cta_curriculum.button": "Lehrplan eingeben",
  "ai.error.cta": "Neu starten",
  "ai.name": "Thena – Deine persönliche KI-Assistenz",
  "ai.assistant.title": "KI-Assistenz",
  "material.ai.create.quick_actions_label": "Mit KI generieren:",
  "ai.assistant.new_chat": "Neuer KI-Chat",
  "ai.assistant.open": "Chat öffnen",
  "ai.assistant.launcher.tooltip": "KI-Assistent öffnen",
  "ai.assistant.period_context.date_only": "Die Lehrperson sieht die Lektion am {{formattedDate}}. Neue Materialien, die hier erstellt werden, sollen für den {{planningTargetDate}} eingeplant werden.",
  "ai.assistant.period_context.pill_date_only": "{{formattedDate}}",
  "ai.assistant.composer.remove_period_context": "Lektionskontext entfernen",
  "ai.assistant.generated_material.open_conversation": "Im Assistenten öffnen",
  "ai.assistant.generated_material.open_when_ready": "Die KI generiert dieses Material. Du kannst es gleich öffnen.",
  "ai.assistant.generated_material.created_in_folder": "In Ordner {{folderName}} erstellt",
  "ai.assistant.generated_material.target_folder_label": "Ordner: {{folderName}}",
  "ai.assistant.generated_material.prompt_label": "Verwendeter Generierungs-Prompt",
  "ai.material.approval.tag_create": "Material prüfen",
  "ai.material.approval.tag_rework": "Überarbeitung prüfen",
  "ai.material.approval.banner_create_title": "KI hat dieses Material erstellt",
  "ai.material.approval.banner_create_description": "Bitte prüfe den Inhalt und bestätige die Änderung, oder passe das Material an.",
  "ai.material.approval.banner_rework_title": "KI hat dieses Material überarbeitet",
  "ai.material.approval.banner_rework_description": "Bitte prüfe die Änderungen und bestätige sie, oder passe das Material an.",
  "ai.material.approval.approve_button": "Geprüft",
  "ai.assistant.close": "Schließen",
  "ai.assistant.back_to_start": "Zurück zum Start",
  "ai.assistant.back_to_chat": "Zurück zum Chat",
  "ai.assistant.mode_fullscreen": "Vollbild",
  "ai.assistant.mode_sidebar": "Seitenleiste",
  "ai.assistant.mode_floating": "Schwebend",
  "ai.assistant.display_mode": "Chatansicht",
  "ai.assistant.expand": "Vergrößern",
  "ai.assistant.collapse": "Verkleinern",
  "ai.assistant.history.title": "Chatverlauf",
  "ai.assistant.history.recent": "Letzte Unterhaltungen",
  "ai.assistant.history.conversation": "Unterhaltung",
  "ai.assistant.history.delete": "Unterhaltung löschen",
  "ai.assistant.history.show": "Alle anzeigen",
  "ai.assistant.history.load_more": "Mehr anzeigen",
  "ai.assistant.history.loading_recent": "Letzte Unterhaltungen werden geladen…",
  "ai.assistant.history.just_now": "Gerade eben",
  "ai.assistant.history.minutes_ago": "vor {{count}} Min.",
  "ai.assistant.history.hours_ago": "vor {{count}} Std.",
  "ai.assistant.history.days_ago": "vor {{count}} T.",
  "ai.assistant.history.needs_confirmation": "Bestätigung ausstehend",
  "ai.assistant.history.running": "Antwort läuft",
  "ai.assistant.history.unread": "Neue ungelesene Nachrichten",
  "ai.assistant.suggestions.title": "Vorschläge",
  "ai.assistant.suggestion.lesson.title": "Unterricht planen",
  "ai.assistant.suggestion.lesson.prompt": "Gib mir Ideen für die nächsten Unterrichtsstunden",
  "ai.assistant.suggestion.material.title": "Material erstellen",
  "ai.assistant.suggestion.material.prompt": "Erstelle ein interaktives Arbeitsblatt: ",
  "ai.assistant.suggestion.material.question": "Zu welchem Thema soll das Material sein?",
  "ai.assistant.suggestion.material.suggest_prompt": "Erstelle ein differenziertes Arbeitsblatt für meine nächste Unterrichtsstunde.",
  "ai.assistant.suggestion.support.title": "Schüler:innen unterstützen",
  "ai.assistant.suggestion.support.prompt": "Schlage Möglichkeiten vor, wie ich Schüler:innen mit Schwierigkeiten unterstützen kann.",
  "ai.assistant.suggestion.reflect.title": "Unterricht reflektieren",
  "ai.assistant.suggestion.reflect.prompt": "Hilf mir, den heutigen Unterricht zu reflektieren und die nächsten Schritte zu planen.",
  "ai.assistant.messages.load_earlier": "Frühere Nachrichten laden",
  "ai.assistant.message.copy": "Kopieren",
  "ai.assistant.message.helpful": "Hilfreich",
  "ai.assistant.message.not_helpful": "Nicht hilfreich",
  "ai.assistant.message.feedback_received": "Danke für Dein Feedback.",
  "ai.assistant.message.sending": "Wird gesendet",
  "ai.assistant.message.failed": "Nicht gesendet. Der Text wurde wiederhergestellt.",
  "ai.assistant.message.show_more": "Mehr anzeigen",
  "ai.assistant.message.show_less": "Weniger anzeigen",
  "ai.assistant.message.link_redirect_limit": "Wir konnten diesen Link nicht öffnen, da er zu oft weitergeleitet wird. Verwende die direkte URL der Zielseite oder lade das Dokument hoch.",
  "ai.assistant.attachment.unreadable": "Datei konnte nicht gelesen werden",
  "ai.assistant.attachment.unreadable_hint": "Der Inhalt dieser Datei konnte nicht ausgelesen werden, die KI-Assistenz kann sie deshalb nicht verwenden. Füge den Text direkt ein oder lade die Datei als PDF oder Bild erneut hoch.",
  "ai.assistant.composer.add_source": "Quelle hinzufügen",
  "ai.assistant.composer.attachment_limit": "Du kannst bis zu {{count}} Quellen pro Nachricht hinzufügen.",
  "ai.assistant.composer.remove_material_context": "Materialkontext entfernen",
  "ai.assistant.composer.placeholder": "KI-Assistenz fragen…",
  "ai.assistant.course_selection.section_title": "Kurse dieses Schuljahres",
  "ai.assistant.course_selection.loading": "Kurse werden geladen…",
  "ai.assistant.course_selection.error": "Kurse konnten nicht geladen werden",
  "ai.assistant.course_selection.empty": "Keine Kurse verfügbar",
  "ai.assistant.course_selection.select_course": "Kurs auswählen",
  "ai.assistant.course_selection.continue": "Wähle einen Kurs aus, um fortzufahren",
  "ai.assistant.course_selection.setup_required": "Einrichtung erforderlich",
  "ai.assistant.course_selection.owner_setup_required": "Die Kurseinstellungen müssen von der Kursleitung vervollständigt werden",
  "ai.assistant.course_setup.banner.description": "Ergänze Fach und Klasse für bessere Ergebnisse",
  "ai.assistant.course_setup.banner.action": "KI-Einstellungen vervollständigen",
  "ai.assistant.course_selection.selected": "Kurs ausgewählt",
  "ai.assistant.user_selection.other": "Etwas anderes",
  "ai.assistant.user_selection.selected": "Ausgewählt",
  "ai.assistant.user_selection.other_placeholder": "Eigene Antwort eingeben …",
  "ai.assistant.user_selection.submit": "Antwort senden",
  "ai.assistant.topic_question.suggest": "Vorschläge anzeigen",
  "ai.assistant.topic_question.subject_label": "Mein Thema",
  "ai.assistant.topic_question.subject_placeholder": "Thema eintippen …",
  "ai.assistant.topic_question.submit": "Thema senden",
  "ai.assistant.composer.send": "Nachricht senden",
  "ai.assistant.run.stop": "Antwort stoppen",
  "ai.assistant.stream.connecting": "Verbindung wird hergestellt",
  "ai.assistant.stream.reconnecting": "Verbindung wird wiederhergestellt",
  "ai.assistant.tool.working": "Arbeite…",
  "ai.assistant.tool.search_images": "Suche passende Bilder…",
  "ai.assistant.tool.read_product_guidance": "Prüfe die verfügbaren Funktionen…",
  "ai.assistant.tool.search_help_center": "Durchsuche die Hilfe…",
  "ai.assistant.tool.read_help_article": "Lese Hilfeartikel…",
  "ai.assistant.tool.search_web": "Durchsuche das Web…",
  "ai.assistant.tool.search_wikipedia": "Durchsuche Wikipedia…",
  "ai.assistant.tool.search_youtube": "Durchsuche YouTube…",
  "ai.assistant.tool.load_youtube_transcript": "Lese Videotranskript…",
  "ai.assistant.tool.load_webpage": "Lese Webseite…",
  "ai.assistant.tool.list_courses": "Lade Kurse…",
  "ai.assistant.tool.list_course_content": "Lese Kursinhalte…",
  "ai.assistant.tool.search_course_materials": "Durchsuche Kursmaterialien…",
  "ai.assistant.tool.load_materials": "Lade Materialien…",
  "ai.assistant.tool.read_course_timetable": "Prüfe Stundenplan…",
  "ai.assistant.tool.read_course_planning": "Prüfe Unterrichtsplanung…",
  "ai.assistant.tool.read_students": "Lade Schüler:innen…",
  "ai.assistant.tool.read_student_documentation": "Lese Schüler:innendokumentation…",
  "ai.assistant.tool.create_course_materials": "Erstelle Materialien…",
  "ai.assistant.tool.edit_course_material": "Überarbeite Material…",
  "ai.assistant.tool.convert_worksheet": "Konvertiere Arbeitsblatt…",
  "ai.assistant.tool.create_course_folders": "Erstelle Ordner…",
  "ai.assistant.tool.create_todo": "Erstelle Aufgabe…",
  "ai.assistant.tool.mark_todos_done": "Erledige Aufgaben…",
  "ai.assistant.tool.add_lesson_note": "Ergänze Unterrichtsnotiz…",
  "ai.assistant.tool.add_period_tags": "Füge Stunden-Tags hinzu…",
  "ai.assistant.tool.create_student_documentation": "Erstelle Schüler:innendokumentation…",
  "ai.assistant.tool.set_material_visibility": "Aktualisiere Materialsichtbarkeit…",
  "ai.assistant.tool.plan_materials_for_date": "Plane Materialien ein…",
  "ai.assistant.tool.remove_materials_from_date": "Entferne Materialien vom Termin…",
  "ai.assistant.tool.move_course_content": "Verschiebe Kursinhalt…",
  "ai.assistant.tool.copy_course_content": "Kopiere Kursinhalt…",
  "ai.assistant.tool.request_user_selection": "Bereite Auswahl vor…",
  "ai.assistant.tool.request_course_selection": "Bereite Kursauswahl vor…",
  "ai.assistant.action.default_title": "Aktion",
  "ai.assistant.action.discarded": "Verworfen",
  "ai.assistant.error.response": "Da ist etwas schiefgelaufen. Bitte versuche es erneut.",
  "ai.assistant.context.current_course": "Aktueller Kurs",
  "ai.assistant.context.current_folder": "Aktueller Ordner",
  "ai.assistant.context.current_material": "Aktuelles Material",
  "ai.assistant.context.course": "Kurs",
  "ai.assistant.context.material": "Material",
  "ai.assistant.job.cancel": "Erstellung abbrechen",
  "ai.assistant.job.cancel_all": "Alle abbrechen",
  "ai.assistant.job.review": "Prüfen",
  "ai.assistant.job.stage.create.planning": "Anfrage wird geprüft und geplant",
  "ai.assistant.job.stage.create.creating": "Inhalt wird erstellt",
  "ai.assistant.job.stage.create.preparing": "Bilder werden erstellt und Material wird aufbereitet",
  "ai.assistant.job.stage.rework.planning": "Überarbeitung wird geprüft und geplant",
  "ai.assistant.job.stage.rework.creating": "Material wird überarbeitet",
  "ai.assistant.job.stage.rework.preparing": "Änderungen werden eingearbeitet und aufbereitet",
  "ai.assistant.job.stage.conversion.planning": "Arbeitsblatt wird gelesen",
  "ai.assistant.job.stage.conversion.creating": "Aufgaben werden konvertiert",
  "ai.assistant.job.stage.conversion.preparing": "Material wird aufbereitet",
  "ai.assistant.job.stage.saving": "Material wird gespeichert",
  "ai.assistant.job.progress.queued": "In der Warteschlange",
  "ai.assistant.job.progress.step": "Schritt {{step}} von {{stepCount}} · {{stage}}",
  "ai.assistant.job.progress.elapsed": "läuft seit {{duration}}",
  "ai.assistant.job.progress.patience_hint": "Das dauert meist 1–2 Minuten. Du kannst weiterarbeiten – wir sagen Bescheid, sobald das Material fertig ist.",
  "ai.assistant.job.ready.image_omissions": "Fertig – mit Bildhinweis",
  "ai.assistant.job.image_omissions": "Ein Bild konnte nicht eingefügt werden. Das Material ist verfügbar.",
  "ai.assistant.job.image_required_missing": "Mindestens ein angefordertes Bild fehlt. Das Material ist verfügbar.",
  "ai.assistant.job.image_optional_details": "Zusatzbild nicht eingefügt – Details zur Bildsuche",
  "ai.assistant.job.image_details": "Warum fehlt das Bild?",
  "ai.assistant.job.image_reason.no_suitable_candidate": "Die Bildsuche hat keinen passenden, verifizierten Vorschlag geliefert.",
  "ai.assistant.job.image_reason.search_unavailable": "Der Bilderdienst war bei dieser Suche nicht erreichbar.",
  "ai.assistant.job.image_reason.verification_unavailable": "Die Eignung des Bildes konnte nicht zuverlässig geprüft werden.",
  "ai.assistant.job.image_reason.generation_failed": "Das Bild konnte nicht erfolgreich erstellt oder gespeichert werden.",
  "ai.assistant.job.image_reason.omitted_from_output": "Ein vorgesehenes Bild wurde nicht in das fertige Material übernommen.",
  "ai.assistant.job.image_reason.not_attempted": "Die Erstellung wurde ohne das angeforderte Bild abgeschlossen; es wurde kein Bildversuch aufgezeichnet.",
  "ai.assistant.job.ready.title": "Fertig – bereit zum Öffnen",
  "ai.assistant.job.failed.title": "Erstellung fehlgeschlagen",
  "ai.assistant.job.ready.toast": "„{{title}}“ ist fertig",
  "ai.assistant.job.ready.toast_many": "{{count}} Materialien sind fertig",
  "ai.assistant.job.ready.badge_aria_zero": "Keine fertigen Materialien im KI-Assistenten",
  "ai.assistant.job.ready.badge_aria_one": "1 fertiges Material im KI-Assistenten",
  "ai.assistant.job.ready.badge_aria_many": "{{number}} fertige Materialien im KI-Assistenten",
  "ai.assistant.job.open_material": "Material öffnen",
  "ai.assistant.job.open_preview": "Materialvorschau öffnen",
  "ai.personification": "Thena – Deine KI-Assistenz",
  "ai.you": "Du",
  "ai.prompt.placeholder": "Wie kann ich Dir heute helfen?",
  "ai.prompt.continue": "Tippe Deine Antwort ein …",
  "ai.prompt.hint.1": "Übersetze das Ergebnis",
  "ai.prompt.hint.1_prompt": "Übersetze das Ergebnis nach …",
  "ai.prompt.hint.2": "Kürze das Ergebnis",
  "ai.prompt.hint.2_prompt": "Kürze das Ergebnis",
  "ai.prompt.hint.3": "Verlängere das Ergebnis",
  "ai.prompt.hint.3_prompt": "Verlängere das Ergebnis",
  "ai.prompt.hint.4": "Vereinfache das Ergebnis",
  "ai.prompt.hint.4_prompt": "Vereinfache das Ergebnis auf Sprachniveau A2",
  "ai.prompt.hint.5": "Was könnte ich noch machen?",
  "ai.prompt.hint.5_prompt": "Mache mir fünf Vorschläge, welche kurzen KI-Prompts ich zur Weiterbearbeitung des Ergebnisses in Textform nutzen könnte.",
  "ai.tasks.show_more": "Weitere anzeigen",
  "ai.tasks.show_less": "Weniger anzeigen",
  "ai.disclaimer": "Die KI kann Fehler machen. Bitte keine personenbezogenen Daten eingeben.",
  "ai.disclaimer_students": "Bei diesem Chat handelt es sich um Künstliche Intelligenz. Die Antworten werden mit KI generiert und können ungenau oder fehlerhaft sein. Behalte eine kritische Haltung und prüfe die Informationen bei Bedarf. Teile keine persönlichen Daten. Viel Spaß beim Chatten!",
  "ai.area_youtube_error.description": "Thena konnte die Untertitel nicht lesen. Bitte kopiere die Untertitel in das Textfeld unten, damit Thena Materialien generieren kann.",
  "ai.area_youtube.title": "KI für Videos",
  "ai.area_youtube.description": "Thena liest die Untertitel von Videos und erstellt dazu passende Materialien. Gib einfach den Link zum Video ein. Videos ohne Untertitel kann Thena noch nicht lesen.",
  "ai.area_youtube.label": "Link zum YouTube-Video",
  "ai.area_youtube.error": "Bitte gib einen gültigen Link zu einem YouTube-Video ein.",
  "ai.area_youtube.iframe_error": "Fehler beim Anzeigen des Videos",
  "ai.area_docs.title": "KI für Dokumente",
  "ai.area_docs.description": "Thena liest Texte in Dokumenten und erstellt dazu passende Materialien.",
  "ai.area_docs.types": "Unterstützte Dateien:",
  "ai.area_websites.title": "KI für Webseiten",
  "ai.area_websites.description": "Thena liest den Text auf der Webseite und erstellt dazu passende Materialien.",
  "ai.area_text.title": "KI für Texte",
  "ai.area_text.description": "Thena liest den eingegebenen Text und erstellt dazu passende Materialien. Als Text kannst Du z. B. auch Untertitel von einem Video hochladen.",
  "ai.area_images.title": "KI für Bilder",
  "ai.area_images.description": "Thena erkennt Texte auf Fotos, liest diese und erstellt dazu passende Materialien.",
  "ai.course_settings_age_missing.before": "(Tipp: Du kannst das Alter Deiner Schüler in den",
  "ai.course_settings_age_missing.label": "Kurseinstellungen eingeben",
  "ai.course_settings_age_missing.after": ", um es für zukünftige Chats zu speichern. Je mehr Informationen ich über deinen Kurs habe, desto besser werden meine Antworten.) ",
  "onboarding_tutorial.enter_courses_header": "Letzter Schritt: Kurse erstellen",
  "library.title": "Materialien & Ordner",
  "library.new_items": "Neue Materialien",
  "library.search_hint": "Bitte gib mindestens 3 Zeichen ein",
  "library.add_dates": "Start- und Enddatum",
  "library.add_dates_placeholder": "Start- und Enddatum wählen",
  "library.remove_dates": "Zeitraum löschen",
  "library.remove_topic": "\"{{topic}}\" löschen?",
  "library.remove_course_topic": "\"{{topic}}\" aus Kurs entfernen?",
  "library.remove_item": "\"{{item}}\" löschen?",
  "library.remove_topics": "{{number}} Ordner löschen?",
  "library.remove_course_topics": "{{number}} Ordner aus Kurs entfernen?",
  "library.remove_items": "{{number}} Materialien löschen?",
  "library.remove_topic.confirm": "{{topic}} löschen",
  "library.remove_course_topic.confirm": "{{topic}} aus Kurs entfernen",
  "library.remove_topics.confirm": "Ordner löschen",
  "library.remove_course_topics.confirm": "Ordner aus Kurs entfernen",
  "library.remove_item.confirm": "{{item}} löschen",
  "library.remove_items.confirm": "{{number}} Materialien löschen",
  "library.remove_topic_pre": "Willst Du",
  "library.remove_course_topic_pre": "Willst Du",
  "library.remove_topic_post": "endgültig löschen? Der Ordner und alle enthaltenen Materialien werden dadurch unwiderruflich gelöscht.",
  "library.remove_course_topic_post": "aus dem Kurs entfernen? Alle Planungsdaten gehen verloren.",
  "library.remove_item_pre": "Willst Du",
  "library.remove_item_post": "endgültig löschen? Das Material wird unwiderruflich gelöscht.",
  "library.remove_topics.description": "Willst du {{number}} Ordner endgültig löschen? Die Ordner und alle enthaltenen Materialien werden dadurch unwiderruflich gelöscht.",
  "library.remove_course_topics.description": "Willst du {{number}} Ordner aus dem Kurs entfernen?",
  "library.remove_items.description": "Willst du {{number}} Materialien endgültig löschen? Die Materialien werden dadurch unwiderruflich gelöscht",
  "library.remove_topic_force_pre": "Der Ordner ",
  "library.remove_item_force_pre": "Das Material ",
  "library.remove_topic_force_post": "wird in den (offenen) Kursen ",
  "library.remove_item_force_post": "wird in den (offenen) Kursen ",
  "library.remove_topic_force_end": "verwendet. Willst Du ihn zusammen mit allen enthaltenen Materialien löschen und auch alle damit verknüpften Planungen in Vergangenheit und Zukunft entfernen?",
  "library.remove_item_force_end": "verwendet. Willst Du das Material löschen und auch alle damit verknüpften Planungen in Vergangenheit und Zukunft entfernen?",
  "library.remove_topics_force_pre": "Die Ordner werden in den (offenen) Kursen ",
  "library.remove_items_force_pre": "Die Materialien werden in den (offenen) Kursen ",
  "library.remove_topics_force_end": "verwendet. Willst Du sie zusammen mit allen enthaltenen Materialien löschen und auch alle damit verknüpften Planungen in Vergangenheit und Zukunft entfernen?",
  "library.remove_items_force_end": "verwendet. Willst Du die Materialien löschen und auch alle damit verknüpften Planungen in Vergangenheit und Zukunft entfernen?",
  "library.remove_item.success_one": "Material gelöscht",
  "library.remove_item.success_many": "Materialien gelöscht",
  "library.topics_autocomplete.placeholder": "Ordner suchen",
  "library.topics_autocomplete.current_course": "Ordner im Kurs",
  "library.topics_autocomplete.all_courses": "Alle Ordner",
  "library.topics_autocomplete.create_description": "In welchem Ordner soll das Material erstellt werden?",
  "library.topics_autocomplete.new_topic": "Neuer Ordner",
  "library.topics_autocomplete.back": "Zurück zur Liste",
  "library.duplicate_items.duplicate_one_description": "{{item}} kopieren",
  "library.duplicate_items.duplicate_many_description": "{{number}} Materialien kopieren",
  "library.duplicate_items.confirm": "Nach {{topic}} kopieren",
  "library.duplicate_items.success": "Material kopiert",
  "library.move_items.move_one_description": "{{item}} verschieben",
  "library.move_items.move_many_description": "{{number}} Materialien verschieben",
  "library.move_items.confirm": "Nach {{topic}} verschieben",
  "library.move_items.success": "Material verschoben",
  "library.add_topic_to_courses": "Ordner zu Kursen hinzufügen",
  "library.add_topic_to_courses.link": "Ordner zu weiteren Kursen hinzufügen",
  "presentation.title": "Präsentationsmodus",
  "presentation.empty.title": "Keine Materialien geplant",
  "presentation.empty.description": "Sobald die Stunde geplant wurde, kann diese hier am Beamer oder an der digitalen Tafel präsentiert werden. Du steuerst dabei, welche Abschnitte Schüler:innen sehen sollen.",
  "presentation.empty.material": "Dieses Material ist leer.",
  "create_item.new_item": "Neues Material",
  "create_item.search_topic": "Ordner wählen",
  "create_item.title_label": "Name des Materials",
  "upgrade.feature_discovered.dialog_title": "Zeit für ein Upgrade",
  "upgrade.feature_discovered.title": "Hol dir den vollen Funktionsumfang",
  "upgrade.feature_discovered.description": "Schließ jetzt eine Lizenz ab und arbeite ohne Limits weiter.",
  "upgrade.feature_discovered.cta": "Mehr erfahren",
  "upgrade.soft_paywall.grace_days_left": "Noch {{days}} Tage kostenlos nutzen.",
  "upgrade.soft_paywall.trial_days_left": "Noch {{days}} Testtage.",
  "upgrade.feature.ai.perk.collaboration": "Zusammenarbeit in Fachgruppen, Teamteaching und Vertretungen",
  "upgrade.feature.storage.title": "Unlimitierter Speicherplatz",
  "upgrade.feature.presentation.title": "Präsentationsmodus",
  "upgrade.feature.presentation.description": "Präsentiere deine Materialien in der Klasse an der digitalen Tafel oder über den Beamer.",
  "upgrade.feature.student_evaluation.title": "Auswertung & Rückmeldung",
  "upgrade.feature.student_evaluation.description": "Sieh die Auswertung pro Schüler:in und pro Frage ein und gib individuelle Rückmeldungen zu den Abgaben.",
  "upgrade.feature.ipi.title": "Unbegrenzt Material mit KI erstellen",
  "upgrade.feature.ipi.description": "Generiere interaktive Arbeitsblätter, Aufgaben und Unterrichtsideen – ohne Limit.",
  "upgrade.feature.integration.description": "Stundenplan & Klassenbuch verknüpfen und immer aktuell halten.",
  "upgrade.feature.school.perk.training": "Begleitung und Schulung des Kollegiums (kostenlose Webinare, individuelle Betreuung auf Anfrage)",
  "upgrade.feature.school.perk.student_accounts": "Persönliche Zugänge für Schüler:innen",
  "upgrade.feature.school.perk.cost_relief": "Kostenentlastung für Lehrkräfte",
  "upgrade.school.cta": "Angebot anfragen",
  "upgrade.buy.cta": "Pro-Lizenz abschließen",
  "upgrade.buy.trainee.discount": "🌱 Referendar:innen sparen auf die <strong>Lizenz für Lehrkräfte</strong>",
  "upgrade.buy.trainee.cta_two_years": "50% für 2 Jahre",
  "upgrade.buy.trainee.cta_one_year": "25% für 1 Jahr",
  "upgrade.buy.payment_cycle.option_multiple": "{{months}} Monate",
  "upgrade.buy.payment_cycle.option_one": "1 Monat",
  "upgrade.buy.payment_cycle.price": "{{price}} / Monat",
  "upgrade.buy.tag.loved": "Am beliebtesten",
  "upgrade.buy.tag.cheapest": "{{percent}}% sparen",
  "upgrade.discover.cta_school": "Schullizenz anfragen",
  "upgrade.discover.cta_school_extend": "Schullizenz verlängern",
  "upgrade.license_page.title_0": "Deine aktuellen Lizenzen",
  "upgrade.license_page.title_1": "Deine aktuelle Lizenz",
  "upgrade.license_page.title_many": "Deine aktuellen Lizenzen",
  "upgrade.license_page.upgrade.personal_licenses": "Persönliche Lizenz",
  "upgrade.license_page.upgrade.tenant_licenses": "Schullizenz",
  "upgrade.license_page.license_started_at": "Gestartet am:",
  "upgrade.license_page.license_renews_at": "Erneuert sich am:",
  "upgrade.license_page.license_expires_at": "Läuft ab am:",
  "upgrade.license_page.license_expired_at": "Abgelaufen am:",
  "upgrade.license_page.license_id": "Lizenznummer:",
  "upgrade.license_page.pro_offer_title": "Lizenz für Lehrkräfte",
  "upgrade.license_page.pro_offer_subtitle": "Alles, was du für deinen Unterricht brauchst – ohne Limits, von der Planung bis zur Rückmeldung.",
  "upgrade.license_page.features": "Enthaltene Funktionen",
  "upgrade.license_page.manage": "Verwalten",
  "upgrade.license_page.upgrade_school.title": "Lizenz für Schulen",
  "upgrade.license_page.upgrade_school.subtitle": "Ein gemeinsames System für digitalen Unterricht in der ganzen Schule",
  "upgrade.license_page.free_license_label": "Kostenlose Lizenz",
  "upgrade.license_page.dpa_signed": "AVV unterzeichnet",
  "upgrade.license_page.student_data_can_be_managed": "Schüler:innendaten können verwaltet werden",
  "upgrade.license_page.trainee_discount": "🌱 Referendar:innen sparen auf die <strong>Lizenz für Lehrkräfte</strong>",
  "upgrade.license_page.legal_billing": "Dein Abo verlängert sich automatisch um die gewählte Laufzeit. Eine Kündigung ist bis 24 Stunden vorher möglich und wird zum Laufzeitende wirksam. <a href=\"/legal/terms\" target=\"_blank\" class=\"underline\">Details in den Nutzungsbedingungen</a>",
  "upgrade.license_page.school_perk_pro": "Alles aus der Lizenz für Lehrkräfte für 5 oder mehr Lehrkräfte",
  "upgrade.feature.files_unlimited": "Unlimitierter Speicher (bis zu 50 MB pro Datei)",
  "upgrade.feature.files_restricted": "250 MB Speicherplatz",
  "upgrade.feature.daily_changes": "Tägliche Änderungen im Stundenplan (Entfälle, Vertretungen, Ferien, persönliche Termine, …)",
  "upgrade.feature.collaboration_teamteaching": "Teamteaching in Kursen",
  "upgrade.feature.collaboration_course_templates": "Zusammenarbeiten und Erstellen von Sammlungen",
  "upgrade.feature.collaboration_substitutions": "Materialien & Pläne mit Vertretungen teilen",
  "upgrade.feature.student_access": "Zugang für Schüler:innen",
  "upgrade.feature.ai_basic": "Einfache KI-Vorschläge",
  "upgrade.feature.ai_advanced": "Erweiterte KI-Vorschläge mit Bezug auf Materialien und Lehrplan/Schulcurriculum",
  "upgrade.feature.integration_timetable": "Integration mit Stundenplan & Klassenbuch",
  "upgrade.feature.presentation": "Präsentationsmodus",
  "upgrade.feature.ai_curriculum_title": "Genauere Ergebnisse mit Bezug zum Lehrplan",
  "upgrade.feature.ai_curriculum_description": "Mit einer Pro-Lizenz oder mit einer Schullizenz kannst Du zusätzlich ein Schulcurriculum hochladen oder aus vorgefertigten Lehrplänen wählen. Damit werden die Ergebnisse der KI genauer und hochwertiger.",
  "upgrade.plan.teacher_pro": "Lehrer:in Pro",
  "upgrade.plan.teachino_school": "Lizenz für Schulen",
  "upgrade.plan.cgie_pro": "Lizenz im Rahmen des KI-Kompass des Script.",
  "upgrade.plan.teacher_free": "Kostenlos",
  "upgrade.plan.teacher_free_light": "Kostenlos",
  "upgrade.plan.school_dpa_only": "AVV unterzeichnet",
  "upgrade.plan.type.friends": "Teachino Freunde & Familie",
  "upgrade.plan.teachino_school_complete": "Lizenz für Schulen inkl. KI-Paket",
  "upgrade.plan.teachino_school_trial": "Lizenz für Schulen - Testlizenz",
  "upgrade.plan.teachino_school_expired": "Lizenz für Schulen - Lizenz abgelaufen",
  "upgrade.plan.teachino_school_suedtirol": "Teachino Schule Südtirol",
  "upgrade.plan.teachino_pro_ai": "Lehrer:in Pro inkl. KI-Paket",
  "upgrade.plan.teachino_school_complete_trial": "Lizenz für Schulen inkl. KI-Paket",
  "upgrade.plan.teacher_pro_trial": "Lizenz für Lehrkräfte",
  "upgrade.plan.teacher_pro_beta": "Teachino Freunde & Familie",
  "upgrade.plan.type.paid": "Bezahlt",
  "upgrade.plan.type.free": "Kostenlos",
  "upgrade.plan.type.trial": "Kostenloser Test",
  "upgrade.plan.type.expired": "Lizenz abgelaufen",
  "upgrade.upgrade_required.title": "Upgrade notwendig!",
  "upgrade.upgrade_required.description": "Diese Funktion gibt es nur mit der Lizenz für Lehrkräfte.",
  "upgrade.upgrade_required.description_2": "Jetzt upgraden und vom vollen Funktionsumfang profitieren!",
  "upgrade.page.pricing_heading": "Wähle deine Laufzeit",
  "upgrade.usp.3": "Persönliche Termine, To-dos & Ferien",
  "upgrade.feature.personal_planning.description": "Persönliche Termine, To-dos und Ferien übersichtlich in deiner Planung verwalten.",
  "upgrade.page.feature.storage.description": "Unbegrenzter Speicherplatz für all deine Unterrichtsmaterialien.",
  "upgrade.page.feature.student_share.description": "Zugang zu Teachino per Link oder QR-Code mit Schüler:innen teilen.",
  "upgrade.page.feature.class_register.description": "Geplanten Lehrstoff direkt ins Klassenbuch (WebUntis/Digitales Register) übernehmen.",
  "upgrade.usp.4": "Integration mit WebUntis",
  "upgrade.plan.cta": "Jetzt upgraden",
  "difusion.teacher_dashboard.title": "Lehrer-Dashboard",
  "difusion.teacher_dashboard.select_class": "Klasse auswählen",
  "difusion.teacher_dashboard.students": "Schüler:innen",
  "difusion.teacher_dashboard.reload": "Neu laden",
  "difusion.teacher_dashboard.export_csv": "CSV exportieren",
  "difusion.teacher_dashboard.try_leo": "LEO testen",
  "difusion.teacher_dashboard.loading_classes": "Klassen werden geladen …",
  "difusion.teacher_dashboard.loading_students": "Schüler:innen werden geladen …",
  "difusion.teacher_dashboard.error": "Fehler",
  "difusion.teacher_dashboard.invalid_session": "Ungültige Sitzung. Bitte melde Dich erneut an.",
  "difusion.teacher_dashboard.load_students_error": "Fehler beim Laden der Schüler:innen",
  "difusion.teacher_dashboard.no_classes": "Keine Klassen verfügbar",
  "difusion.teacher_dashboard.no_students": "Keine Schüler:innen für diese Klasse gefunden",
  "difusion.teacher_dashboard.surname": "NACHNAME",
  "difusion.teacher_dashboard.name": "VORNAME",
  "difusion.teacher_dashboard.status": "STATUS",
  "difusion.teacher_dashboard.completed_conversations": "ABGESCHLOSSENE GESPRÄCHE",
  "difusion.teacher_dashboard.last_activity": "LETZTE AKTIVITÄT",
  "difusion.teacher_dashboard.chat_history": "CHATVERLAUF",
  "difusion.teacher_dashboard.class_id": "Klassen-ID",
  "difusion.teacher_dashboard.status.not_started": "Nicht gestartet",
  "difusion.teacher_dashboard.status.in_progress": "In Bearbeitung",
  "difusion.teacher_dashboard.status.completed": "Abgeschlossen",
  "difusion.teacher_dashboard.class_fallback": "Klasse {{number}}",
  "embed.error.no_auth": "Anmeldung fehlgeschlagen",
  "embed.error.no_account": "Bitte rufe Teachino über das Hauptmenü (links) auf, um zu starten. Sobald Du Dich registriert hast, siehst Du hier die geplanten Materialien der Stunde.",
  "embed.error.no_course_mapping": "Das Material dieser Stunde ist nur für Lehrkräfte sichtbar, die diese Stunde unterrichten oder vertreten.",
  "embed.error.no_course_found": "Für diesen Kurs wurden in Teachino noch keine Materialien freigegeben.",
  "embed.error.no_course_found_description": "Mit Teachino können Lehrer:innen den Unterricht digital vorbereiten und Materialien zur Verfügung stellen.",
  "embed.student.course_list.title": "Wähle deinen Kurs",
  "embed.student.course_list.description": "Du hast Zugriff auf diese Kurse in Teachino.",
  "embed.student.course_list.change_course": "Kurs wechseln",
  "embed.student.session_expired.title": "Deine Anmeldung ist abgelaufen",
  "embed.student.session_expired.description": "Bitte melde dich erneut über das Digitale Register an. Danach kommst du direkt zurück zu deinen Kursen.",
  "embed.student.session_expired.action": "Über das Digitale Register anmelden",
  "embed.student.session_expired.description_eduplaces": "Bitte melde dich erneut über Eduplaces an. Danach kommst du direkt zurück zu deinen Kursen.",
  "embed.student.session_expired.action_eduplaces": "Über Eduplaces anmelden",
  "embed.student.session_expired.description_untis": "Bitte melde dich erneut über WebUntis an. Danach kommst du direkt zurück zu deinen Kursen.",
  "embed.student.session_expired.action_untis": "Über WebUntis anmelden",
  "embed.course.day_empty": "Für dieses Datum wurden noch keine Materialien freigegeben.",
  "embed.error_generic.title": "Die Verbindung zu WebUntis konnte nicht hergestellt werden.",
  "embed.error_generic.help": "Auf Deine Bibliothek kannst Du jederzeit zugreifen. Falls der Stundenplan aus WebUntis nicht geladen wird, kannst Du unter Profil > Integration die Verbindung trennen und den Stundenplan händisch eingeben, damit Du die Unterrichtsplanung fortführen kannst.",
  "embed.error.continue": "Weiter zu Teachino",
  "period.item_context.remove": "Material von Tag entfernen",
  "period.open_period": "Stunde öffnen",
  "period.start_presentation": "Präsentation starten",
  "template.tag.topic": "Dieser Ordner befindet sich in einer Sammlung.",
  "template.tag.item": "Dieses Material befindet sich in einer Sammlung.",
  "template.topic.updates_available": "Für diesen Ordner sind Aktualisierungen verfügbar.",
  "template.topic.sync_topic_info.title": "Ordner aktualisieren",
  "template.topic.sync_topic_info.description": "Aktualisiert den Ordner (Name, Ziele, etc.). Fügt keine neuen Materialien hinzu.",
  "template.topic.sync_new_items.title": "Neue Materialien hinzufügen",
  "template.topic.sync_new_items.description": "Fügt neue Materialien aus der Sammlung hinzu. Zusätzlich erstellte eigene Materialien werden nicht geändert.",
  "template.item.updates_available": "Für dieses Material sind Aktualisierungen verfügbar.",
  "template.item.sync_item_info.title": "Material aktualisieren",
  "template.item.sync_item_info.description": "Aktualisiert das Material (Name, etc.).",
  "template.item.sync_new_snippets.title": "Neue Materialien hinzufügen oder aktualisieren",
  "template.item.sync_new_snippets.description": "Fügt neue Materialien hinzu und aktualisiert bestehende Materialien aus der Sammlung. Zusätzlich erstellte eigene Materialien werden nicht geändert.",
  "collaboration.cannot_edit_item": "Bearbeiten nicht erlaubt.",
  "collaboration.use_topic.button": "Ordner kopieren",
  "collaboration.use_topic.button_short": "Ordner kopieren",
  "collaboration.use_item.button": "Material kopieren",
  "collaboration.use_topic.choose_course": "Kurs wählen",
  "collection.material_banner.title": "Dieses Material befindet sich in einer Sammlung.",
  "collection.material_banner.description": "Kopiere es in einen Kurs, um es dort zu verwenden.",
  "collection.material_banner.copy_to_course": "In Kurs kopieren",
  "collection.copy_multiple_folders.dialog_description": "Wähle die Ordner aus „{{collection}}“, die in einen Kurs kopiert werden sollen.",
  "collection.origin_notice.folder_from": "Ordner aus {{collectionName}}",
  "collection.origin_notice.material_from": "Material aus {{collectionName}}",
  "collection.origin_notice.open_folder": "Ordner in Sammlung öffnen",
  "collection.origin_notice.edit_material": "Material in Sammlung bearbeiten",
  "collection.origin_notice.new_version_available": "Neue Version verfügbar",
  "material_card.also_used_in_course": "Auch verwendet in {{courseName}}",
  "collaboration.add_from_library.successfull": "Ordner kopiert",
  "collaboration.add_from_library.successfull_text": "Der Ordner und die Materialien wurden dupliziert und zur Sammlung hinzugefügt.",
  "collaboration.join_external_course.title": "Teamteaching",
  "collaboration.join_external_course.title_substitution": "Vertretungsstunde",
  "collaboration.join_external_course.description": "{{ownerName}} plant {{courseName}} bereits mit Teachino.",
  "collaboration.join_external_course.cta": "Teamteaching in Kurs {{courseName}} beitreten",
  "collaboration.join_external_course.cta_substitution": "Vertretung in {{courseName}} übernehmen",
  "collaboration.join_external_course.not_join": "Ich möchte den Kurs alleine planen",
  "courses.empty_title": "Noch keine Kurse",
  "courses.empty_description": "Kurse bilden Deine Klassen und Fächer aus dem aktuellen Schuljahr ab. Zum Beispiel \"10A Geographie\". Erstelle einen Kurs, um mit der Planung zu beginnen.",
  "video.modal.close": "Video schließen",
  "video.modal.title": "Video-Erklärung",
  "pathfindr.pdfsplitter.choose_pages": "Seiten wählen",
  "pathfindr.pdfsplitter.select_max_pages": "Wähle bis zu Y Seiten.",
  "pathfindr.pdfsplitter.x_of_y_pages_selected": "X von Y Seiten ausgewählt",
  "iframe.open_teachino": "Teachino öffnen",
  "iframe.redirecting": "Teachino wird geöffnet…",
  "iframe.open_teachino_hint": "Teachino öffnet sich in einem neuen Tab.",
  "iframe.not_activated_hint": "Die WebUntis-Integration ist an Deiner Schule noch nicht aktiviert. Du kannst Teachino trotzdem nutzen, Dein Konto wird aber erst mit WebUntis verbunden, sobald die Integration aktiviert ist.",
  "download.webview_not_possible": "Der Download ist in dieser App nicht möglich. Bitte öffne Teachino im Browser.",
  "link.webview_not_possible": "Das Öffnen von Links ist in dieser App nicht möglich. Bitte öffne Teachino im Browser.",
  "ai_powered_by_teachino": "KI-Chat von",
  "student_ai.home_view.empty_state.title": "Noch keine KI-Übungen vorhanden",
  "student_ai.home_view.empty_state.description": "Sobald du eine KI-Übung erstellst oder zugewiesen bekommst, erscheint sie hier.",
  "student_ai.home_view.title": "Teachino Schüler KI",
  "student_ai.assignment_view.title": "Teachino Schüler KI-Übung",
  "student_ai.assignments": "KI-Übungen",
  "student_ai.banner.title": "KI-Übungen: Künstliche Intelligenz mit Deinen Schüler:innen nutzen ✨",
  "student_ai.banner.description": "Vermittle mit den neuen KI-Übungen themenspezifisches Wissen und KI-Kompetenzen in einer sicheren, datenschutzkonformen Umgebung.",
  "student_ai.banner.cta": "Zur KI für Schüler:innen",
  "student_ai.assignments.create_assignment": "KI-Übung erstellen",
  "student_ai.assignments.share_assignment": "QR-Code und Link",
  "student_ai.assignments.start": "Starten",
  "student_ai.assignments.stop": "Stoppen",
  "student_ai.assignments.start_hint": "Klicke, um die KI-Übung zu starten",
  "student_ai.assignments.stop_hint": "KI-Übung läuft. Klicke, um sie zu stoppen",
  "student_ai.assignments.hint_assignment_inactive_before_cta": "Diese Übung ist nicht gestartet. ",
  "student_ai.assignments.hint_assignment_inactive_cta": "Starte die Übung",
  "student_ai.assignments.hint_assignment_inactive_after_cta": "damit die SuS mit der KI chatten können.",
  "student_ai.assignments.hint_assignment_active": "Deine Schülerinnen und Schüler können jetzt mit der KI chatten. Dazu kann der QR-Code gescannt oder der Link ausgesandt werden.",
  "student_ai.create_assignment.title": "KI-Übung erstellen",
  "student_ai.edit_assignment.title": "KI-Übung bearbeiten",
  "student_ai.duplicate_assignment.title": "KI-Übung kopieren",
  "student_ai.create_assignment.title.placeholder": "KI-Übung vom {{date}}",
  "student_ai.create_assignment.description": "Arbeitsauftrag für SuS",
  "student_ai.create_assignment.system_prompt": "Verhalten der KI (System-Prompt)",
  "student_ai.delete_assignment.title": "KI-Übung löschen",
  "student_ai.delete_assignment.description": "Bist Du Dir sicher, dass Du die KI-Übung \"{{assignment}}\" löschen möchtest? Dieser Schritt kann nicht rückgängig gemacht werden.",
  "student_ai.share_assignment.scan_code": "Scanne den Code, um die KI-Übung zu starten",
  "student_ai.template.import": "Mit meinen SuS nutzen",
  "student_ai.template.created_by_teachino": "Erstellt von Teachino",
  "student_ai.template.import_from_teachino": "Alle KI-Übungen entdecken",
  "student_ai.create.edit_system_prompt": "Prompt bearbeiten",
  "editor.image_selector.upload": "Bild hochladen",
  "editor.image_selector.search": "Bild suchen",
  "editor.image_selector.generate": "Bild mit KI generieren",
  "editor.image_selector.ai.prompt_label": "Gib eine Bildbeschreibung ein",
  "editor.image_selector.ai.prompt_placeholder": "Tippe den Prompt für das KI-generierte Bild hier ein",
  "editor.image_selector.ai.style": "Stil",
  "editor.image_selector.ai.style.realistic": "Realistisch",
  "editor.image_selector.ai.style.artistic": "Künstlerisch",
  "editor.image_selector.ai.style.cartoon": "Cartoon",
  "editor.image_selector.ai.style.sketch": "Sketch",
  "editor.image_selector.ai.style.watercolor": "Wasserfarbe",
  "editor.image_selector.ai.style.minimalist": "Minimalistisch",
  "editor.image_selector.ai.author_name": "KI-generiert",
  "editor.image_selector.ai.cta": "Bild generieren",
  "editor.image_selector.search.label": "Suchbegriff",
  "editor.image_selector.libraries.empty": "Keine Bildbibliotheken verfügbar",
  "editor.image_selector.libraries.recent": "Zuletzt verwendet",
  "editor.image_selector.libraries.all": "Alle Lehrwerke",
  "editor.image_selector.libraries.search": "Lehrwerk suchen",
  "editor.image_selector.ai.results": "Generierte Bilder",
  "editor.image_selector.tab.upload": "Bild hochladen",
  "editor.image_selector.tab.search": "Bild suchen",
  "editor.image_selector.tab.ai": "KI-Generieren",
  "editor.image_selector.ai.paywall.title": "Bilder mit KI für deine Materialien erstellen",
  "editor.image_selector.ai.paywall.description": "Beschreibe, was du brauchst, und erstelle passende Bilder direkt im Material-Editor. Schließ eine Lizenz ab, um KI-Bilder zu erstellen.",
  "editor.image_selector.tab.loading": "Das Bild wird gespeichert",
  "editor.tools.list.bulleted_list.name": "Aufzählung",
  "editor.tools.list.ordered_list.name": "Nummerierung",
  "editor.tools.details.name": "Klappliste",
  "editor.tools.callout.name": "Merksatz",
  "editor.tools.callout.color": "Farbe",
  "editor.tools.table.name": "Tabelle",
  "editor.tools.table.add_row_below": "Zeile unterhalb einfügen",
  "editor.tools.table.add_row_above": "Zeile oberhalb einfügen",
  "editor.tools.table.add_header_row": "Titelzeile",
  "editor.tools.table.add_column_left": "Spalte links einfügen",
  "editor.tools.table.add_column_right": "Spalte rechts einfügen",
  "editor.tools.table.add_header_column": "Titelspalte",
  "editor.tools.table.delete_row": "Zeile löschen",
  "editor.tools.table.delete_column": "Spalte löschen",
  "editor.tools.table.delete": "Tabelle löschen",
  "editor.tools.text_color.name": "Textfarbe",
  "editor.tools.text_color_background.name": "Farbe & Hintergrund",
  "editor.tools.highlight.name": "Hervorheben",
  "editor.tools.align_left.name": "Linksbündig",
  "editor.tools.align_center.name": "Zentriert",
  "editor.tools.align_right.name": "Rechtsbündig",
  "editor.tools.align_justify.name": "Blocksatz",
  "editor.tools.mathematics.name": "Formel",
  "editor.tools.bold.name": "Fett",
  "editor.tools.italic.name": "Kursiv",
  "editor.tools.underline.name": "Unterstrichen",
  "editor.tools.strike.name": "Durchgestrichen",
  "editor.tools.code.name": "Code",
  "editor.tools.code.note": "Lehrer-Notiz",
  "editor.tools.clear_format.name": "Formatierung entfernen",
  "editor.tools.image": "Bild",
  "editor.tools.image.caption.label": "Bildunterschrift",
  "editor.tools.image.caption.placeholder": "Beschreibe das Bild",
  "editor.tools.image.source": "[Quelle]",
  "editor.tools.file": "Datei",
  "editor.tools.link": "Link",
  "editor.tools.youtube": "YouTube",
  "editor.tools.heading.name": "Überschrift",
  "editor.tools.heading.prose": "Fließtext",
  "editor.tools.heading.heading_1": "Titel",
  "editor.tools.heading.heading_2": "Untertitel",
  "editor.tools.heading.heading_3": "Überschrift 3",
  "keyboard.modifier.windows": "Strg",
  "keyboard.modifier.mac": "command",
  "keyboard.shift": "Umschalt",
  "student_ai.upgrade_banner_before": "Mit der kostenlosen Lizenz für Lehrkräfte kannst du die Schüler-KI in dieser Vorschau ausprobieren. Die Schüler-KI gefällt dir? Dann ",
  "student_ai.upgrade_banner_cta": "hol Dir jetzt die Pro-Lizenz",
  "student_ai.upgrade_banner_after": "🏅, um die Übungen ganz einfach mit Deinen Schüler:innen zu teilen.",
  "material.default_name": "Unbenanntes Material",
  "material.block_menu.text": "Text",
  "material.block_menu.open_question": "Offene Frage",
  "material.block_menu.multiple_choice": "Multiple-Choice-Frage",
  "material.block_menu.matching": "Zuordnungsaufgabe",
  "material.editor.matching.badge": "Zuordnungsaufgabe",
  "material.editor.matching.instruction_placeholder": "Tippe hier die Aufgabenstellung ein, z. B. „Finde die passenden Übersetzungen“.",
  "material.editor.matching.no_instruction": "Keine Aufgabenstellung",
  "material.editor.matching.left_placeholder": "Begriff (links)",
  "material.editor.matching.right_placeholder": "Passender Begriff (rechts)",
  "material.editor.matching.add_pair": "Paar hinzufügen",
  "material.editor.matching.reorder": "Verschieben",
  "material.editor.matching.connect_hint": "Verbinde die zusammengehörenden Begriffe: Ziehe eine Linie von links nach rechts oder tippe nacheinander auf zwei Begriffe.",
  "material.editor.matching.read_hint": "Halte einen Begriff gedrückt, um den ganzen Text zu lesen.",
  "material.editor.matching.peek_label": "Vollständiger Text",
  "material.editor.matching.submit": "Abgeben",
  "material.editor.matching.redo": "Zuordnung überarbeiten",
  "material.editor.matching.reset": "Zurücksetzen",
  "material.editor.matching.validation.min_pairs": "Füge mindestens zwei vollständige Paare hinzu.",
  "material.editor.matching.feedback.correct": "Super! Alle Paare sind richtig zugeordnet.",
  "material.editor.matching.feedback.partially": "Teilweise richtig. Prüfe deine Zuordnung und versuche es erneut.",
  "material.editor.matching.feedback.incorrect": "Noch nicht korrekt. Prüfe deine Zuordnung und versuche es erneut.",
  "material.editor.matching.state.correct": "Richtig zugeordnet",
  "material.editor.matching.state.incorrect": "Falsch zugeordnet",
  "material.editor.matching.shuffle_hint": "Hinweis: Für die Schüler:innen wird die rechte Spalte automatisch gemischt.",
  "material.block_menu.listening": "Hörtext",
  "material.block_menu.gap_text": "Lückentext",
  "material.tab_edit": "Bearbeiten",
  "material.tab_preview": "Vorschau",
  "material.tab_share": "Austeilen",
  "material.tab_evaluate": "Auswerten",
  "material.ai": "KI",
  "material.ai_suggestions.custom_prompt": "Prompt eingeben",
  "material.ai_edit.title": "Material mit KI überarbeiten",
  "material.ai_edit.paywall.description": "Schließ jetzt eine Lizenz ab, um Unterrichtsmaterialien mit KI zu überarbeiten.",
  "material.ai_create.title": "Material mit KI erstellen",
  "material.ai_edit.placeholder": "Tippe ein, wie die KI das Material überarbeiten soll",
  "material.ai_edit.suggestions_title": "Vorschläge",
  "material.ai.edit.suggestion_1_label": "Vereinfachen",
  "material.ai_edit.suggestion_1": "Vereinfache das gesamte Material",
  "material.ai.edit.suggestion_2_label": "Schwerpunkt ändern",
  "material.ai_edit.suggestion_2": "Ändere den Schwerpunkt des gesamten Materials auf:",
  "material.ai.edit.suggestion_3_label": "Übersetzen",
  "material.ai_edit.suggestion_3": "Übersetze das Material nach:",
  "material.ai_edit.suggestion_3_question": "In welche Sprache möchtest du das Material übersetzen?",
  "material.ai_edit.suggestion_3_other": "Andere Sprache",
  "material.ai_edit.suggestion_3_placeholder": "Sprache eintippen …",
  "material.ai.edit.suggestion_4_label": "Interaktive Aufgaben",
  "material.ai_edit.suggestion_4": "Ergänze passende interaktive Aufgaben zum Material.",
  "material.ai.edit.suggestion_5_label": "Vertiefen",
  "material.ai_edit.suggestion_5": "Vertiefe das Material inhaltlich.",
  "material.ai.edit.suggestion_6_label": "Kürzen",
  "material.ai_edit.suggestion_6": "Kürze das Material auf das Wesentliche.",
  "material.ai.edit.suggestion_7_label": "Aufgaben hinzufügen",
  "material.ai_edit.suggestion_7": "Füge weitere Aufgaben mit folgenden Operatoren hinzu:",
  "material.ai.edit.suggestion_8_label": "Zusatzaufgaben",
  "material.ai_edit.suggestion_8": "Ergänze vertiefende Knobelaufgaben für Schüler:innen, die früher fertig sind.",
  "material.ai.edit.suggestion_9_label": "Struktur verbessern",
  "material.ai_edit.suggestion_9": "Gestalte das Material übersichtlicher, indem du klare Überschriften, sinnvolle Sinnabschnitte und Absätze nutzt.",
  "material.ai.edit.suggestion_10_label": "Zusammenfassen",
  "material.ai_edit.suggestion_10": "Erstelle am Ende eine kurze Zusammenfassung der Kernaussagen.",
  "material.ai.edit.suggestion_11_label": "Neu generieren",
  "material.ai_edit.suggestion_11": "Erstelle das gesamte Material neu.",
  "material.ai.create.suggestion_1_label": "Arbeitsblatt",
  "material.ai.create.suggestion_1": "Erstelle ein Arbeitsblatt zum Thema: ",
  "material.ai.create.suggestion_1_question": "Zu welchem Thema soll das Arbeitsblatt sein?",
  "material.ai.create.suggestion_1_no_topic": "Erstelle ein Arbeitsblatt.",
  "material.ai.create.suggestion_2_label": "Stundenverlauf",
  "material.ai.create.suggestion_2": "Erstelle einen (tabellarischen) Stundenverlauf zum Thema: ",
  "material.ai.create.suggestion_2_question": "Zu welchem Thema soll der Stundenverlauf sein?",
  "material.ai.create.suggestion_2_no_topic": "Erstelle einen (tabellarischen) Stundenverlauf.",
  "material.ai.create.suggestion_3_label": "Interaktive Übung",
  "material.ai.create.suggestion_3": "Erstelle eine interaktive Übung zum Thema: ",
  "material.ai.create.suggestion_3_question": "Zu welchem Thema soll die interaktive Übung sein?",
  "material.ai.create.suggestion_3_no_topic": "Erstelle eine interaktive Übung.",
  "material.ai.create.suggestion_4_label": "Stundeneinstieg",
  "material.ai.create.suggestion_4": "Erstelle einen (motivierenden, schülerorientierten, problemorientierten) Stundeneinstieg zum Thema: ",
  "material.ai.create.suggestion_4_question": "Zu welchem Thema soll der Stundeneinstieg sein?",
  "material.ai.create.suggestion_4_no_topic": "Erstelle einen (motivierenden, schülerorientierten, problemorientierten) Stundeneinstieg.",
  "material.ai.create.suggestion_5_label": "Ideen für die nächste Stunde",
  "material.ai.create.suggestion_5": "Entwickle Ideen für die nächste Unterrichtsstunde.",
  "material.ai_state.generated": "Material wurde generiert",
  "material.ai_state.reworking": "KI überarbeitet das Material…",
  "material.ai_state.undo": "Rückgängig",
  "material.ai_state.save_as_new": "Als neues Material speichern",
  "material.ai_save_as_new.description": "Das Ergebnis wird als neues Material gespeichert. Damit können z. B. differenzierte Versionen eines Materials erstellt werden.",
  "material.ai_save_as_new.name_label": "Name des neuen Materials",
  "material.ai_save_as_new.name_placeholder": "Name des neuen Materials",
  "material.ai_save_as_new.copy_suffix": " (Kopie)",
  "material.ai_save_as_new.success_title": "Neues Material gespeichert",
  "material.ai_save_as_new.success_message": "Das neue Material wurde erstellt und geöffnet.",
  "material.details": "Details",
  "material.empty_state": "Setze Deine Idee um: Einfach lostippen, KI fragen oder Blöcke hinzufügen.",
  "material.create": "Material erstellen",
  "material.edit_details.title": "Details des Materials",
  "material.details_dialog.duration_placeholder": "z. B. 30",
  "material.details_dialog.duration_invalid": "Verwende eine ganze Zahl zwischen 1 und {{max}} Minuten oder lasse das Feld leer.",
  "material.edit_details.topic_description": "Jedes Material gehört zu einem Ordner. Dadurch findest Du es später wieder und die KI erhält mehr Kontext.",
  "material.edit_details.duration_description": "Wie viele Minuten werden im Unterricht für dieses Material benötigt?",
  "material.edit_details.more": "Weitere Aktionen",
  "material.edit_details.material_duplicate": "Material kopieren",
  "material.edit_details.material_delete": "Material löschen",
  "material.pdf_export": "PDF speichern / drucken",
  "material.docx_export": "Word (.docx)",
  "material.docx_export_with_notes": "Word (.docx) mit Notizen",
  "material.search_placeholder": "Materialien durchsuchen",
  "material.generate": "Material mit KI generieren",
  "material.share.courses_with_material": "Kurse mit diesem Material",
  "material.share.add_to_more_courses": "Material zu weiteren Kursen hinzufügen",
  "material.share.empty.no_courses_available.title": "Erstelle einen Kurs, um das Material mit Schüler:innen zu teilen.",
  "material.share.empty.no_courses_available.description": "Kurse entsprechen Deinen Klassen und Fächern. Zum Beispiel: 8A Geographie.",
  "material.share.empty.courses_available_empty.title": "Füge das Material zu einem bestehenden Kurs hinzu oder erstelle einen neuen.",
  "material.share.new_course": "Kurs erstellen & Material teilen",
  "material.share.added_to_course": "Material zu Kurs hinzugefügt",
  "material.editor.teacher_note.title": "Notiz für Lehrkräfte",
  "material.editor.teacher_note.placeholder": "Notizen sind nur für Dich sichtbar. Hier kannst Du auch Lösungsblätter ablegen.",
  "material.editor.teacher_note.convert_to_teacher_note": "Nur für mich anzeigen",
  "material.editor.teacher_note.remove_from_teacher_note": "Für alle anzeigen",
  "material.editor.activity.ai_feedback": "Mit KI-Feedback",
  "material.editor.interactive_tag": "Interaktiv",
  "material.editor.interactive_ai_tag": "Interaktiv mit KI",
  "material.editor.text.generate_questions": "Fragen zum Text generieren",
  "material.editor.text.simplify": "Text vereinfachen",
  "material.editor.text.label": "Textblock",
  "material.editor.text.placeholder": "Text eintippen",
  "material.editor.callout.label": "Merksatz",
  "material.editor.callout.placeholder": "Schreibe hier",
  "material.save_conflict.title": "Neuere Materialversion verfügbar",
  "material.save_conflict.close": "Schließen",
  "material.save_conflict.reload": "Material neu laden",
  "material.editor.details.summary_label": "Titel der Klappliste",
  "material.editor.details.summary_placeholder": "Titel",
  "material.editor.details.content_label": "Inhalt der Klappliste",
  "material.editor.details.placeholder": "Schreibe hier",
  "material.editor.block.ai_suggestion": "KI-Vorschlag",
  "material.editor.block.reject": "Verwerfen",
  "material.editor.block.accept": "Annehmen",
  "material.editor.block.teacher_only": "Nur für Lehrkräfte sichtbar",
  "material.editor.block.adjust_results": "Ergebnisse anpassen",
  "material.editor.block.prompt_placeholder": "Prompt eingeben",
  "material.editor.block_number.image": "B{{number}}",
  "material.editor.assignment_open_question.title": "Frage",
  "material.editor.assignment_open_question.placeholder": "Tippe hier die Frage ein",
  "material.editor.assignment_open_question.assignment_tag": "Aufgabe",
  "material.editor.assignment_open_question.your_answer": "Deine Antwort",
  "material.editor.assignment_open_question.check": "Abgeben",
  "material.editor.assignment_open_question.redo": "Antwort überarbeiten",
  "material.editor.assignment_open_question.get_hint": "Tipp holen",
  "material.editor.assignment_open_question.hint_loading": "Tipp wird geladen",
  "material.editor.assignment_open_question.hint": "Tipp",
  "material.editor.assignment_open_question.confirm": "Abgeben",
  "material.editor.assignment_open_question.guidance": "Kriterien für inhaltliches KI-Feedback",
  "material.editor.assignment_open_question.generate_guidance": "Mit KI generieren",
  "material.editor.assignment_open_question.generate_guidance_empty": "Tippe eine Frage mit mindestens 10 Zeichen ein, um passende Feedback-Kriterien zu generieren.",
  "material.editor.assignment_open_question.generate_guidance_disabled": "Füge zuerst eine Frage hinzu",
  "material.editor.assignment_open_question.generate_guidance_error": "Feedback-Kriterien konnten nicht generiert werden. Bitte versuche es erneut.",
  "material.editor.assignment_open_question.guidance_placeholder": "Der Schüler nennt …",
  "material.editor.assignment_open_question.guidance_example": "Lege Kriterien zu Form, Länge und Inhalt sowie eine Musterlösung fest. Die KI nutzt sie für Bewertung, Feedback und Feed Forward.",
  "material.editor.assignment_open_question.badge": "Aufgabe mit KI-Feedback",
  "material.editor.assignment_open_question.guidance_hint": "Tippe hier Feedback-Kriterien oder eine Musterlösung ein.",
  "material.editor.assignment_open_question.guidance_hint_short": "Tippe hier Feedback-Kriterien ein",
  "material.editor.assignment_open_question.guidance_input_placeholder": "Feedback-Kriterien hier eintippen",
  "material.editor.assignment_open_question.guidance_collapsed_empty": "Noch nicht festgelegt",
  "material.editor.assignment_open_question.preview_cta": "KI-Feedback testen",
  "material.editor.assignment_open_question.preview_title": "Probiere die Frage aus Sicht Deiner Schüler:innen",
  "material.editor.assignment_open_question.language_assessment.label": "Kriterien für sprachliches KI-Feedback",
  "material.editor.assignment_open_question.language_assessment.description": "Aktiviere oder deaktiviere die gewünschten Optionen.",
  "material.editor.assignment_open_question.language_assessment.chip.grammar_spelling": "Grammatik und Rechtschreibung",
  "material.editor.assignment_open_question.language_assessment.chip.allow_all_languages": "Alle Sprachen erlauben",
  "material.editor.assignment_open_question.language_assessment.feedback_label": "Sprache",
  "material.editor.assignment_open_question.help.cta": "Leitfaden lesen",
  "material.editor.assignment_open_question.help.title": "Tipps und Tricks für den Einsatz von KI im Unterricht",
  "material.assignment_open_question.answer_placeholder": "Tippe Deine Antwort ein …",
  "material.assignment_open_question.answer_reset": "Rückgängig",
  "material.assignment_open_question.get_feedback": "Feedback holen",
  "material.assignment_open_question.feedback": "Feedback der KI",
  "material.assignment_open_question.feedback.empty_state": "Kein Feedback vorhanden",
  "material.assignment_open_question.status.not_answered": "Nicht beantwortet",
  "material.assignment_open_question.status.incorrect": "Nicht korrekt beantwortet",
  "material.assignment_open_question.status.partially": "Teilweise korrekt beantwortet",
  "material.assignment_open_question.status.correct": "Vollständig korrekt beantwortet",
  "material.assignment_open_question.status.started": "In Bearbeitung",
  "material.assignment_open_question.status.not_started": "Noch nicht gestartet",
  "material.assignment_open_question.summary.started": "In Bearbeitung",
  "material.assignment_open_question.summary.correct": "Vollständig korrekt",
  "material.assignment_open_question.summary.partially": "Teilweise korrekt",
  "material.assignment_open_question.summary.incorrect": "Nicht korrekt",
  "material.assignment_open_question.loading": "Die KI liest die Antwort und gibt gleich ein Feedback.",
  "material.assignment_open_question.ai_disclaimer": "Das Feedback wird von KI erstellt. KI kann Fehler machen.\nKeine personenbezogenen Daten eingeben.",
  "material.assignment_open_question.question_placeholder": "Tippe eine Frage oder Aufgabenstellung ein",
  "material.assignment_open_question.attempt": "Versuch",
  "material.assignment_open_question.answer.empty_state": "Keine Antwort",
  "material.assignment_open_question.answer_paste_block": "Bitte tippe Deine Antwort ein, anstatt sie zu kopieren.",
  "material.assignment_open_question.answer_paste_block_teacher": "Schüler:innen können ihre Antwort ausschließlich eintippen. Kopieren und Einfügen ist nur für Lehrkräfte erlaubt.",
  "speech_to_text.microphone": "Mikrofon",
  "speech_to_text.default_microphone": "Standardmikrofon",
  "speech_to_text.start_recording": "Antwort aufnehmen",
  "speech_to_text.stop_recording": "Aufnahme stoppen",
  "speech_to_text.transcribing": "Wird transkribiert …",
  "speech_to_text.microphone_denied": "Mikrofonzugriff wurde verweigert. Bitte erlaube den Mikrofonzugriff in deinen Browsereinstellungen.",
  "speech_to_text.transcription_error": "Spracherkennung fehlgeschlagen. Bitte versuche es erneut oder tippe deine Antwort ein.",
  "image_to_text.upload_image": "Bild hochladen (Text erkennen)",
  "image_to_text.extraction_error": "Texterkennung fehlgeschlagen. Bitte versuche es erneut oder tippe deine Antwort ein.",
  "image_to_text.file_too_large": "Bild ist zu groß (max. 5 MB). Bitte verwende ein kleineres Bild.",
  "material.editor.multiple_choice.badge": "Multiple-Choice-Frage",
  "material.editor.multiple_choice.choice_type": "Antwortmodus",
  "material.editor.multiple_choice.single_choice": "Einfachauswahl",
  "material.editor.multiple_choice.multiple_choice": "Mehrfachauswahl",
  "material.editor.multiple_choice.option_placeholder": "Antwort {{index}}",
  "material.editor.multiple_choice.allow_multiple": "Mehrfachauswahl erlauben",
  "material.editor.multiple_choice.add_option": "Antwort hinzufügen",
  "material.editor.multiple_choice.randomized_order_hint": "Die Reihenfolge der Antworten wird für Schüler:innen zufällig angezeigt.",
  "material.editor.multiple_choice.no_question": "Die Lehrkraft hat noch keine Frage formuliert.",
  "material.editor.multiple_choice.answer_option_default": "Antwortoption",
  "material.editor.multiple_choice.correct": "Richtig",
  "material.editor.multiple_choice.info.title": "Schüler:innen bekommen Tipps der KI",
  "material.editor.multiple_choice.info.description": "Wird die falsche Antwort ausgewählt, erhalten die Schüler:innen einen Tipp.",
  "material.editor.multiple_choice.preview_cta": "Ausprobieren",
  "material.editor.multiple_choice.validation.min_answers": "Bitte gib mindestens zwei Antworten an.",
  "material.editor.multiple_choice.validation.correct_answer": "Bitte wähle mindestens eine richtige Antwort.",
  "material.editor.multiple_choice.feedback.correct": "Super! Alles ist korrekt.",
  "material.editor.multiple_choice.feedback.partially": "Teilweise richtig. Prüfe die Antworten und versuche es erneut.",
  "material.editor.multiple_choice.feedback.incorrect": "Noch nicht korrekt. Prüfe die Antworten und versuche es erneut.",
  "material.editor.multiple_choice.state.correct_selected": "Richtig ausgewählt",
  "material.editor.multiple_choice.state.incorrect_selected": "Falsch ausgewählt",
  "material.editor.multiple_choice.state.missed_correct": "Richtige Antwort nicht ausgewählt",
  "material.editor.listening.badge": "Hörtext",
  "material.editor.listening.placeholder": "Tippe den Text ein, der vorgelesen werden soll",
  "material.editor.listening.generating": "Audio wird erzeugt …",
  "material.editor.listening.empty_state": "Tippe einen Text ein, um Audio zu erzeugen.",
  "material.editor.listening.audio_unavailable": "Audio nicht verfügbar",
  "material.editor.listening.listen": "Anhören",
  "material.editor.listening.stop": "Stoppen",
  "material.editor.listening.generation_failed": "Audio konnte nicht erzeugt werden.",
  "material.editor.listening.retry": "Erneut versuchen",
  "material.editor.gap_text.placeholder": "Tippe hier deinen Text ein",
  "material.editor.gap_text.hint": "Markiere Text, um eine Lücke zu setzen, oder klicke auf ein hervorgehobenes Wort und wähle „Lücke entfernen“",
  "material.editor.gap_text.validation.min_gaps": "Markiere mindestens ein Wort als Lücke",
  "material.editor.gap_text.word_bank_for_students": "Wortbank für Schüler:innen",
  "material.editor.gap_text.word_bank_off": "Aus",
  "material.editor.gap_text.word_bank_on": "An",
  "material.editor.gap_text.word_bank": "Wortbank",
  "material.editor.gap_text.word_bank_drop_return": "Hier ablegen, um das Wort zurückzulegen",
  "material.editor.gap_text.word_bank_all_used": "Alle Wörter verwendet",
  "material.editor.gap_text.actions": "Lückentext-Aktionen",
  "material.editor.gap_text.mark_as_gap": "Als Lücke markieren",
  "material.editor.gap_text.remove_gap": "Lücke entfernen",
  "material.editor.gap_text.evaluation.correct": "Richtig",
  "material.editor.gap_text.evaluation.capitalization": "Groß- und Kleinschreibung prüfen",
  "material.editor.gap_text.evaluation.incorrect": "Falsch",
  "material.student.your_are_logged_in_as": "Du bist als {{name}} angemeldet",
  "material.student.click_logout_description": "Klicke auf \"Abmelden\", um dich abzumelden. Dadurch werden Deine Antworten von diesem Computer gelöscht. Deine Lehrkraft kann weiterhin darauf zugreifen.",
  "material.editor.image.set_size_small": "Verkleinern",
  "material.editor.image.set_size_large": "Vergrößern",
  "material.editor.image.size_small": "Klein",
  "material.editor.image.size_medium": "Mittel",
  "material.editor.image.size_large": "Groß",
  "material.editor.image.replace": "Bild ersetzen",
  "material.editor.image.replace_preview": "Unter \"Bearbeiten\" kannst Du ein alternatives Bild wählen, hochladen oder mit KI generieren.",
  "material.editor.image.search_other": "Anderes Bild suchen",
  "material.editor.image.upload_other": "Anderes Bild hochladen",
  "material.editor.image.generate": "Bild generieren",
  "material.editor.image.no_results": "Keine Ergebnisse gefunden.",
  "material.editor.image.alternative_for": "Alternative Bilder für \"{{keywords}}\"",
  "material.editor.image.source_label": "Quelle:",
  "material.editor.image.author_label": "Autor:",
  "material.editor.image.suggestions_title": "Alternative <br /> Vorschläge",
  "material.editor.file.uploading": "Datei wird hochgeladen",
  "material.editor.file.upload_error": "Die Datei konnte nicht hochgeladen werden.",
  "material.editor.file.retry": "Erneut versuchen",
  "material.editor.file.upload": "Datei hochladen",
  "material.change_topic": "Ordner ändern",
  "library.material.courses.title": "Kurse",
  "library.material.courses.loading": "Lade Kurse …",
  "library.material.courses.empty": "Dieses Material ist keinem Kurs zugeordnet",
  "material.rename.success": "Material umbenannt!",
  "material.icon_change.success": "Neues Symbol gespeichert!",
  "material.download": "Herunterladen",
  "material.editor.image.expand": "Bild vergrößern",
  "material.preview": "Vorschau",
  "material.open_link": "Link öffnen",
  "material.copy_link": "Link kopieren",
  "material.editor.link.save": "Link speichern",
  "material.editor.link.label": "Link",
  "material.editor.link.title": "Linktitel",
  "material.editor.link.title_placeholder": "Titel hinzufügen",
  "material.editor.link.description": "Linkbeschreibung",
  "material.editor.link.description_placeholder": "Beschreibung hinzufügen",
  "material.editor.link.enter": "Link eingeben",
  "material.editor.link.add": "Link einfügen",
  "material.editor.link.edit_url": "Link bearbeiten",
  "material.editor.link.convert_to_preview": "Zu Vorschau konvertieren",
  "material.editor.link.reload_preview": "Vorschau neu laden",
  "material.editor.link.convert_to_url": "Zu URL konvertieren",
  "material.editor.link.invalid": "Bitte gib einen gültigen Link ein.",
  "material.editor.link.remove_preview": "Vorschau entfernen",
  "material.bulk.cta": "Dateien hochladen",
  "material.bulk_create.title": "Dateien hochladen",
  "material.bulk_create.files": "Dateien",
  "material.bulk_create.hint_1": "💡 Tipp: Mit {{cmdAll}} kannst Du alle Dateien in einem Ordner auswählen.",
  "material.bulk_create.hint_2": "Um mehrere Dateien anzuklicken, halte {{cmdMultiSelect}} gedrückt.",
  "material.bulk_create.success": "Materialien erstellt!",
  "material.bulk_create.pending_uploads": "{{count}} ausstehend",
  "material.bulk_create.cancel_uploads.title": "Uploads abbrechen?",
  "material.bulk_create.cancel_uploads.message": "Wenn du diesen Dialog schließt, werden alle laufenden Uploads abgebrochen. Möchtest du fortfahren?",
  "material.bulk_create.cancel_uploads.confirm": "Ja, abbrechen",
  "material.bulk_create.cancel_uploads.keep_uploading": "Nein, weiter hochladen",
  "material.external_content.header": "Dokument auswählen",
  "material.external_content.empty": "Keine Dokumente gefunden",
  "material.external_content.recent": "Kürzlich verwendete Dokumente",
  "material.share.cta": "Teilen",
  "material.share.cta_long": "Material austeilen",
  "material.share_with_teachers.menu_label": "Mit Lehrkräften teilen",
  "material.share_with_teachers.title": "Material mit Lehrkräften teilen",
  "material.share_with_teachers.description": "Alle, die diesen Link haben, können das Material ansehen und in ihre eigenen Kurse übernehmen.",
  "material.share_with_teachers.hint": "Der Link ist öffentlich zugänglich. Antworten und Daten von Schüler:innen werden nicht geteilt.",
  "material.share_with_teachers.deactivate": "Link deaktivieren",
  "material.share_with_teachers.deactivated_title": "Link deaktiviert",
  "material.share_with_teachers.deactivated_description": "Der bisherige Link funktioniert nicht mehr. Niemand kann das Material darüber ansehen oder kopieren. Bereits kopierte Materialien bleiben erhalten.",
  "material.share_with_teachers.create_new_link": "Neuen Link erstellen",
  "shared_material.title": "Geteiltes Material",
  "shared_material.subtitle": "Eine Lehrkraft hat dieses Material mit Dir geteilt",
  "shared_material.use_material": "Material übernehmen",
  "shared_material.use_material_hint": "Kopiere das Material in einen Deiner Kurse, um es zu bearbeiten und einzusetzen.",
  "shared_material.no_courses": "Du hast noch keinen Kurs, in den Du das Material kopieren kannst. Erstelle zuerst einen Kurs.",
  "shared_material.not_available.title": "Material nicht verfügbar",
  "shared_material.not_available.description": "Der Link ist ungültig oder wurde deaktiviert.",
  "material.rename_dialog.title": "Name des Materials",
  "material.rename_dialog.description": "Bitte gib Deinem Material einen aussagekräftigen Namen, damit die KI ausreichend Kontext hat.",
  "material.rename_dialog.placeholder": "Namen eingeben",
  "material.rename_dialog.error": "Bitte gib einen längeren Namen ein.",
  "material.save_as_new_dialog.title": "Neues Material speichern",
  "material.save_as_new_dialog.description": "Gib einen Namen für das neue Material ein.",
  "material.save_as_new_dialog.placeholder": "Namen eingeben",
  "material.chat.send": "Senden",
  "material.chat.age_select.label": "Alter der SuS",
  "material.chat.age_select.tooltip": "Alter der Schüler:innen: Die KI passt die Schwierigkeit und die Methoden an das Alter Deiner Schüler:innen an",
  "material.chat.language_select.label": "Sprache der SuS",
  "material.chat.language_select.tooltip": "In welcher Sprache soll die KI Ergebnisse generieren?",
  "interactive_assignment.overview.title": "Auswertung für {{courseName}}",
  "interactive_assignment.overview.table.name": "Name",
  "interactive_assignment.number_of_students_one": "Ein:e Schüler:in",
  "interactive_assignment.number_of_students_many": "{{number}} Schüler:innen",
  "interactive_assignment.overview.legend": "Legende",
  "interactive_assignment.overview.legend.incorrect": "Nicht korrekt",
  "interactive_assignment.overview.legend.partially_correct": "Teilweise korrekt",
  "interactive_assignment.overview.legend.correct": "Korrekt",
  "interactive_assignment.overview.legend.started": "In Bearbeitung",
  "interactive_assignment.overview.legend.attempts_and_hints": "1. Zahl: Anzahl der Versuche &middot; 2. Zahl: Anzahl der verwendeten Tipps",
  "interactive_assignment.overview.show_hints_and_attempts": "Versuche und Tipps anzeigen",
  "interactive_assignment.overview.one_attempt": "Ein Versuch.",
  "interactive_assignment.overview.many_attempts": "Versuche",
  "interactive_assignment.overview.user_interview.title": "Du nutzt interaktive Aufgaben mit KI-Feedback – danke dafür!",
  "interactive_assignment.overview.user_interview.description": "Hast du 15 Minuten für einen kurzen Austausch? Mit deinem Feedback möchten wir die Funktion gezielt weiterentwickeln.\nAls Dankeschön erhältst du einen Wunschgutschein über 15 €.",
  "interactive_assignment.overview.user_interview.cta": "Feedback-Termin buchen",
  "interactive_assignment.no_courses.title": "Klicke auf \"Austeilen\", um dieses Material mit Deinen Schüler:innen zu teilen.",
  "interactive_assignment.no_courses_description": "Sobald Deine Schüler:innen das Material bearbeiten, siehst Du hier die Auswertung pro Schüler:in und pro Frage.",
  "editor.file.description.placeholder": "Beschreibung hinzufügen",
  "pathfindr.annotation_tool.welcome_modal.title": "Hallo",
  "pathfindr.annotation_tool.welcome_modal.text": "Hier kannst Du Dokumente ansehen und darauf zeichnen.",
  "pathfindr.annotation_tool.welcome_modal.button": "Weiter",
  "pathfindr.annotation_tool.permission_modal.title": "Berechtigung benötigt",
  "pathfindr.annotation_tool.permission_modal.text": "Du musst den Zugriff auf deine Kamera und deinen Bildschirm erlauben, um deine Sitzung aufzuzeichnen.",
  "pathfindr.annotation_tool.permission_modal.button_permission": "Berechtigung erteilen",
  "pathfindr.annotation_tool.permission_modal.button_no_permission": "Ohne Aufnahme fortfahren",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_title": "Keine Browserunterstützung",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_text": "Dein Browser unterstützt keine Bildschirmaufzeichnung. Häufige Gründe sind fehlende Sicherheitseinstellungen, ein veralteter Browser oder mangelnde Unterstützung auf Smartphones.",
  "pathfindr.annotation_tool.uploading_modal.title": "Wird hochgeladen …",
  "pathfindr.annotation_tool.success_modal.title": "Hurra!",
  "pathfindr.annotation_tool.success_modal.text": "Deine Dateien wurden hochgeladen",
  "pathfindr.annotation_tool.error_modal.title": "Fehler",
  "pathfindr.annotation_tool.error_modal.text": "Die Datei kann gerade nicht angezeigt werden. Bitte lade die Datei mit dem Download-Button auf Dein Gerät, um sie zu öffnen.",
  "pathfindr.annotation_tool.error_modal.button_download_video": "Video herunterladen",
  "pathfindr.annotation_tool.error_modal.button_download_pdf": "PDF herunterladen",
  "pathfindr.annotation_tool.error_modal.button_retry": "Erneut versuchen",
  "pathfindr.annotation_tool.navbar.button_done": "Fertig",
  "pathfindr.annotation_tool.navbar.uploading_text": "Wird hochgeladen …",
  "pathfindr.annotation_tool.navbar.button_cancel": "Abbrechen",
  "pathfindr.annotation_tool.navbar.helper_text_not_ready": "Nimm eine Aufnahme auf oder bearbeite das Dokument",
  "pathfindr.annotation_tool.navbar.helper_text_ready": "Bereit zum Hochladen",
  "pathfindr.annotation_tool.access_token_unvalid": "Dies ist eine Testversion nur für Tests und Demos!",
  "language.de": "Deutsch",
  "language.en": "Englisch",
  "language.it": "Italienisch",
  "language.es": "Spanisch",
  "language.fr": "Französisch",
  "language.pt": "Portugiesisch",
  "language.tr": "Türkisch",
  "language.po": "Polnisch",
  "language.nl": "Niederländisch",
  "language.se": "Schwedisch",
  "language.ru": "Russisch",
  "language.sl": "Slowenisch",
  "language.cs": "Tschechisch",
  "language.lb": "Luxemburgisch",
  "language.ro": "Rumänisch",
  "language.rs": "Serbisch",
  "language.hr": "Kroatisch",
  "language.ur": "Urdu",
  "language.hi": "Hindi",
  "language.sq": "Albanisch",
  "language.ar": "Arabisch",
  "ipi.title": "Erstelle interaktives Material in 30 Sekunden.",
  "ipi.paywall.description": "Generiere Unterrichtsmaterial mit KI – interaktive Arbeitsblätter, Aufgaben und Ideen.",
  "ipi.usage.upgrade_cta": "Jetzt upgraden",
  "ipi.prompt.too_short": "Bitte gib einen längeren Prompt ein.",
  "ipi.prompt.generic_error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "ipi.prompt_history.title": "Prompt-Historie",
  "ipi.prompt_history.open": "Prompt-Historie öffnen",
  "ipi.prompt_history.empty_state": "Du hast noch keine Prompts verwendet.",
  "ipi.prompt_history.select": "Prompt verwenden",
  "ipi.prompt.placeholder": "Tippe hier ein Thema und gewünschte Details (Schwerpunkt, Lernziel, Vorwissen, …) ein",
  "ipi.prompt.cta": "Material generieren",
  "ipi.material.done": "Material erstellt!",
  "ipi.material.done_description": "Nicht ganz, was du brauchst? Nutze die KI ",
  "ipi.material.done_description_after": ", um das Material anzupassen.",
  "ipi.hints": "Beispiele",
  "ipi.inspiration.heading": "Inspiration",
  "ipi.inspiration.try_example": "Beispiel ausprobieren",
  "ipi.inspiration.examples.1.subject": "Digitale Grundbildung",
  "ipi.inspiration.examples.1.title": "Künstliche Intelligenz",
  "ipi.inspiration.examples.1.prompt": "Erstelle ein Arbeitsblatt, bei dem die Schüler:innen Schritt für Schritt erarbeiten, was KI ist, welche Vorteile, Nachteile und Gefahren sie birgt. Die Schüler:innen haben kaum Vorwissen zu diesem Thema.",
  "ipi.inspiration.examples.2.subject": "Digitale Grundbildung",
  "ipi.inspiration.examples.2.title": "Soziale Medien",
  "ipi.inspiration.examples.2.prompt": "Erstelle ein Arbeitsblatt zum Thema Soziale Medien. Behandle Chancen, Risiken und Regeln für einen verantwortungsvollen Umgang. Die Schüler:innen kennen grundlegende Gefahren des Internets und nutzen selbst verschiedene Apps (hauptsächlich TikTok und Instagram).",
  "ipi.inspiration.examples.3.subject": "Fächerübergreifend",
  "ipi.inspiration.examples.3.title": "Nachhaltigkeit",
  "ipi.inspiration.examples.3.prompt": "Erstelle ein Arbeitsblatt zum Thema Nachhaltigkeit aus unterschiedlichen Perspektiven.",
  "ipi.inspiration.examples.4.subject": "Englisch",
  "ipi.inspiration.examples.4.title": "Fake-News",
  "ipi.inspiration.examples.4.prompt": "Erstelle einen längeren Lesetext mit interaktiven Verständnisfragen und Fragen zur Reflexion zum Thema Fake-News.",
  "ipi.hint": "Beispiel:",
  "ipi.hints.improvements": "Tipp: Ergänze gewünschte Details wie <strong>Schwerpunkt</strong>, <strong>Lernziel</strong>, <strong>Vorwissen</strong>, <strong>Dauer</strong>, <strong>Sozialform</strong>, <strong>Anforderungsbereich</strong>, <strong>Sprachstil</strong>.",
  "ipi.hints.1.title": "Interaktives Arbeitsblatt Klimawandel",
  "ipi.hints.1.prompt": "Erstelle ein Arbeitsblatt zu den Folgen des Klimawandels mit Fokus auf extreme Wettererscheinungen.",
  "ipi.hints.3.title": "Stundeneinstieg Dampfmaschine",
  "ipi.hints.3.prompt": "Erstelle einen Stundeneinstieg zum Thema Funktionsweise von Dampfmaschinen.",
  "ipi.hints.4.title": "Infotext mit Verständnisfragen Tourismus Südtirol",
  "ipi.hints.4.prompt": "Verfasse einen Informationstext zum Thema Auswirkungen von Tourismus auf einen Ort am Beispiel Südtirol im Fach Geografie. Füge anschließend drei offene Fragen hinzu.",
  "ipi.loading.title": "Dein Material wird erstellt",
  "ipi.loading.subtitle": "Dies dauert ungefähr eine Minute",
  "ipi.loading.1": "Die Struktur Deines Materials wird erstellt",
  "ipi.loading.2": "Texte, Aufgaben und Bilder werden zusammengesetzt",
  "ipi.loading.3": "Interaktive Aufgaben werden generiert",
  "ipi.loading.4": "Du kannst das fertige Material nach Belieben bearbeiten und ergänzen.",
  "ipi.loading.5": "Anschließend kannst Du es drucken oder per Link mit Deinen Schüler:innen teilen.",
  "ipi.loading.6": "Das Material wird in einem Ordner im Kurs gespeichert.",
  "ipi.loading.material_ready": "Dein Material ist fertig.",
  "ipi.loading.view_material": "Material ansehen",
  "ipi.convert_worksheet.title": "Arbeitsblatt digitalisieren",
  "ipi.convert_worksheet.convert_button": "Umwandeln",
  "ipi.convert_worksheet.description": "Lade ein Arbeitsblatt (PDF, Bild oder Dokument) hoch und die KI wandelt es in ein interaktives Teachino-Material um.",
  "ipi.convert_worksheet.ai_prompt": "Wandle dieses hochgeladene Arbeitsblatt in ein interaktives Teachino-Material um.",
  "ipi.progress.validating": "Eingabe wird überprüft …",
  "ipi.progress.generating": "Material mit {{images}} Bildern wird generiert …",
  "ipi.progress.integrating": "{{questions}} interaktive Aufgaben werden eingebunden …",
  "ipi.progress.finalizing": "Material wird finalisiert …",
  "ipi.topic_select.title": "Wähle einen Ordner für die KI",
  "ipi.material.name_placeholder": "Neues Material",
  "ipi.feedback.thank_you": "Danke für Dein Feedback!",
  "ipi.feedback.regenerate": "Klicke auf \"Neu generieren\", um es nochmal zu versuchen.",
  "ipi.add_source": "Quelle",
  "ipi.add_source.loading": "Wird hochgeladen …",
  "ipi.add_source.upload_file": "Datei hochladen",
  "ipi.add_source.add_link": "Link eingeben",
  "ipi.add_source.add_youtube": "YouTube-Link eingeben",
  "ipi.add_source_description": "Wähle einen Link, ein Video, eine Datei oder einen Ordner als Quelle für die KI.",
  "ipi.add_topic_description": "In welchem Ordner soll das Material erstellt werden? Die KI nutzt den Ordner als zusätzlichen Kontext.",
  "ipi.longer_prompt.hint": "Mindestens 6 Zeichen eingeben, um die KI zu starten. Nutze die Beispiele zur Inspiration.",
  "ipi.disclaimer": "Die KI erstellt das Material auf Basis Deiner Angaben (Text, Quelle, Ordner). Bitte keine personenbezogenen Daten eingeben. KI kann Fehler machen.",
  "ipi.rework": "Überarbeiten",
  "ai_assistant.rework_pending_review": "Eine bestehende Überarbeitung dieses Materials wartet noch auf Prüfung oder wird gerade angewendet. Bitte prüfe oder verwerfe sie, bevor du eine neue Überarbeitung startest.",
  "image_generation.disclaimer": "Die Beschreibung wird mit KI verarbeitet. Bitte gib keine personenbezogenen Daten ein.",
  "katex.fractions": "Brüche",
  "katex.exponents": "Potenzen",
  "katex.subscripts": "Indizes (Tiefstellung)",
  "katex.roots": "Wurzeln",
  "katex.summation": "Summenzeichen",
  "katex.product": "Produktzeichen",
  "katex.limit": "Grenzwert (Limit)",
  "katex.integral": "Integral",
  "katex.infinity": "Unendlichkeit",
  "katex.pi": "Kreiszahl (Pi)",
  "katex.delta": "Delta (Änderung)",
  "katex.vector": "Vektoren (fett oder mit Pfeil)",
  "katex.equality": "Gleich / Ungleich",
  "katex.shortFraction": "Bruchstrich kurz (inline)",
  "katex.scaledBrackets": "Automatisch skalierende Klammern",
  "katex.arrows": "Pfeile",
  "katex.sets": "Mengenzeichen",
  "katex.emptysetNumbersets": "Leere Menge / Zahlenmengen",
  "katex.absoluteValue": "Betragsstriche",
  "katex.matrices": "Matrizen",
  "katex.systemOfEquations": "Gleichungssysteme",
  "katex.fractionInExponent": "Bruch im Exponenten",
  "katex.dots": "Punkte (Fortsetzung)",
  "katex.overline": "Überstrich (Mittelwert)",
  "katex.binomial": "Binomialkoeffizient",
  "katex.logarithm": "Logarithmus",
  "katex.trigonometric": "Trigonometrische Funktionen",
  "katex.derivative": "Ableitung",
  "katex.partialDerivative": "Partielle Ableitung",
  "katex.gradient": "Nabla / Gradient",
  "katex.sumWithConditions": "Summe mit Bedingungen darunter",
  "katex.textInMath": "Text in mathematischer Formel",
  "katex.exponential": "Exponentielle Funktion",
  "katex.bracketedFraction": "Bruch mit Klammern",
  "katex.approxIneq": "Ungefähr gleich / Ungleich",
  "katex.doubleArrows": "Doppelpfeile (Äquivalenz)",
  "katex.brackets": "Eckige / Geschweifte Klammern",
  "katex.spacing": "Abstände im Mathemodus",
  "katex.enter_equation": "Formel eingeben (LaTeX)",
  "katex.preview": "Vorschau",
  "katex.preview.empty": "Sobald Du eine Formel eingibst, siehst Du hier eine Vorschau.",
  "katex.show_all_tips": "Alle Tipps anzeigen",
  "katex.hide_all_tips": "Weniger Tipps anzeigen",
  "course.current_course": "Aktueller Kurs",
  "course.current_collection": "Aktuelle Sammlung",
  "course.all_courses": "Alle Kurse",
  "course.all_materials": "Alle Materialien",
  "course.materials.empty.title": "Erstelle Dein erstes Material!",
  "course.materials.empty.description": "Wähle einen KI-Vorschlag oder klicke auf „Neu“, um selbst zu starten.",
  "course.materials.empty.manual_description": "Klicke auf „Neu“, um dein erstes Material zu erstellen.",
  "course.materials.empty.ai_primary_cta": "Mit KI-Assistenz starten",
  "course.materials.empty.ai_primary_prompt": "Erstelle passendes Material für meinen Kurs.",
  "course.materials.empty.ai_cta_description": "Beschreibe dein Vorhaben – die KI-Assistenz erstellt passendes Material für deinen Kurs.",
  "course.materials.empty.ai_cta_action": "Assistenz öffnen",
  "course.materials.empty.convert_description": "Lade ein Arbeitsblatt hoch und wandle es in interaktives Material um.",
  "course.materials.empty.convert_action": "Arbeitsblatt hochladen",
  "course.materials.empty.manual_hint": "Materialien kannst du auch manuell über Neu erstellen, importieren oder hochladen.",
  "course.materials.empty.guest.title": "Noch keine Materialien",
  "course.materials.empty.guest.description": "In diesem Kurs wurden noch keine Materialien erstellt.",
  "course.materials.empty.guest.collection_description": "In dieser Sammlung wurden noch keine Materialien erstellt.",
  "course.materials.used_in_courses_label": "Verwendet in Kursen:",
  "course.add_content_menu.create_material": "Material erstellen",
  "course.add_content_menu.create_folder": "Ordner erstellen",
  "course.add_content_menu.reuse_section": "Wiederverwenden",
  "course.add_content_menu.add_from_course_or_collection": "Material aus anderem Kurs / Sammlung hinzufügen",
  "course.add_existing_empty_title": "Keine weiteren Kurse verfügbar",
  "course.add_existing_empty_description": "Erstelle oder stelle einen anderen Kurs wieder her, um hier bestehende Materialien anzusehen.",
  "course.add_existing_empty_materials_title": "Keine Materialien in diesem Ordner",
  "course.add_existing_empty_materials_description": "Wähle einen anderen Ordner, um dessen Materialien anzusehen.",
  "course.all_folders_copied": "Alle Ordner kopiert",
  "course.copy_all_folders.button": "Alle Ordner kopieren",
  "course.copy_all_folders.confirm_title": "Alle Ordner kopieren?",
  "course.copy_all_folders.confirm_message": "{{count}} Ordner werden in diesen Kurs kopiert.",
  "course.copy_all_folders.partial_success": "{{copied}} von {{total}} Ordnern kopiert",
  "course.copy_all_folders.success": "Alle Ordner kopiert",
  "course.copy_multiple_folders.button": "Ordner kopieren…",
  "course.copy_multiple_folders.confirm": "{{count}} Ordner in Kurs kopieren",
  "course.copy_multiple_folders.select_course": "Kurs auswählen…",
  "course.copy_multiple_folders.dialog_description": "Wähle die Ordner aus „{{course}}“, die in „{{destinationCourse}}“ kopiert werden sollen.",
  "course.copy_multiple_folders.dialog_title": "In Kurs kopieren",
  "course.copy_multiple_folders.material_count": "{{count}} Materialien",
  "course.copy_multiple_folders.partial_success": "{{copied}} von {{total}} Ordnern kopiert",
  "course.copy_multiple_folders.select_all": "Alle auswählen",
  "course.copy_multiple_folders.selection_count": "{{selected}} von {{total}} ausgewählt",
  "course.copy_multiple_folders.success": "{{count}} Ordner kopiert",
  "course.archived_courses": "Gelöschte Kurse",
  "course.recently_updated_materials": "Kürzlich bearbeitet",
  "course.export.date": "Datum",
  "course.export.materials_and_notes": "Materialien und Notizen",
  "course.export.class_register": "Klassenbuch",
  "course.export.year_plan": "Jahresplanung exportieren",
  "course.export.calendar_days": "Stunden und Inhalte exportieren",
  "course.export.dialog.title": "Drucken und exportieren",
  "course.export.dialog.student_codes.title": "Zugangscodes für Schüler:innen",
  "course.export.dialog.student_codes.description": "Druckt Zugangskarten mit Namen und persönlichen Codes für alle Schüler:innen dieses Kurses.",
  "course.export.dialog.student_codes.unavailable": "Dieser Export ist verfügbar, sobald Schüler:innen zum Kurs hinzugefügt wurden.",
  "course.export.dialog.year_plan.title": "Jahresplanung",
  "course.export.dialog.year_plan.description": "Exportiert die Ordner und ihre geplanten Zeiträume als CSV-Datei.",
  "course.export.dialog.year_plan.unavailable": "Dieser Export ist verfügbar, sobald Ordner und Materialien zum Kurs hinzugefügt wurden.",
  "course.export.dialog.calendar.title": "Stunden und Inhalte (Klassenbuch)",
  "course.export.dialog.calendar.description": "Exportiert geplante Stunden, Materialien, Notizen und Klassenbucheinträge als CSV-Datei.",
  "course.export.dialog.calendar.unavailable": "Dieser Export ist verfügbar, sobald Stunden geplant wurden.",
  "course.export.dialog.grading.title": "Beurteilungsübersicht",
  "course.export.dialog.grading.description": "Exportiert die Beurteilungsübersicht aller Schüler:innen als CSV-Datei.",
  "course.export.dialog.grading.unavailable": "Dieser Export ist verfügbar, sobald Schüler:innen zum Kurs hinzugefügt wurden.",
  "course.export.grading_overview": "Beurteilungsübersicht exportieren",
  "course.export.from": "Von",
  "course.export.to": "Bis",
  "course.edit_course": "Kurs bearbeiten",
  "course.archive_course": "Kurs löschen",
  "course.archive_course_message": "\"{{courseName}}\" löschen?",
  "course.archived_toast": "Kurs gelöscht. Der Kurs \"{{courseName}}\" wurde gelöscht.",
  "course.import_material_from_course": "Material aus Kurs oder Sammlung",
  "course.import_material_from_course_dialog": "Material aus Kurs oder Sammlung hinzufügen",
  "course.import_material_from_x": "Material aus \"{{course}}\" hinzufügen",
  "course.import_from_course.destination_hint": "Die Materialien werden nach „{{courseName}}“ in den Ordner „{{folderName}}“ kopiert.",
  "chatbot.chatbots": "KI-Chatbots",
  "chatbot.custom_chatbots": "Eigene KI-Chatbots",
  "chatbot.custom_chatbot": "Eigener KI-Chatbot",
  "chatbot.create_new": "Neuen KI-Chatbot erstellen",
  "chatbot.rename": "KI-Chatbot umbenennen",
  "chatbot.edit": "KI-Chatbot bearbeiten",
  "chatbot.delete": "KI-Chatbot löschen",
  "chatbot.delete_confirm": "Soll \"{{title}}\" wirklich gelöscht werden?",
  "chatbot.customizable": "Individuell konfigurierbar",
  "chatbot.name_label": "Name des KI-Chatbots",
  "chatbot.how_should_answer": "Wie soll der KI-Chatbot antworten?",
  "chatbot.purpose": "Wofür ist dieser KI-Chatbot gedacht?",
  "chatbot.start_without_template": "Ohne Vorlage starten",
  "chatbot.start_chat": "KI-Chat starten",
  "chatbot.ai_instructions": "Grundeinstellungen für die KI",
  "chatbot.additional_info": "Weitere Informationen für die KI",
  "chatbot.internal_notes": "Interne Hinweise zur Nutzung",
  "chatbot.no_info": "Keine Informationen hinterlegt",
  "chatbot.no_ai_settings": "Noch keine KI-Einstellungen hinterlegt",
  "chatbot.enter_message": "Nachricht eingeben …",
  "chatbot.legacy.title": "Vorhandene KI-Chats",
  "chatbot.legacy.description": "Wähle einen bestehenden Chat, um die Felder vorzufüllen. Bitte kopiere alte KI-Chats vor dem 30.07.2026 in deine Kurse.",
  "chatbot.context.description": "Inhalte, auf die der KI-Chatbot zugreifen soll.",
  "chatbot.context.no_sources": "Keine Quellen hinzugefügt",
  "chatbot.context.no_sources_hint": "Füge Dateien oder Links hinzu, auf die die KI zugreifen soll.",
  "chatbot.context.add_file": "Datei",
  "chatbot.context.add_link": "Link",
  "chatbot.description.student_hint": "Wird den Schüler:innen angezeigt, bevor sie den Chat starten.",
  "chatbot.prompt.teacher_only_hint": "Nur du siehst diese Anweisung – sie steuert das Verhalten der KI.",
  "chatbot.title.student_visible_hint": "Der Name des KI-Chatbots, den Schüler:innen sehen.",
  "chatbot.context.sources_label": "Quellen & Materialien",
  "chatbot.hello_message": "Hallo! Wie kann ich dir heute helfen?",
  "chatbot.explain_simple": "Kannst du mir das Thema nochmal einfach erklären?",
  "chatbot.step_by_step": "Gerne. Wir gehen das Thema Schritt für Schritt durch.",
  "chatbot.no_custom_chatbots_empty_state": "Noch keine eigenen KI-Chatbots. Erstelle einen neuen KI-Chatbot über \"Neu …\".",
  "folder.folder_copied": "Ordner kopiert",
  "folder.delete_folder": "Ordner löschen",
  "folder.delete_folder_confirm": "Möchtest du den Ordner wirklich löschen?",
  "folder.remove_from_course": "Aus Kurs entfernen",
  "folder.remove_from_course_confirm": "Möchtest du den Ordner wirklich aus dem Kurs entfernen?",
  "folder.folder_removed_from_course": "Ordner aus Kurs entfernt",
  "folder.select_course_for_copy": "Wähle den Kurs, in den der Ordner kopiert werden soll.",
  "material.no_materials_found": "Keine Materialien gefunden",
  "material.material_copied": "Material kopiert",
  "material.material_moved": "Material verschoben",
  "material.delete_material_confirm": "Möchtest du dieses Material wirklich löschen?",
  "material.copy_destination": "Wohin soll das Material kopiert werden?",
  "material.move_destination": "Wohin soll das Material verschoben werden?",
  "material.visible_for_sus": "Sichtbar für SuS",
  "material.not_visible_for_sus": "Material für Schüler:innen nicht sichtbar",
  "generic.ok": "Ok",
  "generic.new": "Neu...",
  "generic.new_short": "Neu",
  "generic.rename": "Umbenennen",
  "generic.help": "Hilfe",
  "generic.website": "Webseite",
  "generic.webinar": "Webinare",
  "generic.image": "Bild",
  "generic.europathek": "EUROPATHEK",
  "generic.no_images_found": "Keine Bilder gefunden",
  "generic.scan_qr_code": "QR-Code scannen",
  "generic.add_source": "Quelle hinzufügen",
  "generic.try_different_search": "Versuche es mit einem anderen Suchbegriff",
  "generic.name_and_color": "Name und Farbe",
  "generic.change_name_color": "Name & Farbe ändern",
  "ipi.describe_what_to_create": "Erstelle ein interaktives Arbeitsblatt zu …",
  "ipi.placeholder.example_photosynthesis": "Ein Arbeitsblatt zu Photosynthese mit Bild und offenen Fragen",
  "ipi.placeholder.example_faust": "Eine KI-Übung zu Goethes Faust",
  "ipi.placeholder.example_past_simple": "Ein interaktiver Lückentext zu Past Simple",
  "ipi.ideas_for_you": "Ideen für Dich",
  "ipi.generate_ideas": "Ideen generieren",
  "ipi.generate_new_ideas": "Neue Ideen",
  "ipi.choose_idea": "Prompt verwenden",
  "ipi.ideas_generating": "Ideen werden generiert",
  "ipi.ai_assistance": "KI-Assistenz",
  "ipi.enter_details": "Details eingeben",
  "ipi.context_files": "Kontextdateien",
  "ipi.description_students": "Beschreibung für Schüler:innen",
  "ipi.description_teacher": "Beschreibung für Lehrkräfte",
  "ipi.llm_instructions": "Beschreibung für den KI-Chatbot",
  "ipi.loading": "Laden",
  "feature_flags.title": "Feature Flags 🧪",
  "course.ai_instructions_description": "Die KI nutzt diese Informationen, um die Materialien an Deinen Unterricht anzupassen.",
  "course.additional_info_description": "z. B. ob die KI Schüler:innen siezen oder duzen soll sowie Informationen, die bei jedem Material berücksichtigt werden sollen",
  "course.display_question": "Wie soll der Kurs angezeigt werden?",
  "course.archive_description": "Kurs löschen. Materialien bleiben für folgende Schuljahre erhalten.",
  "course.archive_info": "Der Kurs wird nicht mehr zum Planen angezeigt. Auf Materialien kann weiterhin über den Menüpunkt \"Gelöschte Kurse\" zugegriffen werden.",
  "course_list.loading": "Kurslisten-Daten werden geladen…",
  "course_list.error.load_failed": "Kurslisten-Daten konnten nicht geladen werden.",
  "course_list.error.reorder": "Kurs konnte nicht neu sortiert werden.",
  "course_list.error.update_school_year": "Schuljahr konnte nicht aktualisiert werden.",
  "course_list.error.create_course": "Kurs konnte nicht erstellt werden.",
  "course_list.error.connect_course": "Kurs konnte nicht verknüpft werden.",
  "course_list.error.hide_course": "Kurs konnte nicht ausgeblendet werden.",
  "course_list.error.failed_create_school_year": "Schuljahr konnte nicht erstellt werden.",
  "course_list.error.failed_update_school_year": "Schuljahr konnte nicht aktualisiert werden.",
  "course_list.error.school_year_overlap": "Das Schuljahr überschneidet sich mit einem bestehenden. Bitte passe die Daten an und speichere erneut.",
  "course_list.new_school_year": "Neues Schuljahr",
  "course_list.create_school_year": "Schuljahr anlegen",
  "course_list.edit_school_year": "Schuljahr bearbeiten",
  "course_list.delete_school_year": "Schuljahr löschen",
  "course_list.delete_school_year.title": "Schuljahr löschen",
  "course_list.delete_school_year.message": "\"{{schoolYearName}}\" löschen?",
  "course_list.delete_school_year.success": "Schuljahr gelöscht. \"{{schoolYearName}}\" wurde gelöscht.",
  "course_list.delete_school_year_blocked.info_title": "Das Schuljahr enthält Kurse",
  "course_list.delete_school_year_blocked.info_message": "Lösche bitte zuerst alle Kurse des Schuljahres. Danach kannst du das Schuljahr löschen.",
  "course_list.hide_course": "Kurs ausblenden",
  "course_list.connect_course": "Kurs verknüpfen",
  "course_list.add_course": "Kurs erstellen",
  "course_list.empty_school_year.title": "Keine Kurse",
  "course_list.empty_school_year.description": "In diesem Schuljahr sind keine Kurse vorhanden.",
  "course_list.empty.description": "Lege einen Kurs an, um loszulegen.",
  "course_list.connect_dialog.description": "Wähle den Teachino-Kurs, mit dem dieser externe Kurs verknüpft werden soll.",
  "course_list.external_course": "Externer Kurs",
  "course_list.external_course_from": "von {{integrationName}}",
  "course_list.teachino_course": "Teachino-Kurs",
  "course_list.select_course": "Kurs auswählen",
  "course_list.connect_existing": "Kurs verbinden",
  "course_list.statistics.students": "Schülerinnen und Schüler",
  "course_list.statistics.folders": "Ordner",
  "course_list.statistics.materials": "Materialien",
  "course_list.menu.open": "Öffnen",
  "course_list.open_course_aria": "Kurs öffnen",
  "course_list.school_year.description": "Wähle das Schuljahr, zu dem dieser Kurs gehört.",
  "course_list.select_school_year": "Schuljahr auswählen",
  "course_list.school_year.start_date": "Startdatum",
  "course_list.school_year.end_date": "Enddatum",
  "course_list.school_year.end_date_after_start": "Das Enddatum muss nach dem Startdatum liegen.",
  "course_list.school_year.name_placeholder": "z. B. {{startYear}}/{{endYear}}",
  "course_list.school_year.course_count_zero": "{{number}} Kurse",
  "course_list.school_year.course_count_one": "{{number}} Kurs",
  "course_list.school_year.course_count_many": "{{number}} Kurse",
  "course_list.school_year.drag_blocked": "Kurse lassen sich nicht in ein anderes Schuljahr ziehen. Ändere das Schuljahr in den Kurseinstellungen.",
  "course_list.school_year.change_hint": "Ein Wechsel des Schuljahres löscht den Stundenplan dieses Kurses.",
  "course_list.school_year.change_title": "Kurs nach {{schoolYear}} verschieben?",
  "course_list.school_year.change_message": "Der Stundenplan von „{{courseName}}“ wird dabei gelöscht – Stunden, Vertretungen und Zusatzstunden, auch bei Kolleg:innen, die den Kurs mitplanen. Das lässt sich nicht rückgängig machen. Materialien, Themen, Noten und Schüler:innen bleiben erhalten.",
  "course_list.school_year.change_action": "Schuljahr wechseln",
  "material.version_history.title": "Versionsverlauf",
  "material.version_history.current": "Aktuell",
  "material.version_history.current_version": "Aktuelle Version",
  "material.version_history.version": "Version",
  "material.version_history.reason.created": "Erstellt",
  "material.version_history.reason.created_with_ai": "Mit KI erstellt",
  "material.version_history.reason.saved_edit": "Bearbeitung gespeichert",
  "material.version_history.reason.ai_rework": "KI-Überarbeitung",
  "material.version_history.reason.restored": "Wiederhergestellt",
  "material.version_history.reason.saved_version": "Version gespeichert",
  "material.version_history.by": "Von",
  "material.version_history.no_versions_available": "Keine Versionen verfügbar",
  "material.version_history.restore_selected_version": "Ausgewählte Version wiederherstellen?",
  "material.version_history.restore_description": "Das aktuelle Material wird zuerst gespeichert, dann wird diese Version zur neuen aktuellen Version.",
  "material.version_history.cancel_restore": "Wiederherstellen abbrechen",
  "material.version_history.confirm_restore": "Wiederherstellen bestätigen",
  "material.version_history.restore_this_version": "Diese Version wiederherstellen",
  "material.version_history.failed_to_load": "Versionsinhalt konnte nicht geladen werden",
  "material.version_history.restore_failed": "Wiederherstellen fehlgeschlagen",
  "generic.file": "Datei",
  "generic.upload_file": "Datei hochladen",
  "generic.save_link": "Link speichern",
  "generic.enter_link": "Link eingeben",
  "generic.copy_item": "\"{{item}}\" kopieren",
  "chatbot.template.socratic_tutor.title": "Sokratischer Tutor",
  "chatbot.template.socratic_tutor.description_teacher": "Unterstützt Schüler:innen beim Arbeiten mit dem Material.",
  "chatbot.template.socratic_tutor.description_student": "Stelle Fragen zum Material und erhalte hilfreiche Erklärungen und Hinweise.",
  "chatbot.template.socratic_tutor.prompt": "Du bist ein unterstützender und einfühlsamer, sokratischer Tutor für Schüler:innen.\nDu begleitest die Schüler:innen durch dieses Material und unterstützt sie beim Verständnis. Sprich in einfacher Sprache. \nWenn Schüler:innen nach Lösungen zu einer Aufgabe fragen, gib NIEMALS einfach die Lösung. Erzähle oder fasse niemals ganze Abschnitte des Materials nach. Führe die Schüler:innen stattdessen zurück zum Material (z. B. verweise auf die Teile des Materials, in denen die Antwort zu finden ist, z. B.: \"Schau dir M2 an\").",
  "chatbot.template.exam_coach.title": "Prüfungscoach",
  "chatbot.template.exam_coach.description_teacher": "Prüft das Wissen der Schüler:innen zur Vorbereitung.",
  "chatbot.template.exam_coach.description_student": "Übe mit KI-Hilfe für deine Vorbereitung auf Tests, Arbeiten, Klausuren und lasse dir Themen erklären.",
  "chatbot.template.exam_coach.prompt": "Du bist ein Lerncoach für Schüler:innen und hilfst bei der Vorbereitung auf Tests, Arbeiten, Klausuren und andere Prüfungen. Erkläre Inhalte verständlich und in kleinen Schritten.\nHilf beim Strukturieren des Lernstoffs und gib motivierendes Feedback.\nGib keine vollständigen Musterlösungen aus, sondern begleite zum richtigen Lösungsweg.",
  "chatbot.template.discussion.title": "Diskussion",
  "chatbot.template.discussion.description_teacher": "Die Schüler:innen führen eine Pro-und-Kontra-Diskussion zu kontroversen Themen aus dem Material.",
  "chatbot.template.discussion.description_student": "Führe eine Pro-und-Kontra-Diskussion zu einem kontroversen Thema. Die KI vertritt die Gegenposition – überzeuge sie mit starken Argumenten!",
  "chatbot.template.discussion.prompt": "Führe eine Pro-und-Kontra-Diskussion zum kontroversen Thema \"{{topic}}\" aus diesem Material. Du vertrittst diese Meinung: {{opinion}}. Nimm die Gegenposition zu den Schüler:innen ein und fordere sie auf, ihre Argumente schlüssig zu begründen. Halte deine Antworten kurz.",
  "chatbot.copy": "Kopieren",
  "chatbot.initial_message": "Hallo",
  "chatbot.ai_disclaimer": "Du chattest mit einer KI. KI kann Fehler machen. Keine personenbezogenen Daten eingeben.",
  "chatbot.template.persuasion_talk.title": "Überzeugungsgespräch",
  "chatbot.template.persuasion_talk.description_teacher": "Schüler:innen überzeugen die KI von ihrer Meinung oder ihrem Vorhaben.",
  "chatbot.template.persuasion_talk.description_student": "Überzeuge die KI von deiner Meinung",
  "chatbot.template.persuasion_talk.prompt": "Führe eine Diskussion zum Thema \"{{topic}}\" und bringe Gegenargumente. Erst wenn die Schülerin oder der Schüler drei deiner Argumente inhaltlich gut entkräften konnte, gibst du ihr oder ihm recht.",
  "chatbot.template.chat_with_person.title": "Chat mit einer Person",
  "chatbot.template.chat_with_person.description_teacher": "Schüler:innen führen ein Gespräch mit einer ausgewählten Figur.",
  "chatbot.template.chat_with_person.description_student": "Chatte mit \"{{person}}\", um mehr über ein Thema zu erfahren, und stelle gezielte Fragen.",
  "chatbot.template.chat_with_person.prompt": "Du schlüpfst in die Rolle von: {{person}}.\nDie Schülerin oder der Schüler möchte mit dir über folgendes Thema sprechen: {{topic}}.\n\nSprich so, wie es zu deiner Person und deiner Zeit passt. Halte dich kurz.\n\nBleibe immer vollständig in deiner Rolle. Verlasse diese Rolle niemals.\n\nFühre einen natürlichen Dialog. Stelle nicht nach jeder Antwort eine Rückfrage.\nWenn die Schülerin oder der Schüler ein anderes Thema anspricht, lenke das Gespräch freundlich zurück zum Thema.\n\nStelle keine Fragen nach persönlichen Informationen der Schülerin oder des Schülers.\nWenn etwas nicht zu deiner Person oder deiner Zeit passt, sage das ehrlich aus deiner Rolle heraus.\n\nStarte den Chat, indem du dich kurz vorstellst.",
  "chatbot.template.vocabulary_trainer.title": "Vokabeltraining",
  "chatbot.template.vocabulary_trainer.description_teacher": "Lasse deine Schüler:innen ihre aktuellen Vokabeln üben.",
  "chatbot.template.vocabulary_trainer.description_student": "Übe die Vokabeln mit Hilfe der KI, indem du sie übersetzt oder einen Satz bildest. Die KI gibt dir die Vokabeln vor.",
  "chatbot.template.vocabulary_trainer.prompt": "Du bist ein Vokabeltrainer für Schüler:innen.\nÜbe mit der Schülerin oder dem Schüler Vokabeln.\nWähle die Vokabeln in zufälliger Reihenfolge aus.\n\nFrage abwechslungsreich ab:\n– mal soll der Lernende übersetzen\n– mal soll ein Beispielsatz mit der Vokabel gebildet werden.\n\nFrage immer nur eine Vokabel auf einmal.\nAchte sehr genau auf Rechtschreibung und Grammatik.\nGib Feedback, aber gib nie einfach die Lösung aus.\nWiederhole am Ende alle Vokabeln, die noch nicht sicher beherrscht wurden.\nBeende das Training erst, wenn alle Vokabeln richtig beantwortet wurden.\nVerabschiede dich am Ende mit einem Lob.\nNutze die Vokabeln aus dem Material.",
  "chatbot.template.grammar_trainer.title": "Grammatiktraining",
  "chatbot.template.grammar_trainer.description_teacher": "Schüler:innen üben gezielt Grammatik.",
  "chatbot.template.grammar_trainer.description_student": "Übe Grammatik mit KI-Hilfe, indem du Sätze in die geforderte Zeitform umwandelst. Die KI gibt dir Rückmeldung.",
  "chatbot.template.grammar_trainer.prompt": "Du bist ein geduldiger, aber sehr genauer Grammatiktrainer für Lernende. \nÜbe mit der Schülerin oder dem Schüler das Thema: {{topic}}.\nStelle immer nur eine Aufgabe auf einmal.\nGib nach jeder Antwort Feedback, aber gib NIE einfach die Lösung aus.\nLass keine Fehler durchgehen.\nSteigere die Schwierigkeit, wenn mehrere Aufgaben korrekt gelöst wurden.\n\nBeispielablauf:\n\"Change the following sentence from the Simple Present into the Simple Past: 'She walks to school.'\"\nWarte auf die Antwort und gib dann Feedback.",
  "chatbot.template.conversation_simulation.title": "Gesprächssimulation",
  "chatbot.template.conversation_simulation.description_teacher": "Schüler:innen üben eine realistische Gesprächssituation.",
  "chatbot.template.conversation_simulation.description_student": "Übe in dieser Simulation mit der KI diese Art von Gespräch: \"{{conversation}}\". Bereite dich so auf ein echtes Gespräch vor.",
  "chatbot.template.conversation_simulation.prompt": "Du bist \"{{person}}\" und führst folgende Art von Gespräch: \"{{conversation}}\".\nStelle gezielt Fragen.\nWenn die Art des Gesprächs ein Ziel verfolgt, wie z. B. bei einem Bewerbungsgespräch, gib am Ende des Gesprächs Feedback, je nachdem, wie zufrieden du bist (z. B. zum Job gratulieren oder konstruktives Feedback geben).",
  "chatbot.mock_answer": "Mock-Antwort: Danke für deine Nachricht. Hier würde jetzt die KI antworten.",
  "chatbot.create": "KI-Chatbot",
  "chatbot.create_custom": "Eigenen KI-Chatbot erstellen",
  "chatbot.edit_settings": "Einstellungen bearbeiten",
  "chatbot.start_new_chat": "Chat neu starten",
  "chatbot.ready_to_chat": "Bereit zum Chatten",
  "chatbot.history.conversation": "Gespräch",
  "chatbot.history.one_message": "1 Nachricht",
  "chatbot.history.many_messages": "{{count}} Nachrichten",
  "chatbot.messages_count": "Nachrichten: {{count}}",
  "chatbot.column_type.chatbot": "KI-Chatbot",
  "chatbot.column_type.question": "Frage",
  "chatbot.apply_template": "Vorlage anwenden",
  "chatbot.template.discussion.configure": "Diskussion konfigurieren",
  "chatbot.template.discussion.topic_label": "Kontroverses Thema",
  "chatbot.template.discussion.topic_description": "Das Thema, über das die KI mit den Schüler:innen diskutiert.",
  "chatbot.template.discussion.topic_placeholder": "z. B. Social Media in der Schule",
  "chatbot.template.discussion.opinion_label": "Meinung der KI",
  "chatbot.template.discussion.opinion_description": "Die Position, die die KI in der Diskussion vertritt.",
  "chatbot.template.discussion.opinion_placeholder": "z. B. Social Media sollte in der Schule verboten werden",
  "chatbot.template.persuasion_talk.configure": "Überzeugungsgespräch konfigurieren",
  "chatbot.template.persuasion_talk.topic_label": "Thema",
  "chatbot.template.persuasion_talk.topic_description": "Das Thema, von dem die KI überzeugt werden soll.",
  "chatbot.template.persuasion_talk.topic_placeholder": "z. B. Hausaufgaben sollten abgeschafft werden",
  "chatbot.template.conversation_simulation.configure": "Gesprächssimulation konfigurieren",
  "chatbot.template.conversation_simulation.person_label": "Rolle der KI",
  "chatbot.template.conversation_simulation.person_description": "Die Person oder Rolle, die die KI in der Simulation spielt.",
  "chatbot.template.conversation_simulation.person_placeholder": "z. B. Personalmanager",
  "chatbot.template.conversation_simulation.conversation_label": "Art des Gesprächs",
  "chatbot.template.conversation_simulation.conversation_description": "Die Art des Gesprächs, das die Schüler:innen üben sollen.",
  "chatbot.template.conversation_simulation.conversation_placeholder": "z. B. Bewerbungsgespräch",
  "chatbot.template.chat_with_person.configure": "Chat mit einer Person konfigurieren",
  "chatbot.template.chat_with_person.person_label": "Person",
  "chatbot.template.chat_with_person.person_description": "Die Person oder Figur, in deren Rolle die KI schlüpft.",
  "chatbot.template.chat_with_person.person_placeholder": "z. B. Albert Einstein",
  "chatbot.template.chat_with_person.topic_label": "Gesprächsthema",
  "chatbot.template.chat_with_person.topic_description": "Das Thema, über das die Schüler:innen mit der Person sprechen.",
  "chatbot.template.chat_with_person.topic_placeholder": "z. B. Die Relativitätstheorie",
  "chatbot.template.grammar_trainer.configure": "Grammatiktraining konfigurieren",
  "chatbot.template.grammar_trainer.topic_label": "Grammatikthema",
  "chatbot.template.grammar_trainer.topic_description": "Das Grammatikthema, das die Schüler:innen üben sollen.",
  "chatbot.template.grammar_trainer.topic_placeholder": "z. B. Simple Past",
  "material.block_menu.file_upload": "Dateiabgabe",
  "material.editor.file_upload.badge": "Dateiabgabe",
  "material.editor.file_upload.question_placeholder": "Tippe hier die Aufgabenstellung ein, z. B. „Lade ein Foto deiner Lösung hoch.“",
  "material.editor.file_upload.no_question": "Keine Aufgabenstellung",
  "material.editor.file_upload.settings.allow_file": "Datei hochladen",
  "material.editor.file_upload.settings.allow_audio": "Audio oder Podcast aufnehmen",
  "material.editor.file_upload.settings.allow_camera": "Foto oder Video aufnehmen",
  "material.editor.file_upload.settings.allow_link": "Link",
  "material.editor.file_upload.settings.answer_type": "Antwortart",
  "material.editor.file_upload.settings.max_files_hint": "Jede:r Schüler:in kann bis zu {{count}} Dateien hochladen",
  "material.editor.file_upload.student_action.file": "Datei hochladen",
  "material.editor.file_upload.student_action.audio": "Audio oder Podcast aufnehmen",
  "material.editor.file_upload.student_action.camera": "Foto oder Video aufnehmen",
  "material.editor.file_upload.student_action.link": "Link hinzufügen",
  "material.editor.file_upload.drop_here": "Dateien hier ablegen",
  "material.editor.file_upload.record_again": "Neue Aufnahme",
  "material.editor.file_upload.already_submitted": "Die Datei wurde an deine Lehrkraft übermittelt.",
  "material.editor.file_upload.already_submitted_many": "Die Dateien wurden an deine Lehrkraft übermittelt.",
  "material.editor.file_upload.new_try": "Neue Abgabe",
  "material.editor.file_upload.record_audio": "Audio oder Podcast aufnehmen",
  "material.editor.file_upload.stop_recording": "Aufnahme beenden",
  "material.editor.file_upload.take_photo": "Foto aufnehmen",
  "material.editor.file_upload.take_video": "Video aufnehmen",
  "material.editor.file_upload.link_placeholder": "https://…",
  "material.editor.file_upload.link_invalid": "Bitte gib eine gültige URL ein.",
  "material.editor.file_upload.max_files_reached": "Maximale Anzahl an Anhängen erreicht ({{count}}).",
  "material.editor.file_upload.attachments_count": "{{count}} von max. {{max}}",
  "material.editor.file_upload.upload_error": "Upload fehlgeschlagen.",
  "material.editor.file_upload.media_permission_denied": "Zugriff auf Mikrofon oder Kamera nicht möglich.",
  "material.editor.file_upload.submit": "Abgeben",
  "material.editor.file_upload.discard_title": "Wirklich schließen?",
  "material.editor.file_upload.discard_message": "Deine noch nicht abgegebenen Dateien und Aufnahmen gehen dabei verloren.",
  "material.editor.file_upload.discard_confirm": "Verwerfen",
  "material.editor.file_upload.discard_keep": "Weiter bearbeiten",
  "material.editor.file_upload.evaluation.version": "Version {{number}}",
  "material.editor.file_upload.evaluation.download": "Herunterladen",
  "material.editor.file_upload.open": "Öffnen",
  "evaluation.attempt_of_total": "Versuch {{current}} von {{total}}",
  "evaluation.conversation_of_total": "Gespräch {{current}} von {{total}}",
  "evaluation.previous_conversation": "Vorheriger Versuch",
  "evaluation.previous_attempt": "Vorheriger Versuch",
  "evaluation.next_conversation": "Nächster Versuch",
  "evaluation.next_attempt": "Nächster Versuch",
  "evaluation.feedback": "Rückmeldung",
  "evaluation.feedback_placeholder": "Tippe oder sprich hier deine Rückmeldung für {{name}} ein.",
  "evaluation.save_feedback": "Rückmeldung speichern",
  "evaluation.clear_feedback": "Rückmeldung löschen",
  "evaluation.dashboard.give_feedback": "Rückmeldung geben",
  "evaluation.dashboard.show_feedback": "Rückmeldung anzeigen",
  "evaluation.dashboard.next_update_in": "Nächstes Update in",
  "evaluation.dashboard.reload_now": "Jetzt neu laden",
  "evaluation.dashboard.legend.submitted": "Abgegeben",
  "evaluation.overview.edit_schedule": "Freigabe bearbeiten",
  "evaluation.overview.reuse_last_schedule": "Letzte Einstellung übernehmen",
  "evaluation.overview.schedule_save_failed": "Die Freigabe konnte nicht gespeichert werden.",
  "evaluation.overview.make_visible": "Sichtbar machen",
  "evaluation.overview.set_visible_date": "Sichtbarkeitsdatum setzen",
  "evaluation.overview.set_due_date": "Frist setzen",
  "evaluation.overview.reuse_last_schedule_with_dates": "Sichtbar ab: {{from}} · Bearbeitbar bis: {{until}}",
  "evaluation.overview.edit_visibility_all": "Freigabe für alle bearbeiten",
  "evaluation.overview.hide_material_all": "Für alle ausblenden",
  "evaluation.overview.visibility_all_description": "Gemeinsame Termine gelten für Schüler:innen ohne individuelle Einstellungen.",
  "evaluation.overview.title": "Lernfortschritt",
  "evaluation.overview.subtitle": "Fortschritt deiner Schüler:innen über alle Kursmaterialien",
  "evaluation.onboarding.empty_title": "Noch keine Schüler:innen in diesem Kurs",
  "evaluation.onboarding.empty_description": "Erstelle Schüler:innen, um hier Materialien für einzelne Schüler:innen freizuschalten und ihren Fortschritt in Echtzeit zu sehen. Die Beispieldaten verschwinden dann.",
  "evaluation.onboarding.empty_description_readonly": "Sobald Schüler:innen im Kurs sind, siehst du hier ihren Fortschritt in Echtzeit.",
  "evaluation.onboarding.sample_material_1": "Einstiegsquiz",
  "evaluation.onboarding.sample_material_2": "Arbeitsblatt",
  "evaluation.onboarding.sample_material_3": "Rückblick",
  "evaluation.onboarding.sample_material_4": "Lernvideo",
  "evaluation.onboarding.sample_material_5": "Lückentext",
  "evaluation.onboarding.sample_material_6": "Kurztest",
  "evaluation.onboarding.sample_material_7": "Lesetext",
  "evaluation.onboarding.sample_material_8": "Zuordnen",
  "evaluation.onboarding.sample_material_9": "Hausübung",
  "evaluation.onboarding.sample_material_10": "Rätsel",
  "evaluation.onboarding.sample_material_11": "Projekt",
  "evaluation.onboarding.sample_material_12": "Selbsttest",
  "evaluation.onboarding.sample_material_13": "Mindmap",
  "evaluation.onboarding.sample_material_14": "Endtest",
  "evaluation.overview.no_materials": "Dieser Kurs hat noch keine Materialien.",
  "evaluation.overview.no_materials_in_folder": "Dieser Ordner enthält keine Materialien.",
  "evaluation.overview.no_materials_matching_filter": "Keine Materialien entsprechen diesem Filter.",
  "evaluation.overview.load_error": "Der Lernfortschritt konnte nicht geladen werden.",
  "evaluation.overview.all_folders": "Alle Ordner",
  "evaluation.overview.unsorted_folder": "Unsortiert",
  "evaluation.overview.filter_interactive": "Mit interaktiven Aufgaben",
  "evaluation.overview.filter_shared": "Mit Schüler:innen geteilt",
  "evaluation.overview.legend.hidden": "Für Schüler:in ausgeblendet",
  "evaluation.overview.legend.hidden_with_submissions": "Ausgeblendet, aber Antworten vorhanden",
  "evaluation.overview.legend.time_since_last_answer": "Zeit seit der letzten Antwort",
  "evaluation.overview.legend.time_example": "20m",
  "evaluation.overview.live_now": "Jetzt",
  "evaluation.overview.live_tooltip": "In den letzten drei Minuten an diesem Material aktiv",
  "evaluation.overview.last_answer": "Letzte Antwort",
  "evaluation.overview.needs_help_tooltip": "Braucht Hilfe: mindestens drei falsche oder teilweise korrekte Antworten in Folge",
  "evaluation.overview.show_material": "Material für Schüler:in einblenden",
  "evaluation.overview.hide_material": "Material für Schüler:in ausblenden",
  "evaluation.overview.open_feedback": "Rückmeldung zu diesem Material öffnen",
  "evaluation.overview.feedback_given": "Rückmeldung oder Notiz zu diesem Material vorhanden",
  "evaluation.overview.new_answers": "Neue Antworten seit der letzten Rückmeldung",
  "evaluation.overview.non_interactive_material": "Material enthält keine interaktiven Aufgaben",
  "teacher_feedback.label": "Rückmeldung deiner Lehrkraft",
  "teacher_feedback.show_more": "Mehr anzeigen",
  "teacher_feedback.show_less": "Weniger anzeigen",
  "evaluation.mobile.show_feedback": "Rückmeldung anzeigen",
  "evaluation.mobile.hide_feedback": "Rückmeldung ausblenden",
  "evaluation.dialog.static_material_title": "Statisches Material",
  "evaluation.dialog.static_material_hint": "Dieses Material enthält keine interaktiven Aufgaben, daher gibt es hier keine Antworten. Du kannst trotzdem eine Notiz oder Beurteilung für {{name}} erfassen.",
  "evaluation.dialog.not_submitted_yet": "{{name}} hat diese Aufgabe noch nicht bearbeitet.",
  "evaluation.dialog.task_title": "Aufgabe",
  "evaluation.file_upload.submission": "Abgabe",
  "evaluation.file_upload.many_submissions": "Abgaben",
  "evaluation.file_upload.submissions_count": "Abgaben: {{count}}",
  "material_card.view_feedback": "Rückmeldung ansehen",
  "grades.grade_column": "Note",
  "grades.enable_grades": "Notenschema wählen",
  "grades.notes_only": "Nur Notizen",
  "grades.note_for_student": "Notiz für {{name}}",
  "grades.save_for_student_one": "Für {{count}} Schüler:in speichern",
  "grades.save_for_student_many": "Für {{count}} Schüler:innen speichern",
  "grades.quick_note_placeholder": "Notiz …",
  "grades.documentation_title_placeholder": "z. B. Gruppenarbeit",
  "grades.tags_for_student": "Tags für {{name}}",
  "grades.worksheet_keyboard_hint": "Enter: nächste Person · Umschalt + Enter: neue Zeile",
  "grades.tag_for_student": "{{tag}} für {{name}}",
  "grades.tag": "Tag",
  "grades.start_empty": "Leer starten",
  "grades.edit_documentation": "Dokumentation bearbeiten",
  "grades.tab_title": "Dokumentation",
  "grades.grade_categories": "Beurteilungskategorien",
  "grades.tags": "Tags",
  "grades.student": "Schüler:in",
  "grades.students": "Schüler:innen",
  "grades.manage_students": "Schüler:innen verwalten",
  "grades.filter": "Filter",
  "grades.reset_filters": "Zurücksetzen",
  "grades.add_note": "Notiz hinzufügen",
  "grades.add_grade": "Beurteilung hinzufügen",
  "grades.add_documentation": "Dokumentation erfassen",
  "grades.add_students_before_documentation": "Füge zuerst Schüler:innen hinzu, um Dokumentationen zu erfassen.",
  "grades.add_entries": "Einträge hinzufügen",
  "grades.delete_documentation_confirm": "Möchtest du diese Dokumentation wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "grades.discard_note_title": "Ohne Speichern schließen?",
  "grades.discard_note_message": "Deine nicht gespeicherten Änderungen gehen verloren.",
  "grades.discard_note_confirm": "Verwerfen",
  "grades.discard_note_keep": "Weiter bearbeiten",
  "grades.edit_grade": "Note bearbeiten",
  "grades.edit_note": "Notiz bearbeiten",
  "grades.overview_settings": "Ansicht konfigurieren",
  "grades.overview_subtitle": "Beurteilungen und Dokumentationen aller Schüler:innen im Überblick",
  "grades.overview_settings_description": "Lege fest, welche Beurteilungskategorien, Durchschnitte und Tags in der Übersicht angezeigt werden. Ziehe Einträge, um ihre Reihenfolge zu ändern.",
  "grades.shown_in_overview": "In Übersicht anzeigen",
  "grades.date": "Datum",
  "grades.entry_date": "Eintragsdatum",
  "grades.title_placeholder": "Titel hinzufügen …",
  "grades.bulk_title_placeholder": "Titel für alle Beurteilungen hinzufügen …",
  "grades.grade_category": "Beurteilungskategorie",
  "grades.choose_grade_category": "Beurteilungskategorie auswählen",
  "grades.change_grade_category": "Beurteilungskategorie ändern",
  "grades.choose_grade_category_hint": "Wähle eine Beurteilungskategorie aus, um fortzufahren.",
  "grades.grade": "Beurteilung",
  "grades.choose_grade": "Beurteilung auswählen",
  "grades.note": "Notiz",
  "grades.observations": "Notizen",
  "grades.note_placeholder": "Notiz hinzufügen …",
  "grades.grade_and_note": "Beurteilung und Notiz",
  "grades.documentation": "Dokumentation",
  "grades.grade_for_student": "Beurteilung für {{name}}",
  "grades.no_matching_grades": "Keine passenden Beurteilungen",
  "grades.no_students": "Sobald du Schüler:innen zu diesem Kurs hinzugefügt hast, kannst du hier Bewertungen und Dokumentationen erfassen.",
  "grades.no_students_title": "Keine Schüler:innen vorhanden",
  "grades.no_students_course_settings": "Füge Schüler:innen unter Kurseinstellungen hinzu, um Beurteilungen und Notizen zu erfassen.",
  "grades.add_documentation_archived": "Dieser Kurs wurde gelöscht. Es können keine Dokumentationen mehr erfasst werden.",
  "grades.onboarding.empty_title": "Noch keine Schüler:innen in diesem Kurs",
  "grades.onboarding.empty_description": "Erstelle Schüler:innen, um Beurteilungen und Notizen zu erfassen. Die Beispieldaten verschwinden dann, und „Dokumentation erfassen“ wird aktiv.",
  "grades.onboarding.empty_description_readonly": "Sobald Schüler:innen im Kurs sind, erscheinen ihre Beurteilungen und Notizen hier.",
  "grades.onboarding.settings_hint": "Unter {{settings}} kannst du Beurteilungskategorien, Durchschnitte und Tags anpassen.",
  "grades.onboarding.settings_hint_no_categories": "Dieser Kurs hat noch keine Beurteilungskategorien. Lege sie unter {{settings}} an.",
  "grades.onboarding.sample_category_mark": "Schularbeit",
  "grades.onboarding.sample_category_participation": "Mitarbeit",
  "grades.onboarding.sample_tag_homework": "Hausübung vergessen",
  "grades.onboarding.sample_tag_positive": "Positiver Beitrag",
  "grades.saved_grade_title": "Beurteilung gespeichert",
  "grades.saved_note_title": "Notiz gespeichert",
  "grades.saved_entries_one": "Eintrag für {{count}} Schüler:in erstellt",
  "grades.saved_entries_many": "Einträge für {{count}} Schüler:innen erstellt",
  "grades.load_error": "Die Beurteilungen konnten nicht geladen werden.",
  "grades.move_up": "Nach oben verschieben",
  "grades.move_down": "Nach unten verschieben",
  "grades.new_grade_category": "Neue Beurteilungskategorie",
  "grades.grade_category_name_required": "Bitte gib einen Namen für die Beurteilungskategorie ein.",
  "grades.grade_visualization": "Darstellung der Beurteilung",
  "grades.no_grade_categories": "Noch keine Beurteilungskategorien vorhanden.",
  "grades.import_grading_structure": "Kategorien, Durchschnitte und Tags aus anderem Kurs übernehmen",
  "grades.import_grading_structure_description": "Wähle den Kurs, dessen Kategorien, Durchschnitte und Tags übernommen werden sollen.",
  "grades.import_grading_structure_select_course": "Kurs",
  "grades.import_grading_structure_confirm": "Übernehmen",
  "grades.import_grading_structure_success": "Kategorien, Durchschnitte und Tags wurden übernommen.",
  "grades.import_grading_structure_no_other_courses": "Du hast keine weiteren Kurse, aus denen du übernehmen kannst.",
  "grades.import_grading_structure_list_categories_one": "{{count}} Kategorie",
  "grades.import_grading_structure_list_categories_other": "{{count}} Kategorien",
  "grades.import_grading_structure_list_averages_one": "{{count}} Durchschnitt",
  "grades.import_grading_structure_list_averages_other": "{{count}} Durchschnitte",
  "grades.import_grading_structure_list_tags_one": "{{count}} Tag",
  "grades.import_grading_structure_list_tags_other": "{{count}} Tags",
  "grades.import_grading_structure_list_failed": "Nicht geladen",
  "grades.import_grading_structure_warning": "Bereits erfasste Beurteilungen in „{{courseName}}“ gehen dabei verloren.",
  "grades.average": "Durchschnitt",
  "grades.averages": "Durchschnitte",
  "grades.new_average": "Neuer Durchschnitt",
  "grades.no_averages": "Keine Durchschnitte konfiguriert.",
  "grades.category_average": "Kategoriedurchschnitt",
  "grades.export_csv.grade_column": "{{category}} ({{index}})",
  "grades.export_csv.category_average_column": "{{category}} ({{averageSymbol}})",
  "grades.export_csv.duplicate_column": "{{name}} ({{index}})",
  "grades.class_average": "Klassendurchschnitt",
  "grades.timeframe": "Zeitraum",
  "grades.whole_school_year": "Ganzes Schuljahr",
  "grades.custom_timeframe": "Eigener Zeitbereich",
  "grades.weighting": "Gewichtung",
  "grades.equal_weighting": "Gleich gewichtet",
  "grades.custom_weighting": "Eigene Gewichtung",
  "grades.total_weight": "Gesamtgewichtung",
  "grades.total_weight_validation": "Die Gesamtgewichtung muss 100 % ergeben, bevor du speichern kannst.",
  "grades.category_weight_validation": "Jede ausgewählte Kategorie muss mit mehr als 0 % gewichtet sein.",
  "grades.distribute_equally": "Gleich verteilen",
  "grades.grade_invalid_level_removed": "Diese Beurteilung passt nicht mehr zu einer Stufe im aktuellen Schema. Die Stufe wurde möglicherweise entfernt oder geändert.",
  "grades.grade_invalid_scheme_changed": "Diese Beurteilung verwendet ein älteres Schema als die Kategorie. Wähle die Beurteilung erneut.",
  "grades.grade_invalid_scheme_unavailable": "Das Beurteilungsschema für diese Note ist nicht mehr verfügbar. Öffne den Eintrag und wähle die Beurteilung erneut.",
  "grades.new_tag": "Neuer Tag",
  "grades.tag_color": "Tag-Farbe",
  "grades.grading_scheme_group": "Schema-Gruppe",
  "grades.grading_scheme_group_generic": "Allgemeine Typen",
  "grades.grading_scheme_group_other": "Andere",
  "grades.grading_scheme_name_thumbs_three_level": "Daumen",
  "grades.grading_scheme_name_not_fulfilled_fulfilled": "Nicht erfüllt / erfüllt",
  "grades.grading_scheme_name_one_to_five_detailed": "1–5 detailliert",
  "grades.grading_scheme_name_one_to_ten_detailed": "1–10 detailliert",
  "grades.grading_scheme_name_us": "US-Buchstabennoten",
  "grades.grading_scheme_name_plant_growth": "Kompetenzblume",
  "grades.import_grading_structure_unavailable_schemes": "Dieser Kurs verwendet hier nicht verfügbare Beurteilungsschemata: {{schemeNames}}. Wähle einen anderen Kurs oder ersetze diese Schemata im ursprünglichen Kurs.",
  "grades.add_grading_scheme": "Neues Schema",
  "grades.edit_grading_scheme": "Beurteilungsschema bearbeiten",
  "grades.delete_grading_scheme_title": "Beurteilungsschema löschen?",
  "grades.delete_grading_scheme_message": "„{{name}}“ löschen? Bestehende Noten behalten ihre Werte; das Schema erscheint nicht mehr in der Auswahl.",
  "grades.custom_scheme_name_required": "Gib einen Namen für das Beurteilungsschema ein.",
  "grades.custom_scheme_name_too_long": "Der Name des Beurteilungsschemas darf maximal {{maxLength}} Zeichen haben.",
  "grades.custom_scheme_label_mode": "Stufenbeschriftungen",
  "grades.custom_scheme_label_text": "Text",
  "grades.custom_scheme_label_emoji": "Emoji",
  "grades.custom_scheme_supports_average": "Zählt zur Durchschnittsberechnung",
  "grades.custom_scheme_label_too_long": "Die Bezeichnung einer Stufe darf maximal {{maxLength}} Zeichen haben.",
  "grades.custom_scheme_levels": "Stufe",
  "grades.custom_scheme_level_label": "Beschriftung",
  "grades.custom_scheme_default_level_low": "Schwach",
  "grades.custom_scheme_default_level_mid": "Mittel",
  "grades.custom_scheme_default_level_high": "Gut",
  "grades.custom_scheme_level_value": "Wert",
  "grades.custom_scheme_level_grade_value": "Notenwert",
  "grades.custom_scheme_add_level": "Stufe hinzufügen",
  "grades.custom_scheme_duplicate_label": "Jede Stufe braucht eine eindeutige Beschriftung.",
  "grades.custom_scheme_duplicate_emoji": "Jede Stufe braucht ein eindeutiges Emoji.",
  "grades.custom_scheme_duplicate_value": "Jeder numerische Wert muss eindeutig sein.",
  "grades.custom_scheme_label_required": "Gib für jede Stufe eine Beschriftung ein.",
  "grades.custom_scheme_value_required": "Gib für jede Stufe eine gültige Zahl zwischen 0 und 100 ein.",
  "grades.no_tags": "Noch keine Tags vorhanden.",
  "grades.no_matching_documentation": "Keine Dokumentation entspricht den ausgewählten Filtern.",
  "grades.no_documentation_yet": "Für diese:n Schüler:in gibt es noch keine Dokumentation.",
  "grades.ai_generated_pending": "Von der KI erstellt · Freigabe ausstehend",
  "grades.ai_generated_approved": "Von der KI erstellt · Freigegeben",
  "grades.approve_ai_entry": "Freigeben",
  "grades.documentation_count": "Einträge: {{count}}",
  "grades.export_student_csv": "Alle Einträge als CSV exportieren",
  "grades.select_tag_for_all_students": "„{{tag}}“ für alle Schüler:innen auswählen",
  "grades.clear_tag_for_all_students": "„{{tag}}“ für alle Schüler:innen abwählen",
  "grades.view_details": "Details ansehen",
  "grades.colors.grey": "Grau",
  "grades.colors.amber": "Bernstein",
  "grades.colors.green": "Grün",
  "grades.colors.red": "Rot",
  "grades.colors.blue": "Blau",
  "grades.colors.violet": "Violett",
  "sample_preview.row_tag": "Beispiel",
  "sample_preview.hide": "Beispieldaten ausblenden",
  "sample_preview.show": "Beispieldaten anzeigen",
  "sample_preview.student_1": "Anna Huber",
  "sample_preview.student_2": "Ben Gruber",
  "sample_preview.student_3": "Lea Wagner",
  "generic_print": "Drucken",
  "timetable.empty_state_manual_title": "Manuell erstellen",
  "timetable.empty_state_manual_description": "Erstelle und verwalte deinen Stundenplan direkt in Teachino.",
  "timetable.empty_state_integration_title": "Bestehenden Stundenplan verbinden",
  "timetable.empty_state_integration_description": "Synchronisiere deinen Unterricht mit dem Stundenplansystem deiner Schule.",
  "timetable.empty_state_integration_action": "Stundenplan verbinden",
  "timetable.empty_state_integration_dialog_title": "Bestehenden Stundenplan verbinden",
  "timetable.no_lessons_in_week_title": "In dieser Woche hast Du keinen Unterricht",
  "timetable.no_lessons_in_week_description": "Dein Stundenplan ist eingetragen. Deine nächste Stunde ist am {{date}}.",
  "timetable.no_lessons_in_week_none_upcoming": "Dein Stundenplan ist eingetragen, es sind aber keine weiteren Stunden geplant.",
  "timetable.no_lessons_in_week_action": "Zu dieser Woche springen",
  "timetable.breadcrumb.courses": "Kurse",
  "timetable.tabs.vacations": "Ferien hinzufügen",
  "timetable.tabs.timetables": "Stundenpläne erstellen",
  "timetable.tabs.weeks": "Schulwochen zuweisen",
  "timetable.continue.timetables": "Weiter zu den Stundenplänen",
  "timetable.continue.weeks": "Weiter zur Wochenzuweisung",
  "timetable.saving": "Wird gespeichert …",
  "timetable.external_integration.title": "Dein Stundenplan bleibt automatisch aktuell",
  "timetable.external_integration.description": "{{source}} verwaltet deinen Stundenplan. Deshalb kann er hier nicht bearbeitet werden. Unten kannst du importierte Kurse deinen Teachino-Kursen zuordnen.",
  "timetable.profile_prefill.title": "Land / Bundesland ergänzen, um Ferien vorauszufüllen",
  "timetable.profile_prefill.description": "Ergänze Schulstandort und Schulart in den Profileinstellungen, um offizielle Ferien vorauszufüllen.",
  "timetable.profile_prefill.action": "Land / Bundesland ergänzen",
  "timetable.mode.title": "Wie verändert sich dein Stundenplan im Laufe des Jahres?",
  "timetable.mode.description": "Wähle die passende Variante für dein Schuljahr. Du kannst später weitere Stundenpläne hinzufügen.",
  "timetable.mode.single_title": "Gleicher Stundenplan für das gesamte Jahr",
  "timetable.mode.single_description": "Beginne mit einem Stundenplan und verwende ihn für jede Unterrichtswoche.",
  "timetable.mode.multiple_title": "Wechselnde Stundenpläne",
  "timetable.mode.multiple_description": "Beginne mit Woche A und Woche B und weise sie anschließend im Schuljahr zu.",
  "timetable.vacations.title": "Ferien",
  "timetable.vacations.description": "Ferienwochen werden beim Zuweisen von Stundenplänen übersprungen.",
  "timetable.vacations.add": "Ferien hinzufügen",
  "timetable.vacations.edit": "Ferien bearbeiten",
  "timetable.vacations.remove": "Ferien entfernen",
  "timetable.vacations.empty_title": "Keine Ferien hinzugefügt",
  "timetable.vacations.empty_description": "Füge Ferien hinzu, die bei der Stundenplanzuweisung übersprungen werden sollen.",
  "timetable.vacations.empty_action": "Erste Ferien hinzufügen",
  "timetable.vacations.dialog_add_title": "Ferien hinzufügen",
  "timetable.vacations.dialog_edit_title": "Ferien bearbeiten",
  "timetable.vacations.start_date": "Startdatum",
  "timetable.vacations.end_date": "Enddatum",
  "timetable.vacations.invalid_dates": "Das Enddatum muss am oder nach dem Startdatum liegen.",
  "timetable.pattern.title": "Stundenpläne",
  "timetable.pattern.description": "Einmal erstellen und beliebigen Wochen zuweisen.",
  "timetable.pattern.add": "Stundenplan hinzufügen",
  "timetable.pattern.new": "Neuer Stundenplan",
  "timetable.pattern.week_a": "Woche A",
  "timetable.pattern.week_b": "Woche B",
  "timetable.pattern.new_numbered": "Neuer Stundenplan {{number}}",
  "timetable.pattern.school_year_name": "Stundenplan {{schoolYear}}",
  "timetable.pattern.copy": "{{name}} – Kopie",
  "timetable.pattern.empty": "Leerer Stundenplan",
  "timetable.pattern.lesson_count_one": "{{count}} Unterrichtseinheit",
  "timetable.pattern.lesson_count_many": "{{count}} Unterrichtseinheiten",
  "timetable.pattern.name": "Name des Stundenplans",
  "timetable.pattern.cell_hint": "Klicke auf eine Zelle, um den Kurs auszuwählen oder zu ändern.",
  "timetable.pattern.add_more": "Weitere Stundenpläne hinzufügen",
  "timetable.pattern.minimum_one": "Mindestens ein Stundenplan ist erforderlich",
  "timetable.pattern.duplicate": "Kopieren",
  "timetable.pattern.period": "Stunde",
  "timetable.pattern.no_course": "Kein Kurs",
  "timetable.pattern.empty_cells": "Leere Zellen bedeuten, dass du in dieser Stunde keinen Unterricht hast.",
  "timetable.periods.title": "Zeitraster bearbeiten",
  "timetable.periods.description": "Passe alle Stundenzeiten auf einmal an. Verwendete Stundenpläne werden sofort aktualisiert.",
  "timetable.periods.start": "Start",
  "timetable.periods.end": "Ende",
  "timetable.periods.invalid": "Jede Stunde benötigt eine Endzeit nach ihrer Startzeit.",
  "timetable.periods.save": "Stundenzeiten speichern",
  "timetable.delete.title": "Stundenplan löschen?",
  "timetable.delete.message": "„{{name}}“ löschen? Wochen, die ihn verwenden, benötigen anschließend einen neuen Stundenplan.",
  "timetable.delete.planned_lessons_explainer": "Bereits geplante Unterrichtsstunden sind erst wieder verfügbar, wenn für denselben Zeitraum ein neuer Stundenplan hinzugefügt wurde.",
  "timetable.delete.action": "Stundenplan löschen",
  "timetable.weeks.description": "Weise jeder Unterrichtswoche einen wiederverwendbaren Stundenplan zu.",
  "timetable.weeks.calendar_week": "KW",
  "timetable.weeks.vacation": "Ferien",
  "timetable.weeks.vacation_starts_midweek": "beginnt am {{date}}",
  "timetable.weeks.vacation_ends_midweek": "endet am {{date}}",
  "timetable.weeks.vacation_within_week": "beginnt am {{startDate}} und endet am {{endDate}}",
  "timetable.weeks.choose": "Stundenplan auswählen …",
  "timetable.weeks.apply_prompt": "Diesen Stundenplan für alle folgenden Unterrichtswochen verwenden? Ferienwochen werden übersprungen.",
  "timetable.weeks.not_now": "Nicht jetzt",
  "timetable.weeks.apply_every_second": "Auf jede zweite Woche anwenden",
  "timetable.weeks.apply_all_future": "Auf alle zukünftigen Wochen anwenden",
  "timetable.weeks.all_assigned": "Alle Wochen zugewiesen",
  "timetable.weeks.needs_attention_one": "{{count}} Woche benötigt Aufmerksamkeit",
  "timetable.weeks.needs_attention_many": "{{count}} Wochen benötigen Aufmerksamkeit",
  "timetable.weekday.monday": "Montag",
  "timetable.weekday.tuesday": "Dienstag",
  "timetable.weekday.wednesday": "Mittwoch",
  "timetable.weekday.thursday": "Donnerstag",
  "timetable.weekday.friday": "Freitag",
  "timetable.period.number": "{{number}}. Stunde",
  "timetable.period.1": "1. Stunde",
  "timetable.period.2": "2. Stunde",
  "timetable.period.3": "3. Stunde",
  "timetable.period.4": "4. Stunde",
  "timetable.period.5": "5. Stunde",
  "timetable.period.6": "6. Stunde",
  "planning.title": "Planung",
  "planning.heading": "Unterricht planen",
  "planning.open_full_planning": "Gesamte Planung öffnen",
  "planning.add_lesson_short": "Stunde",
  "planning.add_additional_lesson": "Zusätzliche Stunde hinzufügen",
  "planning.description": "Materialien, Notizen und To-dos über alle Unterrichtstermine hinweg.",
  "planning.read_only_description": "Gespeicherte Materialien, Notizen und To-dos für alle Termine dieses Schuljahres.",
  "planning.vacation": "Ferien",
  "planning.cancelled_lesson": "Entfallen",
  "planning.no_scheduled_lesson": "Keine geplante Unterrichtsstunde",
  "planning.period_tags": "Stundenmarkierungen",
  "planning.other_teacher_lesson": "Unterricht von {{teacher}}",
  "planning.shared_teacher_lesson": "Unterricht mit {{teacher}}",
  "planning.enlarge_note": "Notiz vergrößern",
  "planning.note_autosaved": "Änderungen werden automatisch gespeichert.",
  "planning.class_register_needs_review": "Klassenbucheintrag prüfen",
  "planning.class_register_needs_review_description": "Prüfe den gespeicherten Eintrag und aktualisiere ihn bei Bedarf anhand der aktuellen Planung.",
  "planning.update_class_register_from_plan": "Aus aktueller Planung aktualisieren",
  "planning.notes": "Notizen",
  "planning.materials": "Materialien",
  "planning.todos": "To-dos",
  "planning.note": "Notiz",
  "planning.material": "Material",
  "planning.todo": "To-do",
  "planning.add_note": "Notiz hinzufügen",
  "planning.add_material": "Material hinzufügen",
  "planning.collection_material_planned": "Geplant",
  "planning.collection_material_exists.title": "Material bereits im Kurs",
  "planning.collection_material_exists.description": "„{{materialName}}“ ist bereits im Kurs im Ordner „{{folderName}}“. Möchtest du dieses Material planen oder eine weitere Kopie erstellen und planen?",
  "planning.collection_material_exists.intro": "Dieses Material ist bereits in deinem Kurs.",
  "planning.collection_material_exists.choose_action": "Wie möchtest du fortfahren?",
  "planning.collection_material_exists.plan_existing": "Vorhandenes planen",
  "planning.collection_material_exists.plan_existing_title": "Vorhandenes planen",
  "planning.collection_material_exists.plan_existing_hint": "Material aus dem Kurs zur Stunde hinzufügen, ohne erneut zu kopieren.",
  "planning.collection_material_exists.copy_again": "Erneut kopieren und planen",
  "planning.collection_material_exists.copy_again_title": "Kopie erstellen und planen",
  "planning.collection_material_exists.copy_again_hint": "Neue Kopie im Kurs anlegen und zur Stunde hinzufügen.",
  "planning.import_folder_and_plan.button_short": "Ordner kopieren und planen",
  "planning.import_folder_and_plan.planned_success": "{{count}} Materialien wurden für diese Lektion geplant.",
  "planning.import_folder_and_plan.none_planned": "Der Ordner wurde kopiert, aber es konnten keine Materialien für diese Lektion geplant werden.",
  "planning.import_folder_copy.success": "Ordner wurde in deinen Kurs kopiert.",
  "planning.import_external_material.not_in_course_tag": "Noch nicht im Kurs",
  "planning.import_external_material.title": "Material noch nicht im Kurs",
  "planning.import_external_material.intro": "Dieses Material ist noch nicht in deinem Kurs. Wähle, wie du es hinzufügen möchtest, bevor du es planst.",
  "planning.import_external_material.choose_action": "Wie möchtest du fortfahren?",
  "planning.import_external_material.copy_material_title": "Nur dieses Material kopieren",
  "planning.import_external_material.copy_material_hint": "Wähle einen Ordner in deinem Kurs und plane anschließend dieses Material.",
  "planning.import_external_material.copy_folder_title": "Ganzen Ordner kopieren",
  "planning.import_external_material.copy_folder_hint": "Kopiere „{{folderName}}“ in deinen Kurs und plane anschließend dieses Material.",
  "planning.import_destination_folder.title": "Zielordner wählen",
  "planning.import_destination_folder.intro": "Wohin soll „{{materialName}}“ in diesem Kurs kopiert werden?",
  "planning.import_destination_folder.existing_title": "Vorhandener Ordner",
  "planning.import_destination_folder.existing_hint": "Material in einen Ordner kopieren, der bereits in diesem Kurs ist.",
  "planning.import_destination_folder.new_title": "Neuer Ordner",
  "planning.import_destination_folder.new_hint": "Einen neuen Ordner in diesem Kurs für das Material anlegen.",
  "planning.import_destination_folder.no_writable_folder": "Du kannst in keinen vorhandenen Ordner Materialien hinzufügen. Lege stattdessen einen neuen Ordner an.",
  "planning.import_destination_folder.no_destination_available": "Du kannst keine Materialien in diesen Kurs kopieren, weil kein Ordner verfügbar ist und du keinen anlegen darfst.",
  "planning.import_destination_folder.confirm": "Weiter",
  "planning.import_destination_folder.back_to_existing": "Vorhandenen Ordner wählen",
  "planning.import_destination_folder.folder_created_success": "Ordner „{{folderName}}“ wurde angelegt.",
  "planning.folder_exists.title": "Ordner bereits im Kurs",
  "planning.folder_exists.intro": "Dieser Ordner ist bereits in deinem Kurs.",
  "planning.folder_exists.plan_existing_title": "Vorhandenen Ordner planen",
  "planning.folder_exists.plan_existing_hint": "Materialien aus dem vorhandenen Ordner zur Stunde hinzufügen, ohne erneut zu kopieren.",
  "planning.folder_exists.copy_again_title": "Ordner erneut kopieren und planen",
  "planning.folder_exists.copy_again_hint": "Neuen Ordner im Kurs anlegen und alle Materialien zur Stunde hinzufügen.",
  "planning.folder_exists.copy_only_prompt": "Du kannst diesen Ordner erneut in deinen Kurs kopieren.",
  "planning.folder_exists.copy_again_title_copy_only": "Ordner erneut kopieren",
  "planning.folder_exists.copy_again_hint_copy_only": "Eine weitere Kopie dieses Ordners in deinem Kurs anlegen.",
  "planning.add_todo": "To-do hinzufügen …",
  "planning.add_event": "Markierung hinzufügen",
  "planning.choose_start_date": "Startdatum auswählen",
  "planning.today": "Heute",
  "planning.retry": "Erneut versuchen",
  "planning.load_failed": "Planung konnte nicht geladen werden",
  "planning.no_upcoming_lessons": "Kein Unterricht geplant",
  "planning.no_upcoming_lessons_description": "Für diesen Kurs gibt es keine weiteren Termine.",
  "planning.vacation_only_title": "Nur Ferien geplant",
  "planning.vacation_only_description": "Für diesen Kurs gibt es noch keinen Stundenplan. Lege einen an, um mit der Planung zu beginnen.",
  "planning.no_saved_content": "Keine gespeicherten Planungsinhalte",
  "planning.no_saved_content_description": "Für dieses Schuljahr sind keine Materialien, Notizen oder To-dos gespeichert.",
  "planning.move_material": "Material verschieben",
  "planning.remove_material": "Material entfernen",
  "planning.remove_tag": "{{tag}} entfernen",
  "planning.shift": "Planung nach hinten schieben",
  "planning.shift_question": "Planung nach hinten schieben?",
  "planning.shift_all": "Planung ab hier nach hinten schieben",
  "planning.shift_success": "Die Planung wurde nach hinten geschoben.",
  "planning.shift_failed": "Die Planung konnte nicht verschoben werden.",
  "planning.shift_no_next": "Es gibt keine nächste Unterrichtsstunde.",
  "planning.shift_blocked": "Es gibt nicht genügend weitere Unterrichtstermine, um {{content}} weiterzuschieben. Entferne oder verschiebe diese Inhalte zuerst.",
  "planning.shift_description": "Alle ausgewählten Inhalte ab {{date}} werden jeweils in die nächste Unterrichtsstunde verschoben.",
  "planning.class_register": "Klassenbuch",
  "planning.current_period": "Jetzt: {{title}} von {{from}} bis {{to}}",
  "planning.class_register_draft": "Klassenbuch-Entwurf",
  "planning.class_register_completed": "Klassenbuch gesendet",
  "planning.class_register_saved_locally": "Lehrstoff gespeichert",
  "planning.saved": "Gespeichert",
  "planning.not_saved": "Nicht gespeichert",
  "planning.note_placeholder": "Notiz eintippen",
  "planning.delete": "Löschen",
  "planning.toggle_todo": "To-do erledigt umschalten",
  "planning.edit_todo": "To-do bearbeiten",
  "planning.move_todo_date": "Auf ein anderes Datum verschieben",
  "planning.close": "Schließen",
  "planning.cancel": "Abbrechen",
  "planning.material_load_failed": "Kursmaterialien konnten nicht geladen werden.",
  "planning.manage_tags": "Markierungen verwalten",
  "planning.create_tag": "Markierung erstellen",
  "planning.delete_tag": "Markierung löschen",
  "planning.save_draft": "Als Entwurf speichern",
  "planning.send_class_register": "An Klassenbuch senden",
  "planning.copy_class_register": "Klassenbucheintrag kopieren",
  "planning.class_register_content": "Klassenbucheintrag",
  "planning.previous": "Zurück",
  "planning.next": "Weiter",
  "planning.todos_for_date": "Persönliche To-dos für {{date}}",
  "planning.move_note": "Notiz verschieben",
  "todo_more": "+{{count}} weitere",
  "generic_yes": "Ja",
  "generic_no": "Nein",
  "dpa.eyebrow": "Auftragsverarbeitungsvertrag",
  "dpa.title": "AVV für deine Schule",
  "dpa.legal_explanation": "Der Auftragsverarbeitungsvertrag (AVV) regelt die Verarbeitung personenbezogener Daten durch Teachino und unterstützt deine Schule bei der Erfüllung ihrer datenschutzrechtlichen Pflichten.",
  "dpa.download": "AVV herunterladen",
  "dpa.document.description": "Aktuelle AVV als PDF herunterladen",
  "dpa.document.last_changed": "Letzte Änderung",
  "dpa.privacy_link": "Datenschutzinformationen",
  "dpa.privacy.description": "Weitere Informationen zum Umgang mit personenbezogenen Daten und KI bei Teachino",
  "dpa.privacy.info_label": "Nur zur Information",
  "dpa.existing.question": "Unterschriftsprozess starten",
  "dpa.existing.explanation": "Im nächsten Schritt kannst du die AVV unterzeichnen oder an deine Schulleitung weitergeben. Falls deine Schule bereits eine AVV mit Teachino abgeschlossen hat, ist kein neuer Vertrag notwendig. Gib dann die Schuldaten an und wir ordnen die bestehende AVV zu.",
  "dpa.existing.answer_yes": "Meine Schule hat bereits eine AVV unterzeichnet",
  "dpa.existing.answer_no": "Neue AVV unterzeichnen",
  "dpa.school.title": "Angaben zur Schule",
  "dpa.school.name": "Name der Schule",
  "dpa.school.address": "Vollständige Adresse",
  "dpa.leadership.question": "Handelst du im Auftrag der Schulleitung?",
  "dpa.no_cost": "Für die Schule entstehen durch den Abschluss der AVV keine Kosten.",
  "dpa.direct.title": "AVV prüfen und unterzeichnen",
  "dpa.signer.name": "Vollständiger Name",
  "dpa.signer.email": "E-Mail-Adresse",
  "dpa.signer.email_help": "Wir senden einen sechsstelligen Bestätigungscode an diese Adresse. Verwende bitte deine schulische E-Mail-Adresse.",
  "dpa.accept": "Ich habe die AVV gelesen, bin für die Schule zeichnungsberechtigt und stimme der Vereinbarung zu.",
  "dpa.send_code": "Bestätigungscode senden",
  "dpa.code.title": "E-Mail bestätigen",
  "dpa.code.help": "Wir haben einen sechsstelligen Code per E-Mail gesendet. Der Code ist 30 Minuten gültig.",
  "dpa.code.label": "Bestätigungscode",
  "dpa.verify": "AVV unterzeichnen",
  "dpa.resend": "Code erneut senden",
  "dpa.handoff.title": "An die Schulleitung weitergeben",
  "dpa.handoff.help": "Schicke den untenstehenden Link an deine Schulleitung. Sie kann die AVV über diesen Link digital unterschreiben.",
  "dpa.handoff.link_label": "Link zur Unterzeichnung",
  "dpa.handoff.email_label": "Vorbereitete E-Mail",
  "dpa.copy_link": "Link kopieren",
  "dpa.copy_email": "E-Mail kopieren",
  "dpa.copied": "Kopiert",
  "dpa.review.title": "Anfrage übermittelt",
  "dpa.review.before_submit_title": "So geht es weiter",
  "dpa.review.before_submit_help": "Wenn du die Anfrage sendest, wird das Teachino-Team informiert. Wir prüfen deine Angaben so schnell wie möglich und melden uns bei dir.",
  "dpa.review.submit": "Anfrage senden",
  "dpa.review.help": "Wir prüfen, ob für deine Schule bereits eine AVV besteht, und melden uns in Kürze.",
  "dpa.signed.title": "AVV erfolgreich unterzeichnet",
  "dpa.signed.help": "Die Funktion wurde für deine persönliche Lizenz freigeschaltet.",
  "dpa.continue": "Zurück zu Teachino",
  "dpa.error.generic": "Das hat leider nicht funktioniert. Bitte versuche es erneut.",
  "dpa.error.invalid_code": "Der Code ist ungültig oder abgelaufen. Bitte prüfe ihn und versuche es erneut.",
  "dpa.public.title": "AVV für Teachino unterzeichnen",
  "dpa.public.review": "Schuldaten und Vereinbarung prüfen",
  "dpa.public.signed": "Vielen Dank – die AVV wurde unterzeichnet",
  "dpa.public.signed_help": "Die anfragende Lehrperson wurde informiert und die Funktion wurde freigeschaltet.",
  "dpa.public.invalid": "Dieser Link ist nicht mehr gültig",
  "dpa.public.invalid_help": "Der Link ist abgelaufen, wurde bereits verwendet oder durch einen neueren Vorgang ersetzt. Bitte wende dich an die anfragende Lehrkraft.",
  "dpa.trust.label": "Datenschutz und Vertrauen",
  "dpa.trust.gdpr.title": "Datenschutzrechtlicher Rahmen",
  "dpa.trust.gdpr.description": "Die AVV dokumentiert die datenschutzrechtlichen Rahmenbedingungen für die Verarbeitung personenbezogener Daten.",
  "dpa.trust.eu.title": "Datenverarbeitung in der EU",
  "dpa.trust.eu.description": "Die AVV beschreibt, wo und durch welche Auftragsverarbeiter personenbezogene Daten verarbeitet werden.",
  "dpa.trust.encryption.title": "Verschlüsselung",
  "dpa.trust.encryption.description": "Technische Schutzmaßnahmen sichern Daten bei der Übertragung und Speicherung.",
  "dpa.loading": "Vereinbarung wird geladen …",
  "dpa.code.sent_to": "Wir haben den Code an {{email}} gesendet.",
  "dpa.resend_in": "Erneut senden in {{seconds}} s",
  "dpa.error.code_rejected": "Dieser Code ist nicht mehr gültig. Bitte fordere einen neuen an.",
  "material.student_visibility.continue_without_students": "Ohne Schüler:innen fortfahren",
  "material.student_visibility.empty.title": "Noch keine Schüler:innen erstellt",
  "material.student_visibility.empty.create_students_description": "Erstelle Schüler:innen für deinen Kurs \"{{courseName}}\" und teile persönliche Zugangscodes aus.",
  "material.student_visibility.empty.without_students_description": "Alternativ: Schüler:innen öffnen den Link und geben Namen oder Kürzel selbst ein. Sie erhalten einen Code um später wieder zuzugreifen.",
  "material.student_visibility.empty.description": "Erstelle zuerst Schüler:innen. Sie erhalten einen persönlichen Code und können damit auf freigegebene Materialien sowie ihre eigenen Antworten und Abgaben zugreifen.",
  "material.unavailable.title": "Dieses Material ist nicht verfügbar",
  "material.unavailable.description": "Es wurde möglicherweise gelöscht oder du hast keinen Zugriff darauf.",
  "material.unavailable.action": "Zu meinen Kursen",
  "ai.assistant.action.folders_created": "{{count}} Ordner angelegt",
  "material.student_visibility.no_students.title": "Noch keine Schüler:innen",
  "material.student_visibility.no_students.description": "Es gibt zwei Wege, das Material mit Schüler:innen zu teilen: Erstelle die Schüler:innen selbst und teile Zugangscodes aus oder aktiviere den öffentlichen Link.",
  "material.student_visibility.no_students.public_link_description": "Schüler:innen mit diesem Link geben beim ersten Öffnen ihren Namen oder ein Kürzel selbst ein.",
  "ai.assistant.voice.starting": "Warte auf das Mikrofon…",
  "ai.assistant.voice.detected": "Ton erkannt",
  "ai.assistant.voice.quiet": "Kein Ton erkannt – prüfe dein Mikrofon",
  "ai.assistant.voice.ready": "Aufnahme beendet. Bereit zum Senden.",
  "ai.assistant.voice.change_microphone": "Mikrofon wechseln (startet eine neue Aufnahme)",
  "ai.assistant.voice.empty": "Es wurde keine Sprache erkannt. Bitte nimm deine Nachricht erneut auf.",
  "material.assignment_open_question.edited_by_teacher": "Von der Lehrkraft bearbeitet",
  "material.assignment_open_question.edit_feedback": "Feedback bearbeiten",
  "material.assignment_open_question.feedback_rating": "Emoji",
  "auth.two_factor.title": "Zwei-Faktor-Authentifizierung",
  "auth.two_factor.verify": "Bestätigen",
  "auth.two_factor.challenge_description": "Gib den sechsstelligen Code aus Deiner Authenticator-App oder einen Deiner Wiederherstellungscodes ein.",
  "auth.two_factor.code_label": "Authentifizierungscode",
  "auth.two_factor.invalid_or_expired": "Der Code ist ungültig oder abgelaufen. Bitte versuche es erneut.",
  "auth.two_factor.locked_out": "Nach zu vielen falschen Codes ist die Zwei-Faktor-Bestätigung vorübergehend gesperrt. Bitte versuche es in einigen Minuten erneut.",
  "auth.two_factor.setup_failed": "Die Zwei-Faktor-Authentifizierung konnte nicht eingerichtet werden.",
  "auth.two_factor.invalid_code": "Der Authentifizierungscode ist ungültig.",
  "auth.two_factor.enabled_description": "Die Zwei-Faktor-Authentifizierung ist für dein Konto aktiviert.",
  "auth.two_factor.setup_description": "Füge eine Authenticator-App hinzu, um dein Konto mit einem zweiten Anmeldeschritt zu schützen.",
  "auth.two_factor.scan_qr_description": "Scanne diesen QR-Code mit deiner Authenticator-App oder gib den Schlüssel manuell ein.",
  "auth.two_factor.six_digit_code": "Sechsstelliger Code",
  "auth.two_factor.enable": "Zwei-Faktor-Authentifizierung aktivieren",
  "auth.two_factor.code_placeholder": "Authenticator- oder Wiederherstellungscode",
  "auth.two_factor.regenerate_recovery_codes": "Neue Wiederherstellungscodes erstellen",
  "auth.two_factor.disable": "Zwei-Faktor-Authentifizierung deaktivieren",
  "auth.two_factor.setup": "Zwei-Faktor-Authentifizierung einrichten",
  "auth.two_factor.save_recovery_codes": "Speichere diese Wiederherstellungscodes jetzt. Sie werden nicht erneut angezeigt.",
  "auth.two_factor.download_recovery_codes": "Wiederherstellungscodes herunterladen",
  "course.add_content_menu.create_blank_material": "Leeres Material erstellen",
  "course.add_content_menu.create_link": "Link erstellen",
  "course.add_content_menu.upload_files": "Dateien hochladen",
  "course.create_link.url": "Link",
  "course.create_link.placeholder": "https://beispiel.at",
  "course.add_content_menu.new": "Neu",
  "ai.assistant.image_choice.preview_unavailable": "Vorschau nicht verfügbar",
  "ai.assistant.image_choice.open_source": "Quelle öffnen",
  "ai.assistant.image_choice.select": "Bild auswählen",
  "ai.assistant.image_choice.selected": "Ausgewählt",
  "ai.assistant.image_choice.use_selected": "Ausgewählte Bilder verwenden ({{count}})",
  "ai.assistant.image_choice.request": "Ich wähle diese Bilder für meine Anfrage:\n{{images}}",
  "ai.assistant.student_note.pending": "Freigabe ausstehend",
  "ai.assistant.student_note.approved": "Freigegeben",
  "ai.assistant.student_note.grade": "Bewertung",
  "ai.assistant.student_note.created": "KI generiert",
  "material.schedule.visible_from": "Sichtbar ab",
  "material.schedule.editable_until": "Bearbeitbar bis",
  "material.schedule.immediately": "Sofort",
  "material.schedule.no_deadline": "Ohne Frist",
  "material.schedule.timezone": "Zeitzone: {timezone}",
  "material.schedule.lesson": "Unterrichtsstunde wählen",
  "material.schedule.individual": "Individuelle Freigabe",
  "material.schedule.inherit": "Gemeinsamen Termin verwenden ({{date}})",
  "time_input.hours": "Stunden",
  "time_input.minutes": "Minuten",
  "material.navigation_notice.title": "Neue Navigation im Material",
  "material.navigation_notice.description": "Die Aktionen zum Material findest du jetzt rechts oben in der Navigationsleiste.",
  "material.navigation_notice.dismiss": "Nicht mehr anzeigen",
  "material.schedule.invalid_time": "Bitte gib eine gültige Uhrzeit ein, z. B. 08:30.",
  "material.schedule.invalid": "Die Frist muss nach dem Freigabezeitpunkt liegen.",
  "material.schedule.hidden": "Nicht freigegeben",
  "material.schedule.scheduled": "Geplant",
  "material.schedule.available": "Verfügbar",
  "material.schedule.expired": "Nur lesbar: Frist abgelaufen",
  "material.schedule.print_codes": "Zugangscodes drucken",
  "material.schedule.confirm": "Freigabe bestätigen",
  "material.schedule.change": "Ändern",
  "material.schedule.retry": "Erneut versuchen",
  "material.schedule.retry_lessons": "Terminvorschläge neu laden",
  "material.student_visibility.configure_individually": "Für jede:n Schüler:in einzeln festlegen",
  "material.student_visibility.confirm_release": "Material freischalten",
  "material.student_visibility.confirm_revoke": "Freigabe aufheben",
  "material.student_visibility.edit_settings": "Ändern",
  "material.student_visibility.editable_until": "Bearbeitbar bis",
  "material.student_visibility.immediately": "Sofort",
  "material.student_visibility.invalid_dates": "„Bearbeitbar bis“ muss am oder nach „Sichtbar ab“ liegen.",
  "material.student_visibility.tooltip_different_dates": "Unterschiedliche Daten pro Schüler:in",
  "material.student_visibility.tooltip_immediate_count": "{{count}} sofort",
  "material.student_visibility.tooltip_no_deadline_count": "{{count}} ohne Frist",
  "material.student_visibility.tooltip_individual_one": "{{count}} individueller Termin",
  "material.student_visibility.tooltip_individual_many": "{{count}} individuelle Termine",
  "material.student_visibility.tooltip_all": "Alle SuS",
  "material.student_visibility.tooltip_selected": "Alle ausgewählten SuS",
  "material.student_visibility.tooltip_others": "Alle anderen SuS",
  "material.student_visibility.tooltip_other_selected": "Alle anderen ausgewählten SuS",
  "material.student_visibility.no_deadline": "Ohne Frist",
  "material.student_visibility.no_upcoming_periods": "Keine weiteren Unterrichtstermine",
  "material.student_visibility.other_period": "Datum eingeben",
  "material.student_visibility.change_date": "Datum ändern",
  "material.student_visibility.periods_retry": "Unterrichtstermine erneut laden",
  "material.student_visibility.release_all": "Material für alle Schüler:innen freischalten",
  "material.student_visibility.release_audience": "Freigabe für {{visible}} von {{total}} Schüler:innen",
  "material.student_visibility.release_complete": "Material freigeschaltet",
  "material.student_visibility.release_revoked": "Freigabe aufgehoben",
  "material.student_visibility.release_scheduled": "Freigabe geplant",
  "material.student_visibility.release_student": "Für {{name}} freischalten",
  "material.student_visibility.release_summary": "Freigegeben für {{visible}} von {{total}} Schüler:innen",
  "material.student_visibility.release_summary_scheduled": "Freigabe für {{visible}} von {{total}} Schüler:innen geplant",
  "material.student_visibility.qr_description": "Dieser QR-Code führt direkt zum Material.",
  "course.distribute_access": "Zugänge austeilen",
  "material.student_visibility.share_title": "Austeilen",
  "material.student_visibility.release_title": "Materialfreigabe",
  "material.student_visibility.retry": "Erneut versuchen",
  "material.student_visibility.schedule_for_student": "Zeitraum für {{name}}",
  "material.student_visibility.share_link_error": "Der Materiallink konnte nicht geladen werden.",
  "material.student_visibility.visible_from": "Sichtbar ab",
  "material.student_visibility.release_for_students": "Für SuS freischalten",
  "material.preview.banner": "Vorschau · So sehen deine Schüler:innen das Material.",
  "material.preview.tooltip": "Vorschau aus Sicht deiner Schüler:innen",
  "material.schedule.individual_releases": "Individuelle Freigaben",
  "material.student_visibility.share_tooltip": "Material für Schüler:innen freigeben",
  "material.student_visibility.distribute_tooltip": "Zugang zum Material mit Schüler:innen teilen",
  "evaluation.overview.view_progress": "Lernfortschritt einsehen",
  "material.print_tooltip": "Material drucken",
  "material.student_deadline.editable_until": "Bearbeitbar bis {{date}}",
  "material.student_deadline.expired": "Bearbeitungsfrist abgelaufen: {{date}} · Nur lesbar",
  "material.student_visibility.saved_refresh_failed": "Die Änderungen wurden gespeichert. Die Kursansicht konnte nicht aktualisiert werden. Bitte lade die Seite neu.",
  "material.student_visibility.save_changes": "Änderungen speichern",
  "material.student_visibility.release_material": "Material für SuS freischalten",
  "material.student_deadline.access_check_failed": "Der Zugriff konnte nicht geprüft werden. Deine Eingaben bleiben erhalten. Bitte versuche es erneut.",
  "integration.authenticate.required_integration_title": "{{integration}} zuerst verbinden",
  "integration.authenticate.required_integration_description": "Verbinde zuerst {{requiredIntegration}} mit Deinem Teachino-Konto, bevor Du {{integration}} verbindest.",
  "integration.authenticate.required_integration_connect": "Mit {{integration}} anmelden",
  "integration.authenticate.required_integration_return": "Schließe die Anmeldung und Kontoverknüpfung im neuen Tab ab. Kehre dann hierher zurück und fahre fort. Falls sich kein Tab geöffnet hat, versuche die Anmeldung erneut.",
  "integration.authenticate.required_integration_continue": "Ich bin angemeldet – Weiter",
  "material.divider.label": "Abschnitt",
  "material.pages.position": "Seite {{current}} von {{total}}",
  "material.pages.progress": "Fortschritt im Material",
  "material.pages.navigation": "Materialseiten",
  "material.pages.end": "Du bist auf der letzten Seite.",
  "presentation.controls": "Präsentationssteuerung",
  "presentation.close": "Präsentation schließen",
  "presentation.lesson.overview": "Unterrichtsübersicht",
  "presentation.settings.label": "Einstellungen",
  "presentation.font.label": "Schriftgröße",
  "presentation.font.normal": "Normal",
  "presentation.font.large": "Groß",
  "presentation.font.largest": "Sehr groß",
  "presentation.laser": "Laserpointer",
  "presentation.dark_mode": "Dunkelmodus",
  "presentation.drawing.pen": "Stift",
  "presentation.drawing.highlighter": "Textmarker",
  "presentation.drawing.controls": "Zeichnungen",
  "presentation.drawing.undo": "Letzten Strich rückgängig machen",
  "presentation.drawing.clear": "Zeichnungen auf dieser Seite löschen",
  "presentation.drawing.surface": "Zeichenfläche",
  "presentation.tools.label": "Werkzeuge",
  "presentation.tools.clock": "Uhr",
  "presentation.tools.timer": "Timer",
  "presentation.tools.stopwatch": "Stoppuhr",
  "presentation.tools.sound": "Lautstärke",
  "presentation.tools.traffic": "Ampel",
  "presentation.tools.work": "Sozialform",
  "presentation.tools.move": "{{tool}} verschieben (ziehen oder Pfeiltasten verwenden)",
  "presentation.tools.remove": "Werkzeug entfernen",
  "presentation.tools.remaining": "Verbleibende Zeit",
  "presentation.tools.finished": "Die Zeit ist um",
  "presentation.tools.minutes": "Minuten",
  "presentation.tools.seconds": "Sekunden",
  "presentation.tools.pause": "Pause",
  "presentation.tools.start": "Start",
  "presentation.tools.reset": "Zurücksetzen",
  "presentation.tools.alarm": "Signalton am Ende",
  "presentation.tools.sound.loud": "Bitte etwas leiser",
  "presentation.tools.sound.ok": "Die Lautstärke passt",
  "presentation.tools.sound.requesting": "Erlaube den Mikrofonzugriff, um die Lautstärke zu messen.",
  "presentation.tools.sound.denied": "Der Mikrofonzugriff wurde verweigert. Erlaube ihn in den Browsereinstellungen und versuche es erneut.",
  "presentation.tools.sound.unavailable": "Kein Mikrofon verfügbar. Prüfe dein Gerät und versuche es erneut.",
  "presentation.tools.sound.paused": "Mikrofon pausiert",
  "presentation.tools.sound.sensitivity": "Mikrofonempfindlichkeit",
  "presentation.tools.sound.limit": "Maximale Lautstärke",
  "presentation.tools.sound.enable": "Mikrofon aktivieren",
  "presentation.tools.sound.local": "Messung auf diesem Gerät. Audio wird weder aufgenommen noch übertragen.",
  "presentation.tools.traffic.red": "Stopp",
  "presentation.tools.traffic.amber": "Bereit machen",
  "presentation.tools.traffic.green": "Los",
  "presentation.tools.work.silence": "Stille",
  "presentation.tools.work.whisper": "Flüstern",
  "presentation.tools.work.group": "Gruppenarbeit",
  "presentation.tools.work.partner": "Partner fragen",
  "presentation.drawing.color": "Stiftfarbe",
  "presentation.drawing.color.red": "Rot",
  "presentation.drawing.color.yellow": "Gelb",
  "presentation.drawing.color.green": "Grün",
  "presentation.drawing.color.blue": "Blau",
  "presentation.drawing.color.purple": "Violett",
  "presentation.drawing.color.black": "Schwarz",
  "presentation.drawing.color.white": "Weiß",
  "presentation.drawing.width": "Strichstärke",
  "presentation.drawing.width.thin": "Dünn",
  "presentation.drawing.width.medium": "Mittel",
  "presentation.drawing.width.thick": "Dick",
  "presentation.break.start": "Material ausblenden",
  "presentation.break.resume": "Material wieder anzeigen",
  "presentation.pointer.label": "Mauszeiger",
  "presentation.pointer.normal": "Normaler Mauszeiger",
  "presentation.pointer.laser": "Laserpointer",
  "presentation.pointer.spotlight": "Spotlight",
  "presentation.spotlight.circleSmall": "Kreis (klein)",
  "presentation.spotlight.content": "Scan",
  "presentation.spotlight.circleLarge": "Kreis (groß)",
  "presentation.scan.move": "Scan verschieben (ziehen oder Pfeiltasten verwenden)",
  "presentation.scan.resize": "Scan-Höhe ändern (ziehen oder Pfeiltasten verwenden)",
  "presentation.scan.close": "Scan schließen",
  "presentation.attention.label": "Aufmerksamkeitssignal",
  "presentation.attention.title": "Kurz zuhören, bitte",
  "presentation.attention.instruction": "Unterbrich, was du gerade machst. Höre der Lehrperson zu.",
  "presentation.sharing.open": "QR-Code für Schülerinnen und Schüler",
  "presentation.sharing.close": "Zurück zur Präsentation",
  "presentation.sharing.choose_course": "Für welchen Kurs?",
  "presentation.sharing.no_course": "Füge dieses Material zuerst einem Kurs hinzu, um es mit Schülerinnen und Schülern zu teilen.",
  "presentation.sharing.edit": "Freigabe ändern",
  "presentation.sharing.release": "Material für SuS freigeben",
  "presentation.sharing.retry": "Erneut versuchen",
  "presentation.attention.ring": "Glocke läuten",
  "presentation.promotion.hint": "Der neue Präsentationsmodus ist da.",
  "presentation.promotion.try": "Ausprobieren",
  "presentation.promotion.dismiss": "Hinweis schließen",
  "material.student_display.title": "Darstellung für Schüler:innen",
  "material.student_display.info": "Darstellungsarten erklären",
  "material.student_display.scroll": "Scrollen",
  "material.student_display.sections": "Abschnitte",
  "material.student_display.intro": "So können Schüler:innen durch das Material navigieren.",
  "material.student_display.scroll_description": "Das gesamte Material wird auf einer Seite angezeigt. Schüler:innen scrollen von oben nach unten.",
  "material.student_display.sections_description": "Schüler:innen sehen jeweils einen Abschnitt und wechseln mit Weiter und Zurück von Seite zu Seite.",
  "material.student_display.section_title": "Was ist ein Abschnitt?",
  "material.student_display.section_description": "Abschnitte können über das + im Material hinzugefügt werden. Interaktive Aufgaben sind immer ein eigener Abschnitt.",
  "material.student_display.image": "Bild",
  "material.student_display.assignment": "Interaktive Aufgabe",
  "material.student_display.manual_section": "Manuell angelegter Abschnitt",
  "material.student_display.scroll_hint": "Alles auf einer Seite · nach unten scrollen",
  "material.student_display.section_position": "Abschnitt {{current}} von {{total}}",
  "material.student_summary.title": "Dein Fortschritt",
  "material.student_summary.success_title": "Du hast es geschafft!",
  "material.student_summary.success_description": "Du hast alle Aufgaben richtig gelöst. Gut gemacht!",
  "material.student_summary.review_title": "Schau, wie weit du gekommen bist",
  "material.student_summary.review_description": "Hier siehst du deine Ergebnisse. Springe zu einer Aufgabe zurück, um sie fertigzustellen oder erneut zu versuchen.",
  "material.student_summary.no_activities": "Du hast das Ende dieses Materials erreicht. Nimm dir einen Moment Zeit und überlege, was du gelernt hast.",
  "material.student_summary.correct": "Richtig",
  "material.student_summary.remaining": "Noch nicht als richtig bewertet",
  "material.student_summary.progress": "{{correct}} von {{total}} Aufgaben richtig",
  "material.student_summary.activity": "Aufgabe {{number}}",
  "material.student_summary.section": "Zu Abschnitt {{number}}"
}
